// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { AcceptAllData, AcceptAllErrors, AcceptAllResponses, AcceptProposalData, AcceptProposalErrors, AcceptProposalResponses, AddAgentPinData, AddAgentPinErrors, AddAgentPinResponses, AddAgentTeamMemberData, AddAgentTeamMemberErrors, AddAgentTeamMemberResponses, AddAgentUserMemberData, AddAgentUserMemberErrors, AddAgentUserMemberResponses, AddBrandTeamMemberData, AddBrandTeamMemberErrors, AddBrandTeamMemberResponses, AddBrandUserMemberData, AddBrandUserMemberErrors, AddBrandUserMemberResponses, AddConnectorTeamMemberData, AddConnectorTeamMemberErrors, AddConnectorTeamMemberResponses, AddConnectorUserMemberData, AddConnectorUserMemberErrors, AddConnectorUserMemberResponses, AddDataSourceTeamMemberData, AddDataSourceTeamMemberErrors, AddDataSourceTeamMemberResponses, AddDataSourceUserMemberData, AddDataSourceUserMemberErrors, AddDataSourceUserMemberResponses, AddFlowTeamMemberData, AddFlowTeamMemberErrors, AddFlowTeamMemberResponses, AddFlowUserMemberData, AddFlowUserMemberErrors, AddFlowUserMemberResponses, AddMicroAppTeamMemberData, AddMicroAppTeamMemberErrors, AddMicroAppTeamMemberResponses, AddMicroAppUserMemberData, AddMicroAppUserMemberErrors, AddMicroAppUserMemberResponses, AddNoteData, AddNoteErrors, AddNoteResponses, AddPinData, AddPinErrors, AddPinResponses, AddSkillTeamMemberData, AddSkillTeamMemberErrors, AddSkillTeamMemberResponses, AddSkillUserMemberData, AddSkillUserMemberErrors, AddSkillUserMemberResponses, AddSpaceConnectorData, AddSpaceConnectorErrors, AddSpaceConnectorResponses, AddSpaceResourceData, AddSpaceResourceErrors, AddSpaceResourceResponses, AddSpaceTeamMemberData, AddSpaceTeamMemberErrors, AddSpaceTeamMemberResponses, AddSpaceUserMemberData, AddSpaceUserMemberErrors, AddSpaceUserMemberResponses, AddWebsiteUrlData, AddWebsiteUrlErrors, AddWebsiteUrlResponses, AdminConnectorAuditData, AdminConnectorAuditErrors, AdminConnectorAuditResponses, AdminCreateModelData, AdminCreateModelErrors, AdminCreateModelResponses, AdminCreateUserData, AdminCreateUserErrors, AdminCreateUserResponses, AdminDeleteModelData, AdminDeleteModelErrors, AdminDeleteModelResponses, AdminDeleteUserData, AdminDeleteUserErrors, AdminDeleteUserResponses, AdminDisableConnectorData, AdminDisableConnectorErrors, AdminDisableConnectorResponses, AdminEnableConnectorData, AdminEnableConnectorErrors, AdminEnableConnectorResponses, AdminGetConnectorPolicyData, AdminGetConnectorPolicyResponses, AdminGetModelData, AdminGetModelErrors, AdminGetModelResponses, AdminGetUsageData, AdminGetUsageErrors, AdminGetUsageResponses, AdminListConnectorsData, AdminListConnectorsResponses, AdminListModelReferencesData, AdminListModelReferencesErrors, AdminListModelReferencesResponses, AdminListModelsData, AdminListModelsErrors, AdminListModelsResponses, AdminListTierDefaultsData, AdminListTierDefaultsResponses, AdminListUsersData, AdminListUsersErrors, AdminListUsersResponses, AdminReassignModelData, AdminReassignModelErrors, AdminReassignModelResponses, AdminSuggestModelData, AdminSuggestModelErrors, AdminSuggestModelResponses, AdminUpdateConnectorPolicyData, AdminUpdateConnectorPolicyErrors, AdminUpdateConnectorPolicyResponses, AdminUpdateModelData, AdminUpdateModelErrors, AdminUpdateModelResponses, AdminUpdateTierDefaultData, AdminUpdateTierDefaultErrors, AdminUpdateTierDefaultResponses, AdminUpdateUserData, AdminUpdateUserErrors, AdminUpdateUserResponses, AgentDeleteImpactData, AgentDeleteImpactErrors, AgentDeleteImpactResponses, AnalyzeImportData, AnalyzeImportErrors, AnalyzeImportResponses, AttachmentStatusData, AttachmentStatusResponses, AttachSkillsToAgentData, AttachSkillsToAgentErrors, AttachSkillsToAgentResponses, AuthorizeData, AuthorizeErrors, AuthorizeFlowData, AuthorizeFlowErrors, AuthorizeFlowResponses, AuthorizeResponses, CancelFlowRunData, CancelFlowRunErrors, CancelFlowRunResponses, CancelOperationData, CancelOperationErrors, CancelOperationResponses, ChatAccessShareLinkData, ChatAccessShareLinkErrors, ChatAccessShareLinkResponses, ChatCreateSessionData, ChatCreateSessionErrors, ChatCreateSessionResponses, ChatCreateShareLinkData, ChatCreateShareLinkErrors, ChatCreateShareLinkResponses, ChatDeactivateShareLinkData, ChatDeactivateShareLinkErrors, ChatDeactivateShareLinkResponses, ChatDeleteSessionData, ChatDeleteSessionErrors, ChatDeleteSessionResponses, ChatGetSessionData, ChatGetSessionErrors, ChatGetSessionResponses, ChatGetSessionSharingData, ChatGetSessionSharingErrors, ChatGetSessionSharingResponses, ChatListSessionsData, ChatListSessionsErrors, ChatListSessionsResponses, ChatListSharedWithMeData, ChatListSharedWithMeResponses, ChatRemoveShareData, ChatRemoveShareErrors, ChatRemoveShareResponses, ChatShareWithUserData, ChatShareWithUserErrors, ChatShareWithUserResponses, ChatStreamMessageData, ChatStreamMessageErrors, ChatStreamMessageResponses, ChatUpdateSessionData, ChatUpdateSessionErrors, ChatUpdateSessionResponses, ChatUploadAttachmentsData, ChatUploadAttachmentsErrors, ChatUploadAttachmentsResponses, ClearAgentMemoryData, ClearAgentMemoryErrors, ClearAgentMemoryResponses, ClearAllAgentMemoryData, ClearAllAgentMemoryResponses, ClearConnectorSecretData, ClearConnectorSecretErrors, ClearConnectorSecretResponses, ClearCredentialData, ClearCredentialErrors, ClearCredentialResponses, ClearExtensionPreferenceData, ClearExtensionPreferenceErrors, ClearExtensionPreferenceResponses, ClearMyConnectorCredentialData, ClearMyConnectorCredentialErrors, ClearMyConnectorCredentialResponses, CorrelateContentFilterEventData, CorrelateContentFilterEventErrors, CorrelateContentFilterEventResponses, CreateAgentData, CreateAgentErrors, CreateAgentResponses, CreateApiKeyData, CreateApiKeyErrors, CreateApiKeyResponses, CreateBrandData, CreateBrandErrors, CreateBrandResponses, CreateBudgetConfigData, CreateBudgetConfigErrors, CreateBudgetConfigResponses, CreateConnectorData, CreateConnectorErrors, CreateConnectorFromTemplateData, CreateConnectorFromTemplateErrors, CreateConnectorFromTemplateResponses, CreateConnectorInstanceData, CreateConnectorInstanceErrors, CreateConnectorInstanceResponses, CreateConnectorResponses, CreateDataSourceData, CreateDataSourceErrors, CreateDataSourceResponses, CreateFlowData, CreateFlowErrors, CreateFlowResponses, CreateFlowTriggerData, CreateFlowTriggerErrors, CreateFlowTriggerResponses, CreateImportData, CreateImportErrors, CreateImportResponses, CreateSidebarSectionData, CreateSidebarSectionErrors, CreateSidebarSectionResponses, CreateSkillData, CreateSkillErrors, CreateSkillResponses, CreateSpaceData, CreateSpaceErrors, CreateSpaceResponses, DeleteAgentData, DeleteAgentErrors, DeleteAgentMemoryData, DeleteAgentMemoryErrors, DeleteAgentMemoryResponses, DeleteAgentResponses, DeleteBrandData, DeleteBrandErrors, DeleteBrandResponses, DeleteBrandTemplateData, DeleteBrandTemplateErrors, DeleteBrandTemplateResponses, DeleteBudgetConfigData, DeleteBudgetConfigErrors, DeleteBudgetConfigResponses, DeleteConnectorData, DeleteConnectorErrors, DeleteConnectorResponses, DeleteDataSourceData, DeleteDataSourceErrors, DeleteDataSourceResponses, DeleteFileData, DeleteFileErrors, DeleteFileResponses, DeleteFlowData, DeleteFlowErrors, DeleteFlowResponses, DeleteFlowTriggerData, DeleteFlowTriggerErrors, DeleteFlowTriggerResponses, DeleteImportData, DeleteImportErrors, DeleteImportResponses, DeleteMicroAppData, DeleteMicroAppErrors, DeleteMicroAppResponses, DeleteSidebarSectionData, DeleteSidebarSectionErrors, DeleteSidebarSectionResponses, DeleteSkillData, DeleteSkillErrors, DeleteSkillResponses, DeleteSpaceData, DeleteSpaceErrors, DeleteSpaceFileData, DeleteSpaceFileErrors, DeleteSpaceFileResponses, DeleteSpaceResponses, DeleteWikiFileData, DeleteWikiFileErrors, DeleteWikiFileResponses, DetachSkillFromAgentData, DetachSkillFromAgentErrors, DetachSkillFromAgentResponses, DisconnectData, DisconnectErrors, DisconnectResponses, DismissAllData, DismissAllErrors, DismissAllResponses, DismissDuplicateData, DismissDuplicateErrors, DismissDuplicateResponses, DownloadBrandTemplateData, DownloadBrandTemplateErrors, DownloadBrandTemplateResponses, DownloadScreenshotData, DownloadScreenshotErrors, DownloadScreenshotResponses, EditWithAiData, EditWithAiErrors, EditWithAiResponses, ExtractBrandData, ExtractBrandErrors, ExtractBrandResponses, ForkSessionData, ForkSessionErrors, ForkSessionResponses, GetAgentData, GetAgentErrors, GetAgentMembersData, GetAgentMembersErrors, GetAgentMembersResponses, GetAgentResponses, GetAttachmentBindingsData, GetAttachmentBindingsErrors, GetAttachmentBindingsResponses, GetAttachmentLimitsData, GetAttachmentLimitsResponses, GetBrandData, GetBrandErrors, GetBrandMembersData, GetBrandMembersErrors, GetBrandMembersResponses, GetBrandResponses, GetBrandTemplateThumbnailData, GetBrandTemplateThumbnailErrors, GetBrandTemplateThumbnailResponses, GetCompanyProfileData, GetCompanyProfileResponses, GetConnectorDetailData, GetConnectorDetailErrors, GetConnectorDetailResponses, GetConnectorMembersData, GetConnectorMembersErrors, GetConnectorMembersResponses, GetConnectorPolicyData, GetConnectorPolicyResponses, GetContentFilterAnalyticsData, GetContentFilterAnalyticsErrors, GetContentFilterAnalyticsResponses, GetCurrentUserInfoData, GetCurrentUserInfoResponses, GetDataSourceData, GetDataSourceErrors, GetDataSourceMembersData, GetDataSourceMembersErrors, GetDataSourceMembersResponses, GetDataSourceResponses, GetExportCapabilitiesData, GetExportCapabilitiesResponses, GetExtensionData, GetExtensionErrors, GetExtensionResponses, GetFeedbackData, GetFeedbackErrors, GetFeedbackResponses, GetFileDownloadUrlData, GetFileDownloadUrlErrors, GetFileDownloadUrlResponses, GetFileMarkdownData, GetFileMarkdownErrors, GetFileMarkdownResponses, GetFlowAuthorizationData, GetFlowAuthorizationErrors, GetFlowAuthorizationResponses, GetFlowData, GetFlowErrors, GetFlowMembersData, GetFlowMembersErrors, GetFlowMembersResponses, GetFlowResponses, GetFlowRunData, GetFlowRunErrors, GetFlowRunResponses, GetGovernanceOverviewData, GetGovernanceOverviewResponses, GetImportData, GetImportErrors, GetImportResponses, GetLicenseDetailData, GetLicenseDetailResponses, GetLicenseStatusData, GetLicenseStatusResponses, GetLogoData, GetLogoResponses, GetMicroAppContentData, GetMicroAppContentErrors, GetMicroAppContentResponses, GetMicroAppData, GetMicroAppErrors, GetMicroAppInfoData, GetMicroAppInfoErrors, GetMicroAppInfoResponses, GetMicroAppMembersData, GetMicroAppMembersErrors, GetMicroAppMembersResponses, GetMicroAppResponses, GetMyOnedriveData, GetMyOnedriveResponses, GetMySpendData, GetMySpendErrors, GetMySpendResponses, GetPersonalSpaceData, GetPersonalSpaceResponses, GetPlatformCostsData, GetPlatformCostsErrors, GetPlatformCostsResponses, GetPreferencesData, GetPreferencesResponses, GetSkillData, GetSkillErrors, GetSkillMembersData, GetSkillMembersErrors, GetSkillMembersResponses, GetSkillResponses, GetSpaceData, GetSpaceErrors, GetSpaceHubData, GetSpaceHubErrors, GetSpaceHubResponses, GetSpaceMembersData, GetSpaceMembersErrors, GetSpaceMembersResponses, GetSpaceResponses, GetSpaceSidebarData, GetSpaceSidebarResponses, GetUnreadCountData, GetUnreadCountResponses, GetUsageByUserData, GetUsageByUserErrors, GetUsageByUserResponses, GetWikiFileData, GetWikiFileErrors, GetWikiFileResponses, GiveSpaceAccessData, GiveSpaceAccessErrors, GiveSpaceAccessResponses, GoogleDriveDownloadDocumentData, GoogleDriveDownloadDocumentErrors, GoogleDriveDownloadDocumentResponses, ImportSkillsData, ImportSkillsErrors, ImportSkillsResponses, ListActiveOperationsData, ListActiveOperationsResponses, ListAgentConnectorsData, ListAgentConnectorsErrors, ListAgentConnectorsResponses, ListAgentMemoriesData, ListAgentMemoriesResponses, ListAgentPinsData, ListAgentPinsResponses, ListAgentsData, ListAgentsErrors, ListAgentSkillsData, ListAgentSkillsErrors, ListAgentSkillsResponses, ListAgentsResponses, ListAllAuthorizationsData, ListAllAuthorizationsResponses, ListAllFeedbackData, ListAllFeedbackErrors, ListAllFeedbackResponses, ListApiKeysData, ListApiKeysResponses, ListAvailableData, ListAvailableResponses, ListBrandsData, ListBrandsErrors, ListBrandsResponses, ListBrandTemplatesData, ListBrandTemplatesErrors, ListBrandTemplatesResponses, ListBudgetConfigsData, ListBudgetConfigsResponses, ListConnectorIntegrationsData, ListConnectorIntegrationsResponses, ListConnectorsData, ListConnectorsErrors, ListConnectorsResponses, ListConnectorTemplatesData, ListConnectorTemplatesResponses, ListConnectorToolsData, ListConnectorToolsErrors, ListConnectorToolsResponses, ListContentFilterEventsData, ListContentFilterEventsErrors, ListContentFilterEventsResponses, ListDataSourcesData, ListDataSourcesErrors, ListDataSourcesResponses, ListDriveItemsData, ListDriveItemsErrors, ListDriveItemsResponses, ListDuplicatesData, ListDuplicatesErrors, ListDuplicatesResponses, ListExtensionConsentData, ListExtensionConsentResponses, ListExtensionsData, ListExtensionsResponses, ListFilesData, ListFilesErrors, ListFilesResponses, ListFlowRunsData, ListFlowRunsErrors, ListFlowRunsResponses, ListFlowsData, ListFlowsErrors, ListFlowsResponses, ListFlowTriggersData, ListFlowTriggersErrors, ListFlowTriggersResponses, ListImportsData, ListImportsErrors, ListImportsResponses, ListInboxData, ListInboxResponses, ListMergesData, ListMergesErrors, ListMergesResponses, ListMessageAttachmentsData, ListMessageAttachmentsErrors, ListMessageAttachmentsResponses, ListMessagesData, ListMessagesErrors, ListMessagesResponses, ListMicroAppsData, ListMicroAppsErrors, ListMicroAppsResponses, ListMyAuthorizationsData, ListMyAuthorizationsResponses, ListMyConnectorConnectionsData, ListMyConnectorConnectionsResponses, ListMyJobsData, ListMyJobsErrors, ListMyJobsResponses, ListNotificationsData, ListNotificationsErrors, ListNotificationsResponses, ListPinsData, ListPinsResponses, ListQuickActionsData, ListQuickActionsErrors, ListQuickActionsResponses, ListRecentActivitiesData, ListRecentActivitiesErrors, ListRecentActivitiesResponses, ListSessionDocumentsData, ListSessionDocumentsErrors, ListSessionDocumentsResponses, ListSiteDrivesData, ListSiteDrivesErrors, ListSiteDrivesResponses, ListSkillCategoriesData, ListSkillCategoriesResponses, ListSkillsData, ListSkillsErrors, ListSkillsResponses, ListSpaceActivitiesData, ListSpaceActivitiesErrors, ListSpaceActivitiesResponses, ListSpaceConnectorsData, ListSpaceConnectorsErrors, ListSpaceConnectorsResponses, ListSpaceDocumentsData, ListSpaceDocumentsErrors, ListSpaceDocumentsResponses, ListSpaceKnowledgeData, ListSpaceKnowledgeErrors, ListSpaceKnowledgeResponses, ListSpaceResourcesData, ListSpaceResourcesErrors, ListSpaceResourcesResponses, ListSpacesData, ListSpacesErrors, ListSpaceSharedChatsData, ListSpaceSharedChatsErrors, ListSpaceSharedChatsResponses, ListSpacesResponses, ListTeamsData, ListTeamsErrors, ListTeamsResponses, ListToolsData, ListToolsErrors, ListToolsResponses, ListUserFacingTierDefaultsData, ListUserFacingTierDefaultsResponses, ListWikiFilesData, ListWikiFilesErrors, ListWikiFilesResponses, ListWorkersData, ListWorkersResponses, MarkAllReadData, MarkAllReadResponses, MarkDraftAppliedData, MarkDraftAppliedErrors, MarkDraftAppliedResponses, MarkNotificationReadData, MarkNotificationReadErrors, MarkNotificationReadResponses, MergePagesData, MergePagesErrors, MergePagesResponses, ModelsListModelsData, ModelsListModelsErrors, ModelsListModelsResponses, MoveSidebarSpaceData, MoveSidebarSpaceErrors, MoveSidebarSpaceResponses, PlatformCreateOauthClientData, PlatformCreateOauthClientErrors, PlatformCreateOauthClientResponses, PlatformDeleteOauthClientData, PlatformDeleteOauthClientErrors, PlatformDeleteOauthClientResponses, PlatformListOauthClientsData, PlatformListOauthClientsResponses, PlatformUpdateOauthClientData, PlatformUpdateOauthClientErrors, PlatformUpdateOauthClientResponses, PreviewCompanyContextData, PreviewCompanyContextResponses, PreviewMergeData, PreviewMergeErrors, PreviewMergeResponses, PublishMicroAppData, PublishMicroAppErrors, PublishMicroAppResponses, RefreshConnectorToolsData, RefreshConnectorToolsErrors, RefreshConnectorToolsResponses, RegenerateWebhookSecretData, RegenerateWebhookSecretErrors, RegenerateWebhookSecretResponses, RejectProposalData, RejectProposalErrors, RejectProposalResponses, RemoveAgentPinData, RemoveAgentPinErrors, RemoveAgentPinResponses, RemoveAgentTeamMemberData, RemoveAgentTeamMemberErrors, RemoveAgentTeamMemberResponses, RemoveAgentUserMemberData, RemoveAgentUserMemberErrors, RemoveAgentUserMemberResponses, RemoveBrandTeamMemberData, RemoveBrandTeamMemberErrors, RemoveBrandTeamMemberResponses, RemoveBrandUserMemberData, RemoveBrandUserMemberErrors, RemoveBrandUserMemberResponses, RemoveConnectorTeamMemberData, RemoveConnectorTeamMemberErrors, RemoveConnectorTeamMemberResponses, RemoveConnectorUserMemberData, RemoveConnectorUserMemberErrors, RemoveConnectorUserMemberResponses, RemoveDataSourceTeamMemberData, RemoveDataSourceTeamMemberErrors, RemoveDataSourceTeamMemberResponses, RemoveDataSourceUserMemberData, RemoveDataSourceUserMemberErrors, RemoveDataSourceUserMemberResponses, RemoveFlowTeamMemberData, RemoveFlowTeamMemberErrors, RemoveFlowTeamMemberResponses, RemoveFlowUserMemberData, RemoveFlowUserMemberErrors, RemoveFlowUserMemberResponses, RemoveMicroAppTeamMemberData, RemoveMicroAppTeamMemberErrors, RemoveMicroAppTeamMemberResponses, RemoveMicroAppUserMemberData, RemoveMicroAppUserMemberErrors, RemoveMicroAppUserMemberResponses, RemovePinData, RemovePinErrors, RemovePinResponses, RemoveSkillTeamMemberData, RemoveSkillTeamMemberErrors, RemoveSkillTeamMemberResponses, RemoveSkillUserMemberData, RemoveSkillUserMemberErrors, RemoveSkillUserMemberResponses, RemoveSpaceAccessData, RemoveSpaceAccessErrors, RemoveSpaceAccessResponses, RemoveSpaceConnectorData, RemoveSpaceConnectorErrors, RemoveSpaceConnectorResponses, RemoveSpaceDocumentData, RemoveSpaceDocumentErrors, RemoveSpaceDocumentResponses, RemoveSpaceResourceData, RemoveSpaceResourceErrors, RemoveSpaceResourceResponses, RemoveSpaceTeamMemberData, RemoveSpaceTeamMemberErrors, RemoveSpaceTeamMemberResponses, RemoveSpaceUserMemberData, RemoveSpaceUserMemberErrors, RemoveSpaceUserMemberResponses, ReorderPinsData, ReorderPinsErrors, ReorderPinsResponses, ReorderSidebarSectionsData, ReorderSidebarSectionsErrors, ReorderSidebarSectionsResponses, ReorderSpaceResourcesData, ReorderSpaceResourcesErrors, ReorderSpaceResourcesResponses, RepublishMicroAppData, RepublishMicroAppErrors, RepublishMicroAppResponses, ResolveSharepointUrlData, ResolveSharepointUrlErrors, ResolveSharepointUrlResponses, ResumeFlowRunData, ResumeFlowRunErrors, ResumeFlowRunResponses, ResumePlatformData, ResumePlatformErrors, ResumePlatformResponses, RevokeApiKeyData, RevokeApiKeyErrors, RevokeApiKeyResponses, RevokeMyAuthorizationData, RevokeMyAuthorizationErrors, RevokeMyAuthorizationResponses, SaveWikiFileData, SaveWikiFileErrors, SaveWikiFileResponses, SearchDriveItemsData, SearchDriveItemsErrors, SearchDriveItemsResponses, SearchFilesData, SearchFilesErrors, SearchFilesResponses, SearchSitesData, SearchSitesErrors, SearchSitesResponses, SearchUsersData, SearchUsersErrors, SearchUsersResponses, SetAgentConnectorsData, SetAgentConnectorsErrors, SetAgentConnectorsResponses, SetConnectorSecretData, SetConnectorSecretErrors, SetConnectorSecretResponses, SetExtensionPreferenceData, SetExtensionPreferenceErrors, SetExtensionPreferenceResponses, SetMyConnectorCredentialData, SetMyConnectorCredentialErrors, SetMyConnectorCredentialResponses, SetSessionSpaceShareData, SetSessionSpaceShareErrors, SetSessionSpaceShareResponses, SetSpaceConnectorSkillsData, SetSpaceConnectorSkillsErrors, SetSpaceConnectorSkillsResponses, SharepointCountFolderItemsData, SharepointCountFolderItemsErrors, SharepointCountFolderItemsResponses, SharepointDownloadDocumentData, SharepointDownloadDocumentErrors, SharepointDownloadDocumentResponses, ShareSpaceDocumentData, ShareSpaceDocumentErrors, ShareSpaceDocumentResponses, SkillDeleteImpactData, SkillDeleteImpactErrors, SkillDeleteImpactResponses, SpaceAccessImpactData, SpaceAccessImpactErrors, SpaceAccessImpactResponses, SpacesCreateQuickActionData, SpacesCreateQuickActionErrors, SpacesCreateQuickActionResponses, SpacesDeleteQuickActionData, SpacesDeleteQuickActionErrors, SpacesDeleteQuickActionResponses, SpacesUpdateQuickActionData, SpacesUpdateQuickActionErrors, SpacesUpdateQuickActionResponses, StartConnectorOauthData, StartConnectorOauthErrors, StartConnectorOauthResponses, StreamAgentData, StreamAgentErrors, StreamAgentResponses, StreamFlowRunData, StreamFlowRunErrors, StreamFlowRunResponses, SubmitFeedbackData, SubmitFeedbackErrors, SubmitFeedbackResponses, SuspendPlatformData, SuspendPlatformErrors, SuspendPlatformResponses, SyncDataSourceData, SyncDataSourceErrors, SyncDataSourceResponses, ToggleExtensionData, ToggleExtensionErrors, ToggleExtensionResponses, UndoMergeData, UndoMergeErrors, UndoMergeResponses, UpdateAgentData, UpdateAgentErrors, UpdateAgentResponses, UpdateAgentSkillData, UpdateAgentSkillErrors, UpdateAgentSkillResponses, UpdateAgentTeamMemberData, UpdateAgentTeamMemberErrors, UpdateAgentTeamMemberResponses, UpdateAgentUserMemberData, UpdateAgentUserMemberErrors, UpdateAgentUserMemberResponses, UpdateBrandData, UpdateBrandErrors, UpdateBrandResponses, UpdateBrandTeamMemberData, UpdateBrandTeamMemberErrors, UpdateBrandTeamMemberResponses, UpdateBrandUserMemberData, UpdateBrandUserMemberErrors, UpdateBrandUserMemberResponses, UpdateBudgetConfigData, UpdateBudgetConfigErrors, UpdateBudgetConfigResponses, UpdateConnectorData, UpdateConnectorErrors, UpdateConnectorResponses, UpdateConnectorTeamMemberData, UpdateConnectorTeamMemberErrors, UpdateConnectorTeamMemberResponses, UpdateConnectorToolData, UpdateConnectorToolErrors, UpdateConnectorToolResponses, UpdateConnectorUserMemberData, UpdateConnectorUserMemberErrors, UpdateConnectorUserMemberResponses, UpdateCredentialData, UpdateCredentialErrors, UpdateCredentialResponses, UpdateDataSourceData, UpdateDataSourceErrors, UpdateDataSourceResponses, UpdateDataSourceTeamMemberData, UpdateDataSourceTeamMemberErrors, UpdateDataSourceTeamMemberResponses, UpdateDataSourceUserMemberData, UpdateDataSourceUserMemberErrors, UpdateDataSourceUserMemberResponses, UpdateExtensionData, UpdateExtensionErrors, UpdateExtensionResponses, UpdateFeedbackStatusData, UpdateFeedbackStatusErrors, UpdateFeedbackStatusResponses, UpdateFlowData, UpdateFlowErrors, UpdateFlowResponses, UpdateFlowTeamMemberData, UpdateFlowTeamMemberErrors, UpdateFlowTeamMemberResponses, UpdateFlowTriggerData, UpdateFlowTriggerErrors, UpdateFlowTriggerResponses, UpdateFlowUserMemberData, UpdateFlowUserMemberErrors, UpdateFlowUserMemberResponses, UpdateLicenseData, UpdateLicenseErrors, UpdateLicenseResponses, UpdateMicroAppData, UpdateMicroAppErrors, UpdateMicroAppResponses, UpdateMicroAppTeamMemberData, UpdateMicroAppTeamMemberErrors, UpdateMicroAppTeamMemberResponses, UpdateMicroAppUserMemberData, UpdateMicroAppUserMemberErrors, UpdateMicroAppUserMemberResponses, UpdateNoteData, UpdateNoteErrors, UpdateNoteResponses, UpdatePreferencesData, UpdatePreferencesErrors, UpdatePreferencesResponses, UpdateSidebarSectionData, UpdateSidebarSectionErrors, UpdateSidebarSectionResponses, UpdateSkillData, UpdateSkillErrors, UpdateSkillResponses, UpdateSkillTeamMemberData, UpdateSkillTeamMemberErrors, UpdateSkillTeamMemberResponses, UpdateSkillUserMemberData, UpdateSkillUserMemberErrors, UpdateSkillUserMemberResponses, UpdateSpaceConnectorData, UpdateSpaceConnectorErrors, UpdateSpaceConnectorResponses, UpdateSpaceData, UpdateSpaceErrors, UpdateSpaceResourceData, UpdateSpaceResourceErrors, UpdateSpaceResourceResponses, UpdateSpaceResponses, UpdateSpaceTeamMemberData, UpdateSpaceTeamMemberErrors, UpdateSpaceTeamMemberResponses, UpdateSpaceUserMemberData, UpdateSpaceUserMemberErrors, UpdateSpaceUserMemberResponses, UpdateTeamAccessData, UpdateTeamAccessErrors, UpdateTeamAccessResponses, UpdateUserSettingsData, UpdateUserSettingsErrors, UpdateUserSettingsResponses, UploadBrandLogoData, UploadBrandLogoErrors, UploadBrandLogoResponses, UploadBrandTemplateData, UploadBrandTemplateErrors, UploadBrandTemplateResponses, UploadFilesData, UploadFilesErrors, UploadFilesResponses, UploadFlowFilesData, UploadFlowFilesErrors, UploadFlowFilesResponses, UploadImportData, UploadImportErrors, UploadImportResponses, UploadLogoData, UploadLogoErrors, UploadLogoResponses, UploadSpaceFilesData, UploadSpaceFilesErrors, UploadSpaceFilesResponses, UpsertCompanyProfileData, UpsertCompanyProfileErrors, UpsertCompanyProfileResponses } from './types.gen';
import { zAcceptAllResponse, zAcceptProposalResponse, zAddAgentPinResponse, zAddAgentTeamMemberResponse, zAddAgentUserMemberResponse, zAddBrandTeamMemberResponse, zAddBrandUserMemberResponse, zAddConnectorTeamMemberResponse, zAddConnectorUserMemberResponse, zAddDataSourceTeamMemberResponse, zAddDataSourceUserMemberResponse, zAddFlowTeamMemberResponse, zAddFlowUserMemberResponse, zAddMicroAppTeamMemberResponse, zAddMicroAppUserMemberResponse, zAddNoteResponse, zAddPinResponse, zAddSkillTeamMemberResponse, zAddSkillUserMemberResponse, zAddSpaceConnectorResponse, zAddSpaceResourceResponse, zAddSpaceTeamMemberResponse, zAddSpaceUserMemberResponse, zAddWebsiteUrlResponse, zAdminConnectorAuditResponse, zAdminCreateModelResponse, zAdminCreateUserResponse, zAdminDeleteModelResponse, zAdminDeleteUserResponse, zAdminDisableConnectorResponse, zAdminEnableConnectorResponse, zAdminGetConnectorPolicyResponse, zAdminGetModelResponse, zAdminGetUsageResponse, zAdminListConnectorsResponse, zAdminListModelReferencesResponse, zAdminListModelsResponse, zAdminListTierDefaultsResponse, zAdminListUsersResponse, zAdminReassignModelResponse, zAdminSuggestModelResponse, zAdminUpdateConnectorPolicyResponse, zAdminUpdateModelResponse, zAdminUpdateTierDefaultResponse, zAdminUpdateUserResponse, zAgentDeleteImpactResponse2, zAnalyzeImportResponse, zAttachmentStatusResponse2, zAttachSkillsToAgentResponse, zAuthorizeFlowResponse, zAuthorizeResponse2, zCancelFlowRunResponse, zCancelOperationResponse, zChatAccessShareLinkResponse, zChatCreateSessionResponse, zChatCreateShareLinkResponse, zChatDeactivateShareLinkResponse, zChatDeleteSessionResponse, zChatGetSessionResponse, zChatGetSessionSharingResponse, zChatListSessionsResponse, zChatListSharedWithMeResponse, zChatRemoveShareResponse, zChatShareWithUserResponse, zChatStreamMessageResponse, zChatUpdateSessionResponse, zChatUploadAttachmentsResponse, zClearAgentMemoryResponse, zClearAllAgentMemoryResponse, zClearConnectorSecretResponse, zClearCredentialResponse, zClearExtensionPreferenceResponse, zClearMyConnectorCredentialResponse, zCorrelateContentFilterEventResponse, zCreateAgentResponse, zCreateApiKeyResponse, zCreateBrandResponse, zCreateBudgetConfigResponse, zCreateConnectorFromTemplateResponse, zCreateConnectorInstanceResponse, zCreateConnectorResponse, zCreateDataSourceResponse, zCreateFlowResponse, zCreateImportResponse, zCreateSidebarSectionResponse, zCreateSkillResponse, zCreateSpaceResponse, zDeleteAgentMemoryResponse, zDeleteAgentResponse, zDeleteBrandResponse, zDeleteBrandTemplateResponse, zDeleteBudgetConfigResponse, zDeleteConnectorResponse, zDeleteDataSourceResponse, zDeleteFileResponse, zDeleteFlowResponse, zDeleteFlowTriggerResponse, zDeleteImportResponse, zDeleteMicroAppResponse, zDeleteSidebarSectionResponse, zDeleteSkillResponse, zDeleteSpaceFileResponse, zDeleteSpaceResponse, zDeleteWikiFileResponse, zDetachSkillFromAgentResponse, zDisconnectResponse, zDismissAllResponse, zDismissDuplicateResponse, zEditWithAiResponse, zExtractBrandResponse, zForkSessionResponse, zGetAgentMembersResponse, zGetAgentResponse, zGetAttachmentBindingsResponse, zGetAttachmentLimitsResponse, zGetBrandMembersResponse, zGetBrandResponse, zGetCompanyProfileResponse, zGetConnectorDetailResponse, zGetConnectorMembersResponse, zGetConnectorPolicyResponse, zGetContentFilterAnalyticsResponse, zGetCurrentUserInfoResponse, zGetDataSourceMembersResponse, zGetDataSourceResponse, zGetExportCapabilitiesResponse, zGetExtensionResponse, zGetFeedbackResponse, zGetFileDownloadUrlResponse, zGetFlowAuthorizationResponse, zGetFlowMembersResponse, zGetFlowResponse, zGetFlowRunResponse, zGetGovernanceOverviewResponse, zGetImportResponse, zGetLicenseDetailResponse, zGetLicenseStatusResponse, zGetMicroAppInfoResponse, zGetMicroAppMembersResponse, zGetMicroAppResponse, zGetMyOnedriveResponse, zGetMySpendResponse, zGetPersonalSpaceResponse, zGetPlatformCostsResponse, zGetPreferencesResponse, zGetSkillMembersResponse, zGetSkillResponse, zGetSpaceHubResponse, zGetSpaceMembersResponse, zGetSpaceResponse, zGetSpaceSidebarResponse, zGetUnreadCountResponse, zGetUsageByUserResponse, zGetWikiFileResponse, zGiveSpaceAccessResponse, zGoogleDriveDownloadDocumentResponse, zImportSkillsResponse, zListActiveOperationsResponse, zListAgentConnectorsResponse, zListAgentMemoriesResponse, zListAgentPinsResponse, zListAgentSkillsResponse, zListAgentsResponse, zListAllAuthorizationsResponse, zListAllFeedbackResponse, zListApiKeysResponse, zListAvailableResponse, zListBrandsResponse, zListBrandTemplatesResponse, zListBudgetConfigsResponse, zListConnectorIntegrationsResponse, zListConnectorsResponse, zListConnectorTemplatesResponse, zListConnectorToolsResponse, zListContentFilterEventsResponse, zListDataSourcesResponse, zListDriveItemsResponse, zListDuplicatesResponse, zListExtensionConsentResponse, zListExtensionsResponse, zListFilesResponse, zListFlowRunsResponse, zListFlowsResponse, zListFlowTriggersResponse, zListImportsResponse, zListInboxResponse, zListMergesResponse, zListMessageAttachmentsResponse, zListMessagesResponse, zListMicroAppsResponse, zListMyAuthorizationsResponse, zListMyConnectorConnectionsResponse, zListMyJobsResponse, zListNotificationsResponse, zListPinsResponse, zListQuickActionsResponse, zListRecentActivitiesResponse, zListSessionDocumentsResponse, zListSiteDrivesResponse, zListSkillCategoriesResponse, zListSkillsResponse, zListSpaceActivitiesResponse, zListSpaceConnectorsResponse, zListSpaceDocumentsResponse, zListSpaceKnowledgeResponse, zListSpaceResourcesResponse, zListSpaceSharedChatsResponse, zListSpacesResponse, zListTeamsResponse, zListToolsResponse, zListUserFacingTierDefaultsResponse, zListWikiFilesResponse, zListWorkersResponse, zMarkAllReadResponse, zMarkDraftAppliedResponse, zMarkNotificationReadResponse, zMergePagesResponse, zModelsListModelsResponse, zMoveSidebarSpaceResponse, zPlatformCreateOauthClientResponse, zPlatformDeleteOauthClientResponse, zPlatformListOauthClientsResponse, zPlatformUpdateOauthClientResponse, zPreviewCompanyContextResponse, zPreviewMergeResponse, zPublishMicroAppResponse, zRefreshConnectorToolsResponse, zRegenerateWebhookSecretResponse, zRejectProposalResponse, zRemoveAgentPinResponse, zRemoveAgentTeamMemberResponse, zRemoveAgentUserMemberResponse, zRemoveBrandTeamMemberResponse, zRemoveBrandUserMemberResponse, zRemoveConnectorTeamMemberResponse, zRemoveConnectorUserMemberResponse, zRemoveDataSourceTeamMemberResponse, zRemoveDataSourceUserMemberResponse, zRemoveFlowTeamMemberResponse, zRemoveFlowUserMemberResponse, zRemoveMicroAppTeamMemberResponse, zRemoveMicroAppUserMemberResponse, zRemovePinResponse, zRemoveSkillTeamMemberResponse, zRemoveSkillUserMemberResponse, zRemoveSpaceAccessResponse, zRemoveSpaceConnectorResponse, zRemoveSpaceDocumentResponse, zRemoveSpaceResourceResponse, zRemoveSpaceTeamMemberResponse, zRemoveSpaceUserMemberResponse, zReorderPinsResponse, zReorderSidebarSectionsResponse, zReorderSpaceResourcesResponse, zRepublishMicroAppResponse, zResolveSharepointUrlResponse, zResumeFlowRunResponse, zResumePlatformResponse, zRevokeApiKeyResponse, zRevokeMyAuthorizationResponse, zSaveWikiFileResponse, zSearchDriveItemsResponse, zSearchFilesResponse, zSearchSitesResponse, zSearchUsersResponse, zSetAgentConnectorsResponse, zSetConnectorSecretResponse, zSetExtensionPreferenceResponse, zSetMyConnectorCredentialResponse, zSetSessionSpaceShareResponse, zSetSpaceConnectorSkillsResponse, zSharepointCountFolderItemsResponse, zSharepointDownloadDocumentResponse, zShareSpaceDocumentResponse, zSkillDeleteImpactResponse2, zSpaceAccessImpactResponse2, zSpacesCreateQuickActionResponse, zSpacesDeleteQuickActionResponse, zSpacesUpdateQuickActionResponse, zStartConnectorOauthResponse, zStreamAgentResponse, zStreamFlowRunResponse, zSubmitFeedbackResponse, zSuspendPlatformResponse, zSyncDataSourceResponse, zToggleExtensionResponse, zUndoMergeResponse, zUpdateAgentResponse, zUpdateAgentSkillResponse, zUpdateAgentTeamMemberResponse, zUpdateAgentUserMemberResponse, zUpdateBrandResponse, zUpdateBrandTeamMemberResponse, zUpdateBrandUserMemberResponse, zUpdateBudgetConfigResponse, zUpdateConnectorResponse, zUpdateConnectorTeamMemberResponse, zUpdateConnectorToolResponse, zUpdateConnectorUserMemberResponse, zUpdateCredentialResponse, zUpdateDataSourceResponse, zUpdateDataSourceTeamMemberResponse, zUpdateDataSourceUserMemberResponse, zUpdateExtensionResponse, zUpdateFeedbackStatusResponse, zUpdateFlowResponse, zUpdateFlowTeamMemberResponse, zUpdateFlowTriggerResponse, zUpdateFlowUserMemberResponse, zUpdateLicenseResponse, zUpdateMicroAppResponse, zUpdateMicroAppTeamMemberResponse, zUpdateMicroAppUserMemberResponse, zUpdateNoteResponse, zUpdatePreferencesResponse, zUpdateSidebarSectionResponse, zUpdateSkillResponse, zUpdateSkillTeamMemberResponse, zUpdateSkillUserMemberResponse, zUpdateSpaceConnectorResponse, zUpdateSpaceResourceResponse, zUpdateSpaceResponse, zUpdateSpaceTeamMemberResponse, zUpdateSpaceUserMemberResponse, zUpdateTeamAccessResponse, zUpdateUserSettingsResponse, zUploadBrandLogoResponse, zUploadBrandTemplateResponse, zUploadFilesResponse, zUploadFlowFilesResponse, zUploadImportResponse, zUploadLogoResponse, zUploadSpaceFilesResponse, zUpsertCompanyProfileResponse } from './zod.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * List Budget Configs
 *
 * List all budget configurations.
 */
export const listBudgetConfigs = <ThrowOnError extends boolean = false>(options?: Options<ListBudgetConfigsData, ThrowOnError>): RequestResult<ListBudgetConfigsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListBudgetConfigsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zListBudgetConfigsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/budgets',
    ...options
});

/**
 * Create Budget Config
 *
 * Create a budget configuration.
 */
export const createBudgetConfig = <ThrowOnError extends boolean = false>(options: Options<CreateBudgetConfigData, ThrowOnError>): RequestResult<CreateBudgetConfigResponses, CreateBudgetConfigErrors, ThrowOnError> => (options.client ?? client).post<CreateBudgetConfigResponses, CreateBudgetConfigErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateBudgetConfigResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/budgets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Budget Config
 *
 * Delete a budget configuration.
 */
export const deleteBudgetConfig = <ThrowOnError extends boolean = false>(options: Options<DeleteBudgetConfigData, ThrowOnError>): RequestResult<DeleteBudgetConfigResponses, DeleteBudgetConfigErrors, ThrowOnError> => (options.client ?? client).delete<DeleteBudgetConfigResponses, DeleteBudgetConfigErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteBudgetConfigResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/budgets/{budget_id}',
    ...options
});

/**
 * Update Budget Config
 *
 * Update a budget configuration's monthly limit.
 */
export const updateBudgetConfig = <ThrowOnError extends boolean = false>(options: Options<UpdateBudgetConfigData, ThrowOnError>): RequestResult<UpdateBudgetConfigResponses, UpdateBudgetConfigErrors, ThrowOnError> => (options.client ?? client).put<UpdateBudgetConfigResponses, UpdateBudgetConfigErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateBudgetConfigResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/budgets/{budget_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Company Profile
 *
 * Get the company profile (returns null data if not yet configured).
 */
export const getCompanyProfile = <ThrowOnError extends boolean = false>(options?: Options<GetCompanyProfileData, ThrowOnError>): RequestResult<GetCompanyProfileResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetCompanyProfileResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zGetCompanyProfileResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/company',
    ...options
});

/**
 * Upsert Company Profile
 *
 * Create or update the company profile (upsert on the singleton row).
 */
export const upsertCompanyProfile = <ThrowOnError extends boolean = false>(options: Options<UpsertCompanyProfileData, ThrowOnError>): RequestResult<UpsertCompanyProfileResponses, UpsertCompanyProfileErrors, ThrowOnError> => (options.client ?? client).put<UpsertCompanyProfileResponses, UpsertCompanyProfileErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpsertCompanyProfileResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/company',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview Company Context
 *
 * Preview the auto-generated system prompt context from the current profile.
 */
export const previewCompanyContext = <ThrowOnError extends boolean = false>(options?: Options<PreviewCompanyContextData, ThrowOnError>): RequestResult<PreviewCompanyContextResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PreviewCompanyContextResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zPreviewCompanyContextResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/company/context-preview',
    ...options
});

/**
 * Get Logo
 *
 * Serve the company logo from blob storage.
 */
export const getLogo = <ThrowOnError extends boolean = false>(options?: Options<GetLogoData, ThrowOnError>): RequestResult<GetLogoResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetLogoResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/company/logo',
    ...options
});

/**
 * Upload Logo
 *
 * Upload a company logo image.
 *
 * Stores the file in blob storage and updates the company profile's
 * logo_blob_path field. Replaces any existing logo.
 */
export const uploadLogo = <ThrowOnError extends boolean = false>(options: Options<UploadLogoData, ThrowOnError>): RequestResult<UploadLogoResponses, UploadLogoErrors, ThrowOnError> => (options.client ?? client).post<UploadLogoResponses, UploadLogoErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zUploadLogoResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/company/logo',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Admin List Connectors
 *
 * Every connector people have added, with whether its host passes the policy.
 */
export const adminListConnectors = <ThrowOnError extends boolean = false>(options?: Options<AdminListConnectorsData, ThrowOnError>): RequestResult<AdminListConnectorsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AdminListConnectorsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zAdminListConnectorsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/connectors',
    ...options
});

/**
 * Admin Connector Audit
 *
 * Recent connector activity, newest first (optionally for one connector). Page with ``beforeId``.
 */
export const adminConnectorAudit = <ThrowOnError extends boolean = false>(options?: Options<AdminConnectorAuditData, ThrowOnError>): RequestResult<AdminConnectorAuditResponses, AdminConnectorAuditErrors, ThrowOnError> => (options?.client ?? client).get<AdminConnectorAuditResponses, AdminConnectorAuditErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminConnectorAuditResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/connectors/audit',
    ...options
});

/**
 * Admin Get Connector Policy
 *
 * The connector policy.
 */
export const adminGetConnectorPolicy = <ThrowOnError extends boolean = false>(options?: Options<AdminGetConnectorPolicyData, ThrowOnError>): RequestResult<AdminGetConnectorPolicyResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AdminGetConnectorPolicyResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zAdminGetConnectorPolicyResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/connectors/policy',
    ...options
});

/**
 * Admin Update Connector Policy
 *
 * Change who may add connectors and which hosts they may reach.
 */
export const adminUpdateConnectorPolicy = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateConnectorPolicyData, ThrowOnError>): RequestResult<AdminUpdateConnectorPolicyResponses, AdminUpdateConnectorPolicyErrors, ThrowOnError> => (options.client ?? client).put<AdminUpdateConnectorPolicyResponses, AdminUpdateConnectorPolicyErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminUpdateConnectorPolicyResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/connectors/policy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Disable Connector
 *
 * Turn a connector off for everyone. Its owners can't turn it back on.
 */
export const adminDisableConnector = <ThrowOnError extends boolean = false>(options: Options<AdminDisableConnectorData, ThrowOnError>): RequestResult<AdminDisableConnectorResponses, AdminDisableConnectorErrors, ThrowOnError> => (options.client ?? client).post<AdminDisableConnectorResponses, AdminDisableConnectorErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminDisableConnectorResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/connectors/{connector_uuid}/disable',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Enable Connector
 *
 * Allow a connector an admin turned off again.
 */
export const adminEnableConnector = <ThrowOnError extends boolean = false>(options: Options<AdminEnableConnectorData, ThrowOnError>): RequestResult<AdminEnableConnectorResponses, AdminEnableConnectorErrors, ThrowOnError> => (options.client ?? client).post<AdminEnableConnectorResponses, AdminEnableConnectorErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminEnableConnectorResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/connectors/{connector_uuid}/enable',
    ...options
});

/**
 * Get Content Filter Analytics
 *
 * Counts by category, severity and UTC day. No user identity.
 */
export const getContentFilterAnalytics = <ThrowOnError extends boolean = false>(options?: Options<GetContentFilterAnalyticsData, ThrowOnError>): RequestResult<GetContentFilterAnalyticsResponses, GetContentFilterAnalyticsErrors, ThrowOnError> => (options?.client ?? client).get<GetContentFilterAnalyticsResponses, GetContentFilterAnalyticsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetContentFilterAnalyticsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/content-filter/analytics',
    ...options
});

/**
 * List Content Filter Events
 *
 * Flagged categories, newest first. No user identity.
 */
export const listContentFilterEvents = <ThrowOnError extends boolean = false>(options?: Options<ListContentFilterEventsData, ThrowOnError>): RequestResult<ListContentFilterEventsResponses, ListContentFilterEventsErrors, ThrowOnError> => (options?.client ?? client).get<ListContentFilterEventsResponses, ListContentFilterEventsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListContentFilterEventsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/content-filter/events',
    ...options
});

/**
 * Correlate Content Filter Event
 *
 * Who triggered one event and in which conversation, for human follow-up. Audited.
 */
export const correlateContentFilterEvent = <ThrowOnError extends boolean = false>(options: Options<CorrelateContentFilterEventData, ThrowOnError>): RequestResult<CorrelateContentFilterEventResponses, CorrelateContentFilterEventErrors, ThrowOnError> => (options.client ?? client).get<CorrelateContentFilterEventResponses, CorrelateContentFilterEventErrors, ThrowOnError>({
    responseValidator: async (data) => await zCorrelateContentFilterEventResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/content-filter/events/{event_uuid}/correlation',
    ...options
});

/**
 * Get Governance Overview
 *
 * Return a complete governance dashboard with policies, blocklists,
 * and deployment configuration pulled from the Azure Management API.
 */
export const getGovernanceOverview = <ThrowOnError extends boolean = false>(options?: Options<GetGovernanceOverviewData, ThrowOnError>): RequestResult<GetGovernanceOverviewResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetGovernanceOverviewResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zGetGovernanceOverviewResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/governance/overview',
    ...options
});

/**
 * Get License Detail
 *
 * Get full license details (MH admin only).
 *
 * Includes all configuration, internal notes, and exempt domains.
 */
export const getLicenseDetail = <ThrowOnError extends boolean = false>(options?: Options<GetLicenseDetailData, ThrowOnError>): RequestResult<GetLicenseDetailResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetLicenseDetailResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zGetLicenseDetailResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/license',
    ...options
});

/**
 * Update License
 *
 * Update license configuration (MH admin only).
 *
 * Allows changing seat limits, expiry dates, exempt domains, etc.
 */
export const updateLicense = <ThrowOnError extends boolean = false>(options: Options<UpdateLicenseData, ThrowOnError>): RequestResult<UpdateLicenseResponses, UpdateLicenseErrors, ThrowOnError> => (options.client ?? client).put<UpdateLicenseResponses, UpdateLicenseErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateLicenseResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/license',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resume Platform
 *
 * Resume the platform after suspension (MH admin only).
 *
 * Clears the suspension state and restores access for all users.
 */
export const resumePlatform = <ThrowOnError extends boolean = false>(options: Options<ResumePlatformData, ThrowOnError>): RequestResult<ResumePlatformResponses, ResumePlatformErrors, ThrowOnError> => (options.client ?? client).post<ResumePlatformResponses, ResumePlatformErrors, ThrowOnError>({
    responseValidator: async (data) => await zResumePlatformResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/license/resume',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get License Status
 *
 * Get license status summary (any platform admin).
 *
 * Returns a lightweight view suitable for customer admin dashboards:
 * seat usage, expiry date, and overall status.
 */
export const getLicenseStatus = <ThrowOnError extends boolean = false>(options?: Options<GetLicenseStatusData, ThrowOnError>): RequestResult<GetLicenseStatusResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetLicenseStatusResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zGetLicenseStatusResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/license/status',
    ...options
});

/**
 * Suspend Platform
 *
 * Suspend the platform immediately (MH admin only).
 *
 * All non-exempt users will be locked out until the platform is resumed.
 * MH staff can still access to troubleshoot or export data.
 */
export const suspendPlatform = <ThrowOnError extends boolean = false>(options: Options<SuspendPlatformData, ThrowOnError>): RequestResult<SuspendPlatformResponses, SuspendPlatformErrors, ThrowOnError> => (options.client ?? client).post<SuspendPlatformResponses, SuspendPlatformErrors, ThrowOnError>({
    responseValidator: async (data) => await zSuspendPlatformResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/license/suspend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin List Models
 *
 * List all models with admin details (includes disabled).
 */
export const adminListModels = <ThrowOnError extends boolean = false>(options?: Options<AdminListModelsData, ThrowOnError>): RequestResult<AdminListModelsResponses, AdminListModelsErrors, ThrowOnError> => (options?.client ?? client).get<AdminListModelsResponses, AdminListModelsErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminListModelsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/models',
    ...options
});

/**
 * Admin Create Model
 *
 * Create a new AI model.
 */
export const adminCreateModel = <ThrowOnError extends boolean = false>(options: Options<AdminCreateModelData, ThrowOnError>): RequestResult<AdminCreateModelResponses, AdminCreateModelErrors, ThrowOnError> => (options.client ?? client).post<AdminCreateModelResponses, AdminCreateModelErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminCreateModelResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/models',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Suggest Model
 *
 * Suggest configuration for a model based on its name.
 *
 * Uses the models.dev open-source database (https://models.dev) as the
 * primary source for model capabilities, pricing, and token limits.
 * Falls back to an LLM call when the model is not found in models.dev.
 *
 * When models.dev data IS available, the LLM is only used for fields
 * that models.dev doesn't cover (e.g. code_interpreter support) and to
 * normalize Azure-specific pricing when needed.
 *
 * When models.dev data is NOT available, falls back to the original
 * LLM-based approach with live Azure pricing + OpenAI docs scraping.
 */
export const adminSuggestModel = <ThrowOnError extends boolean = false>(options: Options<AdminSuggestModelData, ThrowOnError>): RequestResult<AdminSuggestModelResponses, AdminSuggestModelErrors, ThrowOnError> => (options.client ?? client).post<AdminSuggestModelResponses, AdminSuggestModelErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminSuggestModelResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/models/suggest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin List Tier Defaults
 *
 * List all model tier defaults with their current assignments.
 */
export const adminListTierDefaults = <ThrowOnError extends boolean = false>(options?: Options<AdminListTierDefaultsData, ThrowOnError>): RequestResult<AdminListTierDefaultsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AdminListTierDefaultsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zAdminListTierDefaultsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/models/tier-defaults',
    ...options
});

/**
 * Admin Update Tier Default
 *
 * Update the model assignment for a specific tier.
 */
export const adminUpdateTierDefault = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateTierDefaultData, ThrowOnError>): RequestResult<AdminUpdateTierDefaultResponses, AdminUpdateTierDefaultErrors, ThrowOnError> => (options.client ?? client).put<AdminUpdateTierDefaultResponses, AdminUpdateTierDefaultErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminUpdateTierDefaultResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/models/tier-defaults/{tier}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Delete Model
 *
 * Delete an AI model.
 */
export const adminDeleteModel = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteModelData, ThrowOnError>): RequestResult<AdminDeleteModelResponses, AdminDeleteModelErrors, ThrowOnError> => (options.client ?? client).delete<AdminDeleteModelResponses, AdminDeleteModelErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminDeleteModelResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/models/{model_id}',
    ...options
});

/**
 * Admin Get Model
 *
 * Get one model with admin details (includes disabled), for the new UI's configure page (MHS-714).
 */
export const adminGetModel = <ThrowOnError extends boolean = false>(options: Options<AdminGetModelData, ThrowOnError>): RequestResult<AdminGetModelResponses, AdminGetModelErrors, ThrowOnError> => (options.client ?? client).get<AdminGetModelResponses, AdminGetModelErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminGetModelResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/models/{model_id}',
    ...options
});

/**
 * Admin Update Model
 *
 * Enable/disable a model or update settings.
 */
export const adminUpdateModel = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateModelData, ThrowOnError>): RequestResult<AdminUpdateModelResponses, AdminUpdateModelErrors, ThrowOnError> => (options.client ?? client).patch<AdminUpdateModelResponses, AdminUpdateModelErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminUpdateModelResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/models/{model_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Reassign Model
 *
 * Move a model's live agents and chats to an active replacement.
 */
export const adminReassignModel = <ThrowOnError extends boolean = false>(options: Options<AdminReassignModelData, ThrowOnError>): RequestResult<AdminReassignModelResponses, AdminReassignModelErrors, ThrowOnError> => (options.client ?? client).post<AdminReassignModelResponses, AdminReassignModelErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminReassignModelResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/models/{model_id}/reassign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin List Model References
 *
 * Live agents and chats that still use a model.
 */
export const adminListModelReferences = <ThrowOnError extends boolean = false>(options: Options<AdminListModelReferencesData, ThrowOnError>): RequestResult<AdminListModelReferencesResponses, AdminListModelReferencesErrors, ThrowOnError> => (options.client ?? client).get<AdminListModelReferencesResponses, AdminListModelReferencesErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminListModelReferencesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/models/{model_id}/references',
    ...options
});

/**
 * Get Platform Costs
 *
 * Return platform cost data from Azure Cost Management.
 *
 * Includes total cost, breakdown by resource group, breakdown by
 * resource group + service, and a daily cost trend. Data is cached
 * for 1 hour since Azure billing data lags 24-48 hours.
 *
 * Uses ``PlatformAdminLight`` (no request-scoped DB session) because the
 * upstream Azure Cost Management call can take 2-3 minutes; holding a pooled
 * DB connection for that long can exhaust the pool and block other requests
 * (e.g. editing a budget). See the session-per-phase rule in AGENTS.md.
 */
export const getPlatformCosts = <ThrowOnError extends boolean = false>(options?: Options<GetPlatformCostsData, ThrowOnError>): RequestResult<GetPlatformCostsResponses, GetPlatformCostsErrors, ThrowOnError> => (options?.client ?? client).get<GetPlatformCostsResponses, GetPlatformCostsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetPlatformCostsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/platform-costs/overview',
    ...options
});

/**
 * Platform List Oauth Clients
 *
 * List all registered OAuth clients.
 */
export const platformListOauthClients = <ThrowOnError extends boolean = false>(options?: Options<PlatformListOauthClientsData, ThrowOnError>): RequestResult<PlatformListOauthClientsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PlatformListOauthClientsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zPlatformListOauthClientsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/platform/oauth-clients',
    ...options
});

/**
 * Platform Create Oauth Client
 *
 * Register a new OAuth client. A confidential client's secret is returned once.
 */
export const platformCreateOauthClient = <ThrowOnError extends boolean = false>(options: Options<PlatformCreateOauthClientData, ThrowOnError>): RequestResult<PlatformCreateOauthClientResponses, PlatformCreateOauthClientErrors, ThrowOnError> => (options.client ?? client).post<PlatformCreateOauthClientResponses, PlatformCreateOauthClientErrors, ThrowOnError>({
    responseValidator: async (data) => await zPlatformCreateOauthClientResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/platform/oauth-clients',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Platform Delete Oauth Client
 *
 * Delete a client. First-party clients cannot be deleted.
 */
export const platformDeleteOauthClient = <ThrowOnError extends boolean = false>(options: Options<PlatformDeleteOauthClientData, ThrowOnError>): RequestResult<PlatformDeleteOauthClientResponses, PlatformDeleteOauthClientErrors, ThrowOnError> => (options.client ?? client).delete<PlatformDeleteOauthClientResponses, PlatformDeleteOauthClientErrors, ThrowOnError>({
    responseValidator: async (data) => await zPlatformDeleteOauthClientResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/platform/oauth-clients/{client_uuid}',
    ...options
});

/**
 * Platform Update Oauth Client
 *
 * Update a client's mutable fields.
 */
export const platformUpdateOauthClient = <ThrowOnError extends boolean = false>(options: Options<PlatformUpdateOauthClientData, ThrowOnError>): RequestResult<PlatformUpdateOauthClientResponses, PlatformUpdateOauthClientErrors, ThrowOnError> => (options.client ?? client).patch<PlatformUpdateOauthClientResponses, PlatformUpdateOauthClientErrors, ThrowOnError>({
    responseValidator: async (data) => await zPlatformUpdateOauthClientResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/platform/oauth-clients/{client_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Get Usage
 *
 * Get platform usage statistics.
 */
export const adminGetUsage = <ThrowOnError extends boolean = false>(options?: Options<AdminGetUsageData, ThrowOnError>): RequestResult<AdminGetUsageResponses, AdminGetUsageErrors, ThrowOnError> => (options?.client ?? client).get<AdminGetUsageResponses, AdminGetUsageErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminGetUsageResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/usage',
    ...options
});

/**
 * Admin List Users
 *
 * List all users.
 */
export const adminListUsers = <ThrowOnError extends boolean = false>(options?: Options<AdminListUsersData, ThrowOnError>): RequestResult<AdminListUsersResponses, AdminListUsersErrors, ThrowOnError> => (options?.client ?? client).get<AdminListUsersResponses, AdminListUsersErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminListUsersResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users',
    ...options
});

/**
 * Admin Create User
 *
 * Pre-provision a user before their first login.
 *
 * Creates a user record without an external_id (IdP subject identifier).
 * When the user logs in for the first time, the auth middleware will match
 * them by email and link their IdP identity automatically.
 *
 * The user is automatically added to the "Everyone" team. Additional teams
 * can be specified via `team_uuids`.
 */
export const adminCreateUser = <ThrowOnError extends boolean = false>(options: Options<AdminCreateUserData, ThrowOnError>): RequestResult<AdminCreateUserResponses, AdminCreateUserErrors, ThrowOnError> => (options.client ?? client).post<AdminCreateUserResponses, AdminCreateUserErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminCreateUserResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Delete User
 *
 * Permanently delete a deactivated user who has never signed in.
 */
export const adminDeleteUser = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteUserData, ThrowOnError>): RequestResult<AdminDeleteUserResponses, AdminDeleteUserErrors, ThrowOnError> => (options.client ?? client).delete<AdminDeleteUserResponses, AdminDeleteUserErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminDeleteUserResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_uuid}',
    ...options
});

/**
 * Admin Update User
 *
 * Update user (role, active status).
 *
 * When deactivating a user, an optional `deactivation_reason` can be provided.
 * When activating a user, the deactivation_reason is automatically cleared.
 *
 * Role assignment rules:
 * - Any platform_admin or install_admin can assign member or platform_admin roles.
 * - Only an install_admin can assign the install_admin role to another user.
 */
export const adminUpdateUser = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateUserData, ThrowOnError>): RequestResult<AdminUpdateUserResponses, AdminUpdateUserErrors, ThrowOnError> => (options.client ?? client).put<AdminUpdateUserResponses, AdminUpdateUserErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminUpdateUserResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_uuid}',
    ...options
});

/**
 * Clear All Agent Memory
 *
 * Delete everything every agent remembers about you.
 */
export const clearAllAgentMemory = <ThrowOnError extends boolean = false>(options?: Options<ClearAllAgentMemoryData, ThrowOnError>): RequestResult<ClearAllAgentMemoryResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<ClearAllAgentMemoryResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zClearAllAgentMemoryResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agent-memories',
    ...options
});

/**
 * List Agent Memories
 *
 * Everything your agents remember about you, by agent (the default AnthmAI chat first).
 */
export const listAgentMemories = <ThrowOnError extends boolean = false>(options?: Options<ListAgentMemoriesData, ThrowOnError>): RequestResult<ListAgentMemoriesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListAgentMemoriesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zListAgentMemoriesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agent-memories',
    ...options
});

/**
 * Clear Agent Memory
 *
 * Delete everything one agent remembers about you (``default``: the default AnthmAI chat).
 */
export const clearAgentMemory = <ThrowOnError extends boolean = false>(options: Options<ClearAgentMemoryData, ThrowOnError>): RequestResult<ClearAgentMemoryResponses, ClearAgentMemoryErrors, ThrowOnError> => (options.client ?? client).delete<ClearAgentMemoryResponses, ClearAgentMemoryErrors, ThrowOnError>({
    responseValidator: async (data) => await zClearAgentMemoryResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agent-memories/agents/{agent_uuid}',
    ...options
});

/**
 * Delete Agent Memory
 *
 * Delete one note (404 if it isn't yours, the same as missing).
 */
export const deleteAgentMemory = <ThrowOnError extends boolean = false>(options: Options<DeleteAgentMemoryData, ThrowOnError>): RequestResult<DeleteAgentMemoryResponses, DeleteAgentMemoryErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAgentMemoryResponses, DeleteAgentMemoryErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteAgentMemoryResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agent-memories/entries/{entry_uuid}',
    ...options
});

/**
 * List Agents
 *
 * List agents the user can access.
 *
 * An agent is accessible when the user has a membership role on it (directly
 * or via a team), or is a platform admin. ``team_uuid`` filters by the agent's
 * organizational team association (not access).
 *
 * When ``project_uuid`` is provided, results are further restricted to agents
 * attached to that project as a resource.
 */
export const listAgents = <ThrowOnError extends boolean = false>(options?: Options<ListAgentsData, ThrowOnError>): RequestResult<ListAgentsResponses, ListAgentsErrors, ThrowOnError> => (options?.client ?? client).get<ListAgentsResponses, ListAgentsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListAgentsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents',
    ...options
});

/**
 * Create Agent
 *
 * Create a new agent.
 *
 * The agent is created in the specified team.
 */
export const createAgent = <ThrowOnError extends boolean = false>(options: Options<CreateAgentData, ThrowOnError>): RequestResult<CreateAgentResponses, CreateAgentErrors, ThrowOnError> => (options.client ?? client).post<CreateAgentResponses, CreateAgentErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateAgentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Agent Pins
 *
 * The caller's starred agents, in pin order (Home's "Pinned agents").
 */
export const listAgentPins = <ThrowOnError extends boolean = false>(options?: Options<ListAgentPinsData, ThrowOnError>): RequestResult<ListAgentPinsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListAgentPinsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zListAgentPinsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/pins',
    ...options
});

/**
 * Add Agent Pin
 *
 * Star an agent. Requires view access to it.
 */
export const addAgentPin = <ThrowOnError extends boolean = false>(options: Options<AddAgentPinData, ThrowOnError>): RequestResult<AddAgentPinResponses, AddAgentPinErrors, ThrowOnError> => (options.client ?? client).post<AddAgentPinResponses, AddAgentPinErrors, ThrowOnError>({
    responseValidator: async (data) => await zAddAgentPinResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/pins',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Agent Pin
 *
 * Unstar an agent.
 */
export const removeAgentPin = <ThrowOnError extends boolean = false>(options: Options<RemoveAgentPinData, ThrowOnError>): RequestResult<RemoveAgentPinResponses, RemoveAgentPinErrors, ThrowOnError> => (options.client ?? client).delete<RemoveAgentPinResponses, RemoveAgentPinErrors, ThrowOnError>({
    responseValidator: async (data) => await zRemoveAgentPinResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/pins/{agent_uuid}',
    ...options
});

/**
 * Delete Agent
 *
 * Delete an agent (soft delete).
 *
 * Only the creator or platform admin can delete an agent.
 */
export const deleteAgent = <ThrowOnError extends boolean = false>(options: Options<DeleteAgentData, ThrowOnError>): RequestResult<DeleteAgentResponses, DeleteAgentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAgentResponses, DeleteAgentErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteAgentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/{agent_uuid}',
    ...options
});

/**
 * Get Agent
 *
 * Get agent details.
 */
export const getAgent = <ThrowOnError extends boolean = false>(options: Options<GetAgentData, ThrowOnError>): RequestResult<GetAgentResponses, GetAgentErrors, ThrowOnError> => (options.client ?? client).get<GetAgentResponses, GetAgentErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetAgentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/{agent_uuid}',
    ...options
});

/**
 * Update Agent
 *
 * Update an agent.
 *
 * Only the creator or platform admin can update an agent.
 */
export const updateAgent = <ThrowOnError extends boolean = false>(options: Options<UpdateAgentData, ThrowOnError>): RequestResult<UpdateAgentResponses, UpdateAgentErrors, ThrowOnError> => (options.client ?? client).patch<UpdateAgentResponses, UpdateAgentErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateAgentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/{agent_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Agent Connectors
 *
 * The agent's connectors (viewer+), and whether I can use each.
 */
export const listAgentConnectors = <ThrowOnError extends boolean = false>(options: Options<ListAgentConnectorsData, ThrowOnError>): RequestResult<ListAgentConnectorsResponses, ListAgentConnectorsErrors, ThrowOnError> => (options.client ?? client).get<ListAgentConnectorsResponses, ListAgentConnectorsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListAgentConnectorsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/{agent_uuid}/connectors',
    ...options
});

/**
 * Set Agent Connectors
 *
 * Replace the agent's connectors (editor+; each new one must be one I can use).
 */
export const setAgentConnectors = <ThrowOnError extends boolean = false>(options: Options<SetAgentConnectorsData, ThrowOnError>): RequestResult<SetAgentConnectorsResponses, SetAgentConnectorsErrors, ThrowOnError> => (options.client ?? client).put<SetAgentConnectorsResponses, SetAgentConnectorsErrors, ThrowOnError>({
    responseValidator: async (data) => await zSetAgentConnectorsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/{agent_uuid}/connectors',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Agent Delete Impact
 *
 * What deleting this agent would affect: the skill imported alongside it,
 * and whether that skill is attached to other agents (MHS-359).
 */
export const agentDeleteImpact = <ThrowOnError extends boolean = false>(options: Options<AgentDeleteImpactData, ThrowOnError>): RequestResult<AgentDeleteImpactResponses, AgentDeleteImpactErrors, ThrowOnError> => (options.client ?? client).get<AgentDeleteImpactResponses, AgentDeleteImpactErrors, ThrowOnError>({
    responseValidator: async (data) => await zAgentDeleteImpactResponse2.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/{agent_uuid}/delete-impact',
    ...options
});

/**
 * Get Agent Members
 *
 * List an agent's user + team members and the caller's effective role.
 *
 * Any user who can view the agent may read its membership.
 */
export const getAgentMembers = <ThrowOnError extends boolean = false>(options: Options<GetAgentMembersData, ThrowOnError>): RequestResult<GetAgentMembersResponses, GetAgentMembersErrors, ThrowOnError> => (options.client ?? client).get<GetAgentMembersResponses, GetAgentMembersErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetAgentMembersResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/{agent_uuid}/members',
    ...options
});

/**
 * Add Agent Team Member
 *
 * Add (or update) a team's role on an agent. Requires agent admin.
 *
 * Granting a role to the special "Everyone" team makes the agent available
 * org-wide at that role.
 */
export const addAgentTeamMember = <ThrowOnError extends boolean = false>(options: Options<AddAgentTeamMemberData, ThrowOnError>): RequestResult<AddAgentTeamMemberResponses, AddAgentTeamMemberErrors, ThrowOnError> => (options.client ?? client).post<AddAgentTeamMemberResponses, AddAgentTeamMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zAddAgentTeamMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/{agent_uuid}/members/teams',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Agent Team Member
 *
 * Remove a team member. Requires agent admin (cannot remove the last admin).
 */
export const removeAgentTeamMember = <ThrowOnError extends boolean = false>(options: Options<RemoveAgentTeamMemberData, ThrowOnError>): RequestResult<RemoveAgentTeamMemberResponses, RemoveAgentTeamMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveAgentTeamMemberResponses, RemoveAgentTeamMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zRemoveAgentTeamMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/{agent_uuid}/members/teams/{team_uuid}',
    ...options
});

/**
 * Update Agent Team Member
 *
 * Change a team member's role. Requires agent admin. 404 if not a member.
 */
export const updateAgentTeamMember = <ThrowOnError extends boolean = false>(options: Options<UpdateAgentTeamMemberData, ThrowOnError>): RequestResult<UpdateAgentTeamMemberResponses, UpdateAgentTeamMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateAgentTeamMemberResponses, UpdateAgentTeamMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateAgentTeamMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/{agent_uuid}/members/teams/{team_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add Agent User Member
 *
 * Add (or update) a user's role on an agent. Requires agent admin.
 */
export const addAgentUserMember = <ThrowOnError extends boolean = false>(options: Options<AddAgentUserMemberData, ThrowOnError>): RequestResult<AddAgentUserMemberResponses, AddAgentUserMemberErrors, ThrowOnError> => (options.client ?? client).post<AddAgentUserMemberResponses, AddAgentUserMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zAddAgentUserMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/{agent_uuid}/members/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Agent User Member
 *
 * Remove a user member. Requires agent admin (cannot remove the last admin).
 */
export const removeAgentUserMember = <ThrowOnError extends boolean = false>(options: Options<RemoveAgentUserMemberData, ThrowOnError>): RequestResult<RemoveAgentUserMemberResponses, RemoveAgentUserMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveAgentUserMemberResponses, RemoveAgentUserMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zRemoveAgentUserMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/{agent_uuid}/members/users/{user_uuid}',
    ...options
});

/**
 * Update Agent User Member
 *
 * Change a user member's role. Requires agent admin.
 */
export const updateAgentUserMember = <ThrowOnError extends boolean = false>(options: Options<UpdateAgentUserMemberData, ThrowOnError>): RequestResult<UpdateAgentUserMemberResponses, UpdateAgentUserMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateAgentUserMemberResponses, UpdateAgentUserMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateAgentUserMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/{agent_uuid}/members/users/{user_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Agent Skills
 *
 * List skills attached to an agent.
 *
 * Returns skills ordered by priority (highest first).
 */
export const listAgentSkills = <ThrowOnError extends boolean = false>(options: Options<ListAgentSkillsData, ThrowOnError>): RequestResult<ListAgentSkillsResponses, ListAgentSkillsErrors, ThrowOnError> => (options.client ?? client).get<ListAgentSkillsResponses, ListAgentSkillsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListAgentSkillsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/{agent_uuid}/skills',
    ...options
});

/**
 * Attach Skills To Agent
 *
 * Attach one or more skills to an agent.
 *
 * If a skill is already attached, it will be updated with the new config.
 * Tools required by the skill are auto-provisioned onto the agent.
 */
export const attachSkillsToAgent = <ThrowOnError extends boolean = false>(options: Options<AttachSkillsToAgentData, ThrowOnError>): RequestResult<AttachSkillsToAgentResponses, AttachSkillsToAgentErrors, ThrowOnError> => (options.client ?? client).post<AttachSkillsToAgentResponses, AttachSkillsToAgentErrors, ThrowOnError>({
    responseValidator: async (data) => await zAttachSkillsToAgentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/{agent_uuid}/skills',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Detach Skill From Agent
 *
 * Detach a skill from an agent.
 *
 * The skill itself is not deleted, only the association.
 * Tools that were auto-provisioned by this skill (and not needed by other skills)
 * are automatically de-provisioned.
 */
export const detachSkillFromAgent = <ThrowOnError extends boolean = false>(options: Options<DetachSkillFromAgentData, ThrowOnError>): RequestResult<DetachSkillFromAgentResponses, DetachSkillFromAgentErrors, ThrowOnError> => (options.client ?? client).delete<DetachSkillFromAgentResponses, DetachSkillFromAgentErrors, ThrowOnError>({
    responseValidator: async (data) => await zDetachSkillFromAgentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/{agent_uuid}/skills/{skill_uuid}',
    ...options
});

/**
 * Update Agent Skill
 *
 * Update a skill's configuration on an agent.
 *
 * Only updates fields that are provided.
 */
export const updateAgentSkill = <ThrowOnError extends boolean = false>(options: Options<UpdateAgentSkillData, ThrowOnError>): RequestResult<UpdateAgentSkillResponses, UpdateAgentSkillErrors, ThrowOnError> => (options.client ?? client).patch<UpdateAgentSkillResponses, UpdateAgentSkillErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateAgentSkillResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/{agent_uuid}/skills/{skill_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stream Agent
 *
 * Stream an agent response via OperationManager.
 *
 * Returns ``{"operation_id": "...", "session_uuid": "..."}`` immediately (HTTP 202).
 * The actual LLM streaming runs as a background ``asyncio.Task``.
 * Subscribe to progress via ``GET /api/v1/operations/{operation_id}/stream``.
 *
 * Executes the agent with tool calling. Tool execution happens
 * in between streams, only the final response is streamed.
 */
export const streamAgent = <ThrowOnError extends boolean = false>(options: Options<StreamAgentData, ThrowOnError>): RequestResult<StreamAgentResponses, StreamAgentErrors, ThrowOnError> => (options.client ?? client).post<StreamAgentResponses, StreamAgentErrors, ThrowOnError>({
    responseValidator: async (data) => await zStreamAgentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/{agent_uuid}/stream',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Api Keys
 *
 * List all API keys for the current user (never returns the key itself).
 */
export const listApiKeys = <ThrowOnError extends boolean = false>(options?: Options<ListApiKeysData, ThrowOnError>): RequestResult<ListApiKeysResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListApiKeysResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zListApiKeysResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/api-keys',
    ...options
});

/**
 * Create Api Key
 *
 * Generate a new API key. The full key is returned only once.
 */
export const createApiKey = <ThrowOnError extends boolean = false>(options: Options<CreateApiKeyData, ThrowOnError>): RequestResult<CreateApiKeyResponses, CreateApiKeyErrors, ThrowOnError> => (options.client ?? client).post<CreateApiKeyResponses, CreateApiKeyErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateApiKeyResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/api-keys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Api Key
 *
 * Revoke an API key (soft delete).
 */
export const revokeApiKey = <ThrowOnError extends boolean = false>(options: Options<RevokeApiKeyData, ThrowOnError>): RequestResult<RevokeApiKeyResponses, RevokeApiKeyErrors, ThrowOnError> => (options.client ?? client).delete<RevokeApiKeyResponses, RevokeApiKeyErrors, ThrowOnError>({
    responseValidator: async (data) => await zRevokeApiKeyResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/api-keys/{key_id}',
    ...options
});

/**
 * Get Current User Info
 *
 * Get current authenticated user information.
 *
 * Returns user profile and list of teams they belong to.
 */
export const getCurrentUserInfo = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentUserInfoData, ThrowOnError>): RequestResult<GetCurrentUserInfoResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetCurrentUserInfoResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zGetCurrentUserInfoResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/me',
    ...options
});

/**
 * Update User Settings
 *
 * Update current user's settings.
 *
 * Only fields present in the request body are applied; absent fields are
 * left unchanged.  Sending ``null`` for a field removes it from settings.
 *
 * Adding a new user setting requires only adding the field to
 * ``UserSettingsUpdate`` — no whitelist or manual mapping needed.
 */
export const updateUserSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateUserSettingsData, ThrowOnError>): RequestResult<UpdateUserSettingsResponses, UpdateUserSettingsErrors, ThrowOnError> => (options.client ?? client).put<UpdateUserSettingsResponses, UpdateUserSettingsErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateUserSettingsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/me/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search Users
 *
 * Search for platform users by name or email.
 *
 * Returns up to 10 matching users, excluding the current user.
 * Used by the share dialog to find users to share with.
 */
export const searchUsers = <ThrowOnError extends boolean = false>(options: Options<SearchUsersData, ThrowOnError>): RequestResult<SearchUsersResponses, SearchUsersErrors, ThrowOnError> => (options.client ?? client).get<SearchUsersResponses, SearchUsersErrors, ThrowOnError>({
    responseValidator: async (data) => await zSearchUsersResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/users/search',
    ...options
});

/**
 * List My Authorizations
 *
 * List the current user's cached delegated authorizations.
 */
export const listMyAuthorizations = <ThrowOnError extends boolean = false>(options?: Options<ListMyAuthorizationsData, ThrowOnError>): RequestResult<ListMyAuthorizationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListMyAuthorizationsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zListMyAuthorizationsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/authorizations',
    ...options
});

/**
 * List All Authorizations
 *
 * Admin: list all cached authorizations across the organization.
 */
export const listAllAuthorizations = <ThrowOnError extends boolean = false>(options?: Options<ListAllAuthorizationsData, ThrowOnError>): RequestResult<ListAllAuthorizationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListAllAuthorizationsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zListAllAuthorizationsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/authorizations/all',
    ...options
});

/**
 * Revoke My Authorization
 *
 * Revoke (delete) the current user's authorization for a purpose.
 */
export const revokeMyAuthorization = <ThrowOnError extends boolean = false>(options: Options<RevokeMyAuthorizationData, ThrowOnError>): RequestResult<RevokeMyAuthorizationResponses, RevokeMyAuthorizationErrors, ThrowOnError> => (options.client ?? client).delete<RevokeMyAuthorizationResponses, RevokeMyAuthorizationErrors, ThrowOnError>({
    responseValidator: async (data) => await zRevokeMyAuthorizationResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/authorizations/{purpose}',
    ...options
});

/**
 * List Brands
 *
 * List brands the caller can access (plus the company default).
 */
export const listBrands = <ThrowOnError extends boolean = false>(options?: Options<ListBrandsData, ThrowOnError>): RequestResult<ListBrandsResponses, ListBrandsErrors, ThrowOnError> => (options?.client ?? client).get<ListBrandsResponses, ListBrandsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListBrandsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brands',
    ...options
});

/**
 * Create Brand
 *
 * Create a brand owned (admin) by the caller.
 */
export const createBrand = <ThrowOnError extends boolean = false>(options: Options<CreateBrandData, ThrowOnError>): RequestResult<CreateBrandResponses, CreateBrandErrors, ThrowOnError> => (options.client ?? client).post<CreateBrandResponses, CreateBrandErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateBrandResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brands',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Extract Brand
 *
 * Extract a draft brand kit + logo candidates from a guidelines document.
 *
 * Non-persisting: returns a draft for the user to review/edit before saving
 * via the normal create/update endpoints. Any authenticated user may extract;
 * saving still enforces brand permissions. No DB session is held during the
 * (potentially slow) document parse + LLM call.
 */
export const extractBrand = <ThrowOnError extends boolean = false>(options: Options<ExtractBrandData, ThrowOnError>): RequestResult<ExtractBrandResponses, ExtractBrandErrors, ThrowOnError> => (options.client ?? client).post<ExtractBrandResponses, ExtractBrandErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zExtractBrandResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brands/extract',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete Brand
 *
 * Soft-delete a brand (admin only). The company default is protected.
 */
export const deleteBrand = <ThrowOnError extends boolean = false>(options: Options<DeleteBrandData, ThrowOnError>): RequestResult<DeleteBrandResponses, DeleteBrandErrors, ThrowOnError> => (options.client ?? client).delete<DeleteBrandResponses, DeleteBrandErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteBrandResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brands/{brand_uuid}',
    ...options
});

/**
 * Get Brand
 *
 * Get a single brand.
 */
export const getBrand = <ThrowOnError extends boolean = false>(options: Options<GetBrandData, ThrowOnError>): RequestResult<GetBrandResponses, GetBrandErrors, ThrowOnError> => (options.client ?? client).get<GetBrandResponses, GetBrandErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetBrandResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brands/{brand_uuid}',
    ...options
});

/**
 * Update Brand
 *
 * Update a brand's metadata/tokens (editor+ only).
 */
export const updateBrand = <ThrowOnError extends boolean = false>(options: Options<UpdateBrandData, ThrowOnError>): RequestResult<UpdateBrandResponses, UpdateBrandErrors, ThrowOnError> => (options.client ?? client).put<UpdateBrandResponses, UpdateBrandErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateBrandResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brands/{brand_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Brand Logo
 *
 * Upload/replace a brand's logo image (editor+ only).
 *
 * Session-per-phase: authz runs on the request session, the blob upload
 * happens after that session is out of scope, and persistence uses a fresh
 * short-lived session — no pooled connection is held during the Blob call.
 */
export const uploadBrandLogo = <ThrowOnError extends boolean = false>(options: Options<UploadBrandLogoData, ThrowOnError>): RequestResult<UploadBrandLogoResponses, UploadBrandLogoErrors, ThrowOnError> => (options.client ?? client).post<UploadBrandLogoResponses, UploadBrandLogoErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zUploadBrandLogoResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brands/{brand_uuid}/logo',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get Brand Members
 *
 * List a brand's members (viewer+).
 */
export const getBrandMembers = <ThrowOnError extends boolean = false>(options: Options<GetBrandMembersData, ThrowOnError>): RequestResult<GetBrandMembersResponses, GetBrandMembersErrors, ThrowOnError> => (options.client ?? client).get<GetBrandMembersResponses, GetBrandMembersErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetBrandMembersResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brands/{brand_uuid}/members',
    ...options
});

/**
 * Add Brand Team Member
 *
 * Grant a team a role on a brand (admin only).
 */
export const addBrandTeamMember = <ThrowOnError extends boolean = false>(options: Options<AddBrandTeamMemberData, ThrowOnError>): RequestResult<AddBrandTeamMemberResponses, AddBrandTeamMemberErrors, ThrowOnError> => (options.client ?? client).post<AddBrandTeamMemberResponses, AddBrandTeamMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zAddBrandTeamMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brands/{brand_uuid}/members/teams',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Brand Team Member
 *
 * Remove a team member (admin only; never the last admin).
 */
export const removeBrandTeamMember = <ThrowOnError extends boolean = false>(options: Options<RemoveBrandTeamMemberData, ThrowOnError>): RequestResult<RemoveBrandTeamMemberResponses, RemoveBrandTeamMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveBrandTeamMemberResponses, RemoveBrandTeamMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zRemoveBrandTeamMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brands/{brand_uuid}/members/teams/{team_uuid}',
    ...options
});

/**
 * Update Brand Team Member
 *
 * Change a team member's role (admin only).
 */
export const updateBrandTeamMember = <ThrowOnError extends boolean = false>(options: Options<UpdateBrandTeamMemberData, ThrowOnError>): RequestResult<UpdateBrandTeamMemberResponses, UpdateBrandTeamMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateBrandTeamMemberResponses, UpdateBrandTeamMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateBrandTeamMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brands/{brand_uuid}/members/teams/{team_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add Brand User Member
 *
 * Grant a user a role on a brand (admin only).
 */
export const addBrandUserMember = <ThrowOnError extends boolean = false>(options: Options<AddBrandUserMemberData, ThrowOnError>): RequestResult<AddBrandUserMemberResponses, AddBrandUserMemberErrors, ThrowOnError> => (options.client ?? client).post<AddBrandUserMemberResponses, AddBrandUserMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zAddBrandUserMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brands/{brand_uuid}/members/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Brand User Member
 *
 * Remove a user member (admin only; never the last admin).
 */
export const removeBrandUserMember = <ThrowOnError extends boolean = false>(options: Options<RemoveBrandUserMemberData, ThrowOnError>): RequestResult<RemoveBrandUserMemberResponses, RemoveBrandUserMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveBrandUserMemberResponses, RemoveBrandUserMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zRemoveBrandUserMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brands/{brand_uuid}/members/users/{user_uuid}',
    ...options
});

/**
 * Update Brand User Member
 *
 * Change a user member's role (admin only).
 */
export const updateBrandUserMember = <ThrowOnError extends boolean = false>(options: Options<UpdateBrandUserMemberData, ThrowOnError>): RequestResult<UpdateBrandUserMemberResponses, UpdateBrandUserMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateBrandUserMemberResponses, UpdateBrandUserMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateBrandUserMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brands/{brand_uuid}/members/users/{user_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Brand Templates
 *
 * List a brand's templates (viewer+).
 */
export const listBrandTemplates = <ThrowOnError extends boolean = false>(options: Options<ListBrandTemplatesData, ThrowOnError>): RequestResult<ListBrandTemplatesResponses, ListBrandTemplatesErrors, ThrowOnError> => (options.client ?? client).get<ListBrandTemplatesResponses, ListBrandTemplatesErrors, ThrowOnError>({
    responseValidator: async (data) => await zListBrandTemplatesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brands/{brand_uuid}/templates',
    ...options
});

/**
 * Delete Brand Template
 *
 * Remove the brand's template for one format (editor+ only).
 */
export const deleteBrandTemplate = <ThrowOnError extends boolean = false>(options: Options<DeleteBrandTemplateData, ThrowOnError>): RequestResult<DeleteBrandTemplateResponses, DeleteBrandTemplateErrors, ThrowOnError> => (options.client ?? client).delete<DeleteBrandTemplateResponses, DeleteBrandTemplateErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteBrandTemplateResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brands/{brand_uuid}/templates/{template_format}',
    ...options
});

/**
 * Upload Brand Template
 *
 * Upload or replace the brand's template for one format (editor+ only).
 *
 * The file must be a real Office package of that format with no macros, ActiveX or embedded
 * objects. A .potx/.dotx/.xltx is stored as a .pptx/.docx/.xlsx. Session-per-phase like the logo upload.
 */
export const uploadBrandTemplate = <ThrowOnError extends boolean = false>(options: Options<UploadBrandTemplateData, ThrowOnError>): RequestResult<UploadBrandTemplateResponses, UploadBrandTemplateErrors, ThrowOnError> => (options.client ?? client).put<UploadBrandTemplateResponses, UploadBrandTemplateErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zUploadBrandTemplateResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brands/{brand_uuid}/templates/{template_format}',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Download Brand Template
 *
 * Download the brand's template for one format (viewer+).
 */
export const downloadBrandTemplate = <ThrowOnError extends boolean = false>(options: Options<DownloadBrandTemplateData, ThrowOnError>): RequestResult<DownloadBrandTemplateResponses, DownloadBrandTemplateErrors, ThrowOnError> => (options.client ?? client).get<DownloadBrandTemplateResponses, DownloadBrandTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brands/{brand_uuid}/templates/{template_format}/file',
    ...options
});

/**
 * Get Brand Template Thumbnail
 *
 * The preview image embedded in the template, when it has one (viewer+).
 */
export const getBrandTemplateThumbnail = <ThrowOnError extends boolean = false>(options: Options<GetBrandTemplateThumbnailData, ThrowOnError>): RequestResult<GetBrandTemplateThumbnailResponses, GetBrandTemplateThumbnailErrors, ThrowOnError> => (options.client ?? client).get<GetBrandTemplateThumbnailResponses, GetBrandTemplateThumbnailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brands/{brand_uuid}/templates/{template_format}/thumbnail',
    ...options
});

/**
 * List Message Attachments
 *
 * One page of a message's attachments (its own files, then files it references), for long histories.
 */
export const listMessageAttachments = <ThrowOnError extends boolean = false>(options: Options<ListMessageAttachmentsData, ThrowOnError>): RequestResult<ListMessageAttachmentsResponses, ListMessageAttachmentsErrors, ThrowOnError> => (options.client ?? client).get<ListMessageAttachmentsResponses, ListMessageAttachmentsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListMessageAttachmentsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/chat-files/messages/{message_uuid}/attachments',
    ...options
});

/**
 * Attachment Status
 *
 * Authoritative lifecycle/capabilities/state_version from canonical state (no runtime call).
 */
export const attachmentStatus = <ThrowOnError extends boolean = false>(options: Options<AttachmentStatusData, ThrowOnError>): RequestResult<AttachmentStatusResponses, unknown, ThrowOnError> => (options.client ?? client).post<AttachmentStatusResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zAttachmentStatusResponse2.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/chat-files/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Attachment Limits
 *
 * Size, type and count limits for chat attachment uploads.
 *
 * Clients check files against these before uploading; the upload endpoint
 * enforces the same limits (413 ``file_too_large``, 415
 * ``unsupported_file_type``, 400 ``too_many_files``).
 */
export const getAttachmentLimits = <ThrowOnError extends boolean = false>(options?: Options<GetAttachmentLimitsData, ThrowOnError>): RequestResult<GetAttachmentLimitsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAttachmentLimitsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zGetAttachmentLimitsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/chat/attachment-limits',
    ...options
});

/**
 * List Sessions
 *
 * List user's chat sessions.
 *
 * Sessions are ordered by most recently updated first.
 */
export const chatListSessions = <ThrowOnError extends boolean = false>(options?: Options<ChatListSessionsData, ThrowOnError>): RequestResult<ChatListSessionsResponses, ChatListSessionsErrors, ThrowOnError> => (options?.client ?? client).get<ChatListSessionsResponses, ChatListSessionsErrors, ThrowOnError>({
    responseValidator: async (data) => await zChatListSessionsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/chat/sessions',
    ...options
});

/**
 * Create Session
 *
 * Create a new chat session. With ``spaceUuid`` the chat starts in that
 * space; any member (viewer+) can, since asking questions is what viewers do.
 * The chat is the caller's own; changing the space still needs editor.
 */
export const chatCreateSession = <ThrowOnError extends boolean = false>(options: Options<ChatCreateSessionData, ThrowOnError>): RequestResult<ChatCreateSessionResponses, ChatCreateSessionErrors, ThrowOnError> => (options.client ?? client).post<ChatCreateSessionResponses, ChatCreateSessionErrors, ThrowOnError>({
    responseValidator: async (data) => await zChatCreateSessionResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/chat/sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Edit With Ai
 *
 * The chat to edit a Build entity in (MHS-733): the chat that built it when it is yours, otherwise a new
 * build chat opened for it. Needs edit access to the entity.
 */
export const editWithAi = <ThrowOnError extends boolean = false>(options: Options<EditWithAiData, ThrowOnError>): RequestResult<EditWithAiResponses, EditWithAiErrors, ThrowOnError> => (options.client ?? client).post<EditWithAiResponses, EditWithAiErrors, ThrowOnError>({
    responseValidator: async (data) => await zEditWithAiResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/chat/sessions/edit-with-ai',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Session
 *
 * Delete a chat session (soft delete).
 */
export const chatDeleteSession = <ThrowOnError extends boolean = false>(options: Options<ChatDeleteSessionData, ThrowOnError>): RequestResult<ChatDeleteSessionResponses, ChatDeleteSessionErrors, ThrowOnError> => (options.client ?? client).delete<ChatDeleteSessionResponses, ChatDeleteSessionErrors, ThrowOnError>({
    responseValidator: async (data) => await zChatDeleteSessionResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/chat/sessions/{session_uuid}',
    ...options
});

/**
 * Get Session
 *
 * Get chat session with messages (``attachmentsLimit`` pages each message's attachments).
 */
export const chatGetSession = <ThrowOnError extends boolean = false>(options: Options<ChatGetSessionData, ThrowOnError>): RequestResult<ChatGetSessionResponses, ChatGetSessionErrors, ThrowOnError> => (options.client ?? client).get<ChatGetSessionResponses, ChatGetSessionErrors, ThrowOnError>({
    responseValidator: async (data) => await zChatGetSessionResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/chat/sessions/{session_uuid}',
    ...options
});

/**
 * Update Session
 *
 * Update a chat session (title, starred status, reasoning effort).
 */
export const chatUpdateSession = <ThrowOnError extends boolean = false>(options: Options<ChatUpdateSessionData, ThrowOnError>): RequestResult<ChatUpdateSessionResponses, ChatUpdateSessionErrors, ThrowOnError> => (options.client ?? client).patch<ChatUpdateSessionResponses, ChatUpdateSessionErrors, ThrowOnError>({
    responseValidator: async (data) => await zChatUpdateSessionResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/chat/sessions/{session_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Attachments
 *
 * Upload file attachments (images or documents) for a chat session.
 *
 * Files are stored in blob storage and can later be associated with a
 * message when the user sends their prompt. Returns a list of attachment
 * UUIDs that the frontend should include in the message request.
 *
 * Supported types and size limits: ``GET /chat/attachment-limits``.
 *
 * At most ten files per request: clients queue larger selections over several requests.
 *
 * Uses session-per-phase: validates with request session, uploads to blob
 * with no DB held, then persists records in a fresh short-lived session.
 * Files are streamed to storage in bounded chunks and classified legacy-unverified (MHS-646). With the file
 * pipeline on, checking them starts before the response (a short bounded wait, no DB held), so a client can wait
 * for them to be ready and they're usually ready by the message that uses them. Best effort: a file left
 * legacy-unverified (no preparation capacity free) is checked on first use instead.
 */
export const chatUploadAttachments = <ThrowOnError extends boolean = false>(options: Options<ChatUploadAttachmentsData, ThrowOnError>): RequestResult<ChatUploadAttachmentsResponses, ChatUploadAttachmentsErrors, ThrowOnError> => (options.client ?? client).post<ChatUploadAttachmentsResponses, ChatUploadAttachmentsErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zChatUploadAttachmentsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/chat/sessions/{session_uuid}/attachments',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * List Session Documents
 *
 * List all document lineages for a chat session.
 *
 * Returns one entry per unique document (canonical filename) with the
 * full version history embedded.  Only sessions with at least one
 * tracked document version will have lineage records.
 */
export const listSessionDocuments = <ThrowOnError extends boolean = false>(options: Options<ListSessionDocumentsData, ThrowOnError>): RequestResult<ListSessionDocumentsResponses, ListSessionDocumentsErrors, ThrowOnError> => (options.client ?? client).get<ListSessionDocumentsResponses, ListSessionDocumentsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListSessionDocumentsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/chat/sessions/{session_uuid}/documents',
    ...options
});

/**
 * Mark Draft Applied
 *
 * Record that a draft card created or saved its entity (MHS-733), so the card says so after a reload.
 *
 * The chat's owner only: its cards are read-only for anyone else.
 */
export const markDraftApplied = <ThrowOnError extends boolean = false>(options: Options<MarkDraftAppliedData, ThrowOnError>): RequestResult<MarkDraftAppliedResponses, MarkDraftAppliedErrors, ThrowOnError> => (options.client ?? client).patch<MarkDraftAppliedResponses, MarkDraftAppliedErrors, ThrowOnError>({
    responseValidator: async (data) => await zMarkDraftAppliedResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/chat/sessions/{session_uuid}/drafts/{draft_id}/applied',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fork Session
 *
 * Fork a shared chat session into the current user's own session.
 *
 * Copies the session and all its messages. The new session is owned
 * by the current user and is independent of the original.
 */
export const forkSession = <ThrowOnError extends boolean = false>(options: Options<ForkSessionData, ThrowOnError>): RequestResult<ForkSessionResponses, ForkSessionErrors, ThrowOnError> => (options.client ?? client).post<ForkSessionResponses, ForkSessionErrors, ThrowOnError>({
    responseValidator: async (data) => await zForkSessionResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/chat/sessions/{session_uuid}/fork',
    ...options
});

/**
 * List Messages
 *
 * Get all messages for a chat session (``attachmentsLimit`` pages each message's attachments).
 */
export const listMessages = <ThrowOnError extends boolean = false>(options: Options<ListMessagesData, ThrowOnError>): RequestResult<ListMessagesResponses, ListMessagesErrors, ThrowOnError> => (options.client ?? client).get<ListMessagesResponses, ListMessagesErrors, ThrowOnError>({
    responseValidator: async (data) => await zListMessagesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/chat/sessions/{session_uuid}/messages',
    ...options
});

/**
 * Stream Message
 *
 * Send a message and stream the AI response via OperationManager.
 *
 * Returns ``{"operation_id": "..."}`` immediately (HTTP 202).
 * The actual LLM streaming runs as a background ``asyncio.Task``.
 * Subscribe to progress via ``GET /api/v1/operations/{operation_id}/stream``.
 *
 * Event types emitted to the operation stream:
 * - message_start: Stream has started
 * - content_delta: A content chunk from the AI
 * - tool_start / tool_end: Tool execution lifecycle
 * - message_end: Stream has completed
 * - error: An error occurred
 */
export const chatStreamMessage = <ThrowOnError extends boolean = false>(options: Options<ChatStreamMessageData, ThrowOnError>): RequestResult<ChatStreamMessageResponses, ChatStreamMessageErrors, ThrowOnError> => (options.client ?? client).post<ChatStreamMessageResponses, ChatStreamMessageErrors, ThrowOnError>({
    responseValidator: async (data) => await zChatStreamMessageResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/chat/sessions/{session_uuid}/messages/stream',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Session Sharing
 *
 * Get all shares and share links for a session.
 */
export const chatGetSessionSharing = <ThrowOnError extends boolean = false>(options: Options<ChatGetSessionSharingData, ThrowOnError>): RequestResult<ChatGetSessionSharingResponses, ChatGetSessionSharingErrors, ThrowOnError> => (options.client ?? client).get<ChatGetSessionSharingResponses, ChatGetSessionSharingErrors, ThrowOnError>({
    responseValidator: async (data) => await zChatGetSessionSharingResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/chat/sessions/{session_uuid}/sharing',
    ...options
});

/**
 * Create Share Link
 *
 * Create a shareable link for a chat session.
 */
export const chatCreateShareLink = <ThrowOnError extends boolean = false>(options: Options<ChatCreateShareLinkData, ThrowOnError>): RequestResult<ChatCreateShareLinkResponses, ChatCreateShareLinkErrors, ThrowOnError> => (options.client ?? client).post<ChatCreateShareLinkResponses, ChatCreateShareLinkErrors, ThrowOnError>({
    responseValidator: async (data) => await zChatCreateShareLinkResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/chat/sessions/{session_uuid}/sharing/link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deactivate Share Link
 *
 * Deactivate a share link.
 */
export const chatDeactivateShareLink = <ThrowOnError extends boolean = false>(options: Options<ChatDeactivateShareLinkData, ThrowOnError>): RequestResult<ChatDeactivateShareLinkResponses, ChatDeactivateShareLinkErrors, ThrowOnError> => (options.client ?? client).delete<ChatDeactivateShareLinkResponses, ChatDeactivateShareLinkErrors, ThrowOnError>({
    responseValidator: async (data) => await zChatDeactivateShareLinkResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/chat/sessions/{session_uuid}/sharing/link/{link_uuid}',
    ...options
});

/**
 * Set Session Space Share
 *
 * Share the chat read-only with everyone in its space, or stop (owner only).
 *
 * Members, including people who join later, can read and fork it.
 */
export const setSessionSpaceShare = <ThrowOnError extends boolean = false>(options: Options<SetSessionSpaceShareData, ThrowOnError>): RequestResult<SetSessionSpaceShareResponses, SetSessionSpaceShareErrors, ThrowOnError> => (options.client ?? client).put<SetSessionSpaceShareResponses, SetSessionSpaceShareErrors, ThrowOnError>({
    responseValidator: async (data) => await zSetSessionSpaceShareResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/chat/sessions/{session_uuid}/sharing/space',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Share With User
 *
 * Share a chat session with a specific user.
 */
export const chatShareWithUser = <ThrowOnError extends boolean = false>(options: Options<ChatShareWithUserData, ThrowOnError>): RequestResult<ChatShareWithUserResponses, ChatShareWithUserErrors, ThrowOnError> => (options.client ?? client).post<ChatShareWithUserResponses, ChatShareWithUserErrors, ThrowOnError>({
    responseValidator: async (data) => await zChatShareWithUserResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/chat/sessions/{session_uuid}/sharing/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Share
 *
 * Remove a direct share from a chat session.
 */
export const chatRemoveShare = <ThrowOnError extends boolean = false>(options: Options<ChatRemoveShareData, ThrowOnError>): RequestResult<ChatRemoveShareResponses, ChatRemoveShareErrors, ThrowOnError> => (options.client ?? client).delete<ChatRemoveShareResponses, ChatRemoveShareErrors, ThrowOnError>({
    responseValidator: async (data) => await zChatRemoveShareResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/chat/sessions/{session_uuid}/sharing/users/{user_uuid}',
    ...options
});

/**
 * List Shared With Me
 *
 * List all chat sessions shared with the current user.
 */
export const chatListSharedWithMe = <ThrowOnError extends boolean = false>(options?: Options<ChatListSharedWithMeData, ThrowOnError>): RequestResult<ChatListSharedWithMeResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ChatListSharedWithMeResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zChatListSharedWithMeResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/chat/shared-with-me',
    ...options
});

/**
 * Access Share Link
 *
 * Access a chat session via a share link token.
 */
export const chatAccessShareLink = <ThrowOnError extends boolean = false>(options: Options<ChatAccessShareLinkData, ThrowOnError>): RequestResult<ChatAccessShareLinkResponses, ChatAccessShareLinkErrors, ThrowOnError> => (options.client ?? client).get<ChatAccessShareLinkResponses, ChatAccessShareLinkErrors, ThrowOnError>({
    responseValidator: async (data) => await zChatAccessShareLinkResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/chat/shared/{token}',
    ...options
});

/**
 * List Connectors
 *
 * Connectors I can use (all of them for platform admins).
 */
export const listConnectors = <ThrowOnError extends boolean = false>(options?: Options<ListConnectorsData, ThrowOnError>): RequestResult<ListConnectorsResponses, ListConnectorsErrors, ThrowOnError> => (options?.client ?? client).get<ListConnectorsResponses, ListConnectorsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListConnectorsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors',
    ...options
});

/**
 * Create Connector
 *
 * Add an MCP server or HTTP endpoint. I become its admin.
 */
export const createConnector = <ThrowOnError extends boolean = false>(options: Options<CreateConnectorData, ThrowOnError>): RequestResult<CreateConnectorResponses, CreateConnectorErrors, ThrowOnError> => (options.client ?? client).post<CreateConnectorResponses, CreateConnectorErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateConnectorResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Connector From Template
 *
 * Add a connector from a template with my key: finds its tools, keeps it read-only if asked, and can
 * add the template's starter skill (mine, to attach in a space).
 */
export const createConnectorFromTemplate = <ThrowOnError extends boolean = false>(options: Options<CreateConnectorFromTemplateData, ThrowOnError>): RequestResult<CreateConnectorFromTemplateResponses, CreateConnectorFromTemplateErrors, ThrowOnError> => (options.client ?? client).post<CreateConnectorFromTemplateResponses, CreateConnectorFromTemplateErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateConnectorFromTemplateResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors/from-template',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Connector Instance
 *
 * Add my own connector for an integration (e.g. our team's HubSpot), with my key. I become its admin.
 */
export const createConnectorInstance = <ThrowOnError extends boolean = false>(options: Options<CreateConnectorInstanceData, ThrowOnError>): RequestResult<CreateConnectorInstanceResponses, CreateConnectorInstanceErrors, ThrowOnError> => (options.client ?? client).post<CreateConnectorInstanceResponses, CreateConnectorInstanceErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateConnectorInstanceResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors/instances',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Connector Integrations
 *
 * Integrations I can add my own connector for, with my own key (HubSpot, Slack, SQL...).
 */
export const listConnectorIntegrations = <ThrowOnError extends boolean = false>(options?: Options<ListConnectorIntegrationsData, ThrowOnError>): RequestResult<ListConnectorIntegrationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListConnectorIntegrationsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zListConnectorIntegrationsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors/integrations',
    ...options
});

/**
 * List My Connector Connections
 *
 * Connectors I can use that need my own token, and whether I've added it (Settings > Connections).
 *
 * Uses my own grants only (a platform admin's see-everything bypass doesn't apply), like chat does.
 */
export const listMyConnectorConnections = <ThrowOnError extends boolean = false>(options?: Options<ListMyConnectorConnectionsData, ThrowOnError>): RequestResult<ListMyConnectorConnectionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListMyConnectorConnectionsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zListMyConnectorConnectionsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors/my-connections',
    ...options
});

/**
 * Get Connector Policy
 *
 * The organization's connector rules, so the app can explain them (anyone).
 */
export const getConnectorPolicy = <ThrowOnError extends boolean = false>(options?: Options<GetConnectorPolicyData, ThrowOnError>): RequestResult<GetConnectorPolicyResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetConnectorPolicyResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zGetConnectorPolicyResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors/policy',
    ...options
});

/**
 * List Connector Templates
 *
 * Known servers (GitHub, Linear, ...) you can connect in one step, with their setup guides (MHS-875).
 */
export const listConnectorTemplates = <ThrowOnError extends boolean = false>(options?: Options<ListConnectorTemplatesData, ThrowOnError>): RequestResult<ListConnectorTemplatesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListConnectorTemplatesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zListConnectorTemplatesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors/templates',
    ...options
});

/**
 * Delete Connector
 *
 * Delete (admin).
 */
export const deleteConnector = <ThrowOnError extends boolean = false>(options: Options<DeleteConnectorData, ThrowOnError>): RequestResult<DeleteConnectorResponses, DeleteConnectorErrors, ThrowOnError> => (options.client ?? client).delete<DeleteConnectorResponses, DeleteConnectorErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteConnectorResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors/{connector_uuid}',
    ...options
});

/**
 * Get Connector Detail
 *
 * A connector's settings (viewer+). Never its secrets.
 */
export const getConnectorDetail = <ThrowOnError extends boolean = false>(options: Options<GetConnectorDetailData, ThrowOnError>): RequestResult<GetConnectorDetailResponses, GetConnectorDetailErrors, ThrowOnError> => (options.client ?? client).get<GetConnectorDetailResponses, GetConnectorDetailErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetConnectorDetailResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors/{connector_uuid}',
    ...options
});

/**
 * Update Connector
 *
 * Change settings (editor+).
 */
export const updateConnector = <ThrowOnError extends boolean = false>(options: Options<UpdateConnectorData, ThrowOnError>): RequestResult<UpdateConnectorResponses, UpdateConnectorErrors, ThrowOnError> => (options.client ?? client).patch<UpdateConnectorResponses, UpdateConnectorErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateConnectorResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors/{connector_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Connector Members
 *
 * Who can use a connector (viewer+).
 */
export const getConnectorMembers = <ThrowOnError extends boolean = false>(options: Options<GetConnectorMembersData, ThrowOnError>): RequestResult<GetConnectorMembersResponses, GetConnectorMembersErrors, ThrowOnError> => (options.client ?? client).get<GetConnectorMembersResponses, GetConnectorMembersErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetConnectorMembersResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors/{connector_uuid}/members',
    ...options
});

/**
 * Add Connector Team Member
 *
 * Grant a team a role (admin only).
 */
export const addConnectorTeamMember = <ThrowOnError extends boolean = false>(options: Options<AddConnectorTeamMemberData, ThrowOnError>): RequestResult<AddConnectorTeamMemberResponses, AddConnectorTeamMemberErrors, ThrowOnError> => (options.client ?? client).post<AddConnectorTeamMemberResponses, AddConnectorTeamMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zAddConnectorTeamMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors/{connector_uuid}/members/teams',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Connector Team Member
 *
 * Remove a team member (admin only; never the last admin).
 */
export const removeConnectorTeamMember = <ThrowOnError extends boolean = false>(options: Options<RemoveConnectorTeamMemberData, ThrowOnError>): RequestResult<RemoveConnectorTeamMemberResponses, RemoveConnectorTeamMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveConnectorTeamMemberResponses, RemoveConnectorTeamMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zRemoveConnectorTeamMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors/{connector_uuid}/members/teams/{team_uuid}',
    ...options
});

/**
 * Update Connector Team Member
 *
 * Change a team member's role (admin only).
 */
export const updateConnectorTeamMember = <ThrowOnError extends boolean = false>(options: Options<UpdateConnectorTeamMemberData, ThrowOnError>): RequestResult<UpdateConnectorTeamMemberResponses, UpdateConnectorTeamMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateConnectorTeamMemberResponses, UpdateConnectorTeamMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateConnectorTeamMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors/{connector_uuid}/members/teams/{team_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add Connector User Member
 *
 * Grant a user a role (admin only).
 */
export const addConnectorUserMember = <ThrowOnError extends boolean = false>(options: Options<AddConnectorUserMemberData, ThrowOnError>): RequestResult<AddConnectorUserMemberResponses, AddConnectorUserMemberErrors, ThrowOnError> => (options.client ?? client).post<AddConnectorUserMemberResponses, AddConnectorUserMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zAddConnectorUserMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors/{connector_uuid}/members/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Connector User Member
 *
 * Remove a user member (admin only; never the last admin).
 */
export const removeConnectorUserMember = <ThrowOnError extends boolean = false>(options: Options<RemoveConnectorUserMemberData, ThrowOnError>): RequestResult<RemoveConnectorUserMemberResponses, RemoveConnectorUserMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveConnectorUserMemberResponses, RemoveConnectorUserMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zRemoveConnectorUserMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors/{connector_uuid}/members/users/{user_uuid}',
    ...options
});

/**
 * Update Connector User Member
 *
 * Change a user member's role (admin only).
 */
export const updateConnectorUserMember = <ThrowOnError extends boolean = false>(options: Options<UpdateConnectorUserMemberData, ThrowOnError>): RequestResult<UpdateConnectorUserMemberResponses, UpdateConnectorUserMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateConnectorUserMemberResponses, UpdateConnectorUserMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateConnectorUserMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors/{connector_uuid}/members/users/{user_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clear My Connector Credential
 *
 * Remove my own token.
 */
export const clearMyConnectorCredential = <ThrowOnError extends boolean = false>(options: Options<ClearMyConnectorCredentialData, ThrowOnError>): RequestResult<ClearMyConnectorCredentialResponses, ClearMyConnectorCredentialErrors, ThrowOnError> => (options.client ?? client).delete<ClearMyConnectorCredentialResponses, ClearMyConnectorCredentialErrors, ThrowOnError>({
    responseValidator: async (data) => await zClearMyConnectorCredentialResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors/{connector_uuid}/my-credential',
    ...options
});

/**
 * Set My Connector Credential
 *
 * Add or replace my own token for a per-user connector (anyone who can use it). Never returned.
 */
export const setMyConnectorCredential = <ThrowOnError extends boolean = false>(options: Options<SetMyConnectorCredentialData, ThrowOnError>): RequestResult<SetMyConnectorCredentialResponses, SetMyConnectorCredentialErrors, ThrowOnError> => (options.client ?? client).put<SetMyConnectorCredentialResponses, SetMyConnectorCredentialErrors, ThrowOnError>({
    responseValidator: async (data) => await zSetMyConnectorCredentialResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors/{connector_uuid}/my-credential',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Connector Oauth
 *
 * Start signing in to the connector's server as me; the browser then goes to ``authorizeUrl``.
 */
export const startConnectorOauth = <ThrowOnError extends boolean = false>(options: Options<StartConnectorOauthData, ThrowOnError>): RequestResult<StartConnectorOauthResponses, StartConnectorOauthErrors, ThrowOnError> => (options.client ?? client).post<StartConnectorOauthResponses, StartConnectorOauthErrors, ThrowOnError>({
    responseValidator: async (data) => await zStartConnectorOauthResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors/{connector_uuid}/oauth/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Refresh Connector Tools
 *
 * Ask the server again what it offers (editor+). 502 with the reason if it can't be reached.
 */
export const refreshConnectorTools = <ThrowOnError extends boolean = false>(options: Options<RefreshConnectorToolsData, ThrowOnError>): RequestResult<RefreshConnectorToolsResponses, RefreshConnectorToolsErrors, ThrowOnError> => (options.client ?? client).post<RefreshConnectorToolsResponses, RefreshConnectorToolsErrors, ThrowOnError>({
    responseValidator: async (data) => await zRefreshConnectorToolsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors/{connector_uuid}/refresh',
    ...options
});

/**
 * Clear Connector Secret
 *
 * Remove the shared secret (admin).
 */
export const clearConnectorSecret = <ThrowOnError extends boolean = false>(options: Options<ClearConnectorSecretData, ThrowOnError>): RequestResult<ClearConnectorSecretResponses, ClearConnectorSecretErrors, ThrowOnError> => (options.client ?? client).delete<ClearConnectorSecretResponses, ClearConnectorSecretErrors, ThrowOnError>({
    responseValidator: async (data) => await zClearConnectorSecretResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors/{connector_uuid}/secret',
    ...options
});

/**
 * Set Connector Secret
 *
 * Set or replace the shared secret everyone's calls use (admin). Never returned.
 */
export const setConnectorSecret = <ThrowOnError extends boolean = false>(options: Options<SetConnectorSecretData, ThrowOnError>): RequestResult<SetConnectorSecretResponses, SetConnectorSecretErrors, ThrowOnError> => (options.client ?? client).put<SetConnectorSecretResponses, SetConnectorSecretErrors, ThrowOnError>({
    responseValidator: async (data) => await zSetConnectorSecretResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors/{connector_uuid}/secret',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Connector Tools
 *
 * The tools a connector offers (viewer+).
 */
export const listConnectorTools = <ThrowOnError extends boolean = false>(options: Options<ListConnectorToolsData, ThrowOnError>): RequestResult<ListConnectorToolsResponses, ListConnectorToolsErrors, ThrowOnError> => (options.client ?? client).get<ListConnectorToolsResponses, ListConnectorToolsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListConnectorToolsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors/{connector_uuid}/tools',
    ...options
});

/**
 * Update Connector Tool
 *
 * Reclassify a tool (reads / acts, asks first or not), turn it off, or reset it (editor+).
 */
export const updateConnectorTool = <ThrowOnError extends boolean = false>(options: Options<UpdateConnectorToolData, ThrowOnError>): RequestResult<UpdateConnectorToolResponses, UpdateConnectorToolErrors, ThrowOnError> => (options.client ?? client).patch<UpdateConnectorToolResponses, UpdateConnectorToolErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateConnectorToolResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/connectors/{connector_uuid}/tools/{tool_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Data Sources
 *
 * List data collections the caller has been granted access to (platform admins see all).
 */
export const listDataSources = <ThrowOnError extends boolean = false>(options?: Options<ListDataSourcesData, ThrowOnError>): RequestResult<ListDataSourcesResponses, ListDataSourcesErrors, ThrowOnError> => (options?.client ?? client).get<ListDataSourcesResponses, ListDataSourcesErrors, ThrowOnError>({
    responseValidator: async (data) => await zListDataSourcesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data-sources',
    ...options
});

/**
 * Create Data Source
 *
 * Create a new data collection.
 *
 * For notes source_type, if content is provided, it will be saved as a
 * markdown file and indexed automatically.
 */
export const createDataSource = <ThrowOnError extends boolean = false>(options: Options<CreateDataSourceData, ThrowOnError>): RequestResult<CreateDataSourceResponses, CreateDataSourceErrors, ThrowOnError> => (options.client ?? client).post<CreateDataSourceResponses, CreateDataSourceErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateDataSourceResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data-sources',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Data Source
 *
 * Delete a data collection (soft delete).
 *
 * Uses session-per-phase: validates with request session, deletes vector
 * store with no DB held, then soft-deletes in a fresh short-lived session.
 */
export const deleteDataSource = <ThrowOnError extends boolean = false>(options: Options<DeleteDataSourceData, ThrowOnError>): RequestResult<DeleteDataSourceResponses, DeleteDataSourceErrors, ThrowOnError> => (options.client ?? client).delete<DeleteDataSourceResponses, DeleteDataSourceErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteDataSourceResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data-sources/{collection_uuid}',
    ...options
});

/**
 * Get Data Source
 *
 * Get data collection details.
 */
export const getDataSource = <ThrowOnError extends boolean = false>(options: Options<GetDataSourceData, ThrowOnError>): RequestResult<GetDataSourceResponses, GetDataSourceErrors, ThrowOnError> => (options.client ?? client).get<GetDataSourceResponses, GetDataSourceErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetDataSourceResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data-sources/{collection_uuid}',
    ...options
});

/**
 * Update Data Source
 *
 * Update a data collection.
 */
export const updateDataSource = <ThrowOnError extends boolean = false>(options: Options<UpdateDataSourceData, ThrowOnError>): RequestResult<UpdateDataSourceResponses, UpdateDataSourceErrors, ThrowOnError> => (options.client ?? client).put<UpdateDataSourceResponses, UpdateDataSourceErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateDataSourceResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data-sources/{collection_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Files
 *
 * Upload files to a data collection.
 *
 * Files are stored in Azure Blob Storage and metadata is saved to the database.
 *
 * Uses session-per-phase: validates with request session, uploads to blob
 * with no DB held, then persists records in a fresh short-lived session.
 */
export const uploadFiles = <ThrowOnError extends boolean = false>(options: Options<UploadFilesData, ThrowOnError>): RequestResult<UploadFilesResponses, UploadFilesErrors, ThrowOnError> => (options.client ?? client).post<UploadFilesResponses, UploadFilesErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zUploadFilesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data-sources/{collection_uuid}/files',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete File
 *
 * Delete a file from a data collection.
 *
 * Uses session-per-phase: validates with request session, deletes from blob
 * and vector store with no DB held, then deletes record in fresh session.
 */
export const deleteFile = <ThrowOnError extends boolean = false>(options: Options<DeleteFileData, ThrowOnError>): RequestResult<DeleteFileResponses, DeleteFileErrors, ThrowOnError> => (options.client ?? client).delete<DeleteFileResponses, DeleteFileErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteFileResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data-sources/{collection_uuid}/files/{file_uuid}',
    ...options
});

/**
 * Get File Download Url
 *
 * Generate a temporary download URL (SAS token) for a file.
 *
 * The URL is valid for the specified number of hours (default 1 hour).
 */
export const getFileDownloadUrl = <ThrowOnError extends boolean = false>(options: Options<GetFileDownloadUrlData, ThrowOnError>): RequestResult<GetFileDownloadUrlResponses, GetFileDownloadUrlErrors, ThrowOnError> => (options.client ?? client).get<GetFileDownloadUrlResponses, GetFileDownloadUrlErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetFileDownloadUrlResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data-sources/{collection_uuid}/files/{file_uuid}/download',
    ...options
});

/**
 * Get File Markdown
 *
 * Extract and return the AI-ready markdown version of a file.
 *
 * Downloads the file from blob storage, runs it through the text extraction
 * pipeline (same as indexing), and returns the resulting markdown.
 */
export const getFileMarkdown = <ThrowOnError extends boolean = false>(options: Options<GetFileMarkdownData, ThrowOnError>): RequestResult<GetFileMarkdownResponses, GetFileMarkdownErrors, ThrowOnError> => (options.client ?? client).get<GetFileMarkdownResponses, GetFileMarkdownErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data-sources/{collection_uuid}/files/{file_uuid}/markdown',
    ...options
});

/**
 * Get Data Source Members
 *
 * List who has access to a data source (viewer+).
 */
export const getDataSourceMembers = <ThrowOnError extends boolean = false>(options: Options<GetDataSourceMembersData, ThrowOnError>): RequestResult<GetDataSourceMembersResponses, GetDataSourceMembersErrors, ThrowOnError> => (options.client ?? client).get<GetDataSourceMembersResponses, GetDataSourceMembersErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetDataSourceMembersResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data-sources/{collection_uuid}/members',
    ...options
});

/**
 * Add Data Source Team Member
 *
 * Grant a team a role on a data source (admin only).
 */
export const addDataSourceTeamMember = <ThrowOnError extends boolean = false>(options: Options<AddDataSourceTeamMemberData, ThrowOnError>): RequestResult<AddDataSourceTeamMemberResponses, AddDataSourceTeamMemberErrors, ThrowOnError> => (options.client ?? client).post<AddDataSourceTeamMemberResponses, AddDataSourceTeamMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zAddDataSourceTeamMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data-sources/{collection_uuid}/members/teams',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Data Source Team Member
 *
 * Remove a team member (admin only; never the last admin).
 */
export const removeDataSourceTeamMember = <ThrowOnError extends boolean = false>(options: Options<RemoveDataSourceTeamMemberData, ThrowOnError>): RequestResult<RemoveDataSourceTeamMemberResponses, RemoveDataSourceTeamMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveDataSourceTeamMemberResponses, RemoveDataSourceTeamMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zRemoveDataSourceTeamMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data-sources/{collection_uuid}/members/teams/{team_uuid}',
    ...options
});

/**
 * Update Data Source Team Member
 *
 * Change a team member's role (admin only).
 */
export const updateDataSourceTeamMember = <ThrowOnError extends boolean = false>(options: Options<UpdateDataSourceTeamMemberData, ThrowOnError>): RequestResult<UpdateDataSourceTeamMemberResponses, UpdateDataSourceTeamMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateDataSourceTeamMemberResponses, UpdateDataSourceTeamMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateDataSourceTeamMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data-sources/{collection_uuid}/members/teams/{team_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add Data Source User Member
 *
 * Grant a user a role on a data source (admin only).
 */
export const addDataSourceUserMember = <ThrowOnError extends boolean = false>(options: Options<AddDataSourceUserMemberData, ThrowOnError>): RequestResult<AddDataSourceUserMemberResponses, AddDataSourceUserMemberErrors, ThrowOnError> => (options.client ?? client).post<AddDataSourceUserMemberResponses, AddDataSourceUserMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zAddDataSourceUserMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data-sources/{collection_uuid}/members/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Data Source User Member
 *
 * Remove a user member (admin only; never the last admin).
 */
export const removeDataSourceUserMember = <ThrowOnError extends boolean = false>(options: Options<RemoveDataSourceUserMemberData, ThrowOnError>): RequestResult<RemoveDataSourceUserMemberResponses, RemoveDataSourceUserMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveDataSourceUserMemberResponses, RemoveDataSourceUserMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zRemoveDataSourceUserMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data-sources/{collection_uuid}/members/users/{user_uuid}',
    ...options
});

/**
 * Update Data Source User Member
 *
 * Change a user member's role (admin only).
 */
export const updateDataSourceUserMember = <ThrowOnError extends boolean = false>(options: Options<UpdateDataSourceUserMemberData, ThrowOnError>): RequestResult<UpdateDataSourceUserMemberResponses, UpdateDataSourceUserMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateDataSourceUserMemberResponses, UpdateDataSourceUserMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateDataSourceUserMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data-sources/{collection_uuid}/members/users/{user_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add Note
 *
 * Add a note (ad-hoc text) to a data collection.
 *
 * The note content is saved as a .md file in blob storage and indexed
 * through the normal pipeline. This allows any collection to accept
 * pasted text alongside uploaded files, SharePoint docs, etc.
 *
 * Uses session-per-phase: validates with request session, uploads to
 * blob with no DB held, then persists record in fresh short-lived session.
 */
export const addNote = <ThrowOnError extends boolean = false>(options: Options<AddNoteData, ThrowOnError>): RequestResult<AddNoteResponses, AddNoteErrors, ThrowOnError> => (options.client ?? client).post<AddNoteResponses, AddNoteErrors, ThrowOnError>({
    responseValidator: async (data) => await zAddNoteResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data-sources/{collection_uuid}/notes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Note
 *
 * Update an existing note's content and/or title.
 *
 * Re-uploads the markdown file to blob storage and re-indexes it.
 *
 * Uses session-per-phase: validates with request session, uploads to
 * blob with no DB held, then updates record in fresh short-lived session.
 */
export const updateNote = <ThrowOnError extends boolean = false>(options: Options<UpdateNoteData, ThrowOnError>): RequestResult<UpdateNoteResponses, UpdateNoteErrors, ThrowOnError> => (options.client ?? client).put<UpdateNoteResponses, UpdateNoteErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateNoteResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data-sources/{collection_uuid}/notes/{file_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sync Data Source
 *
 * Trigger sync for a data collection.
 *
 * For file collections, this triggers indexing/embedding of pending files.
 * For website collections, this fetches the URL content first, then indexes.
 * Processing happens in the background.
 *
 * Uses **session-per-phase**: the request-scoped ``session`` is used only
 * for fast validation.  SharePoint Graph API downloads and blob uploads
 * run with no DB connection held, using short-lived ``async_session_maker``
 * sessions for each DB write.
 */
export const syncDataSource = <ThrowOnError extends boolean = false>(options: Options<SyncDataSourceData, ThrowOnError>): RequestResult<SyncDataSourceResponses, SyncDataSourceErrors, ThrowOnError> => (options.client ?? client).post<SyncDataSourceResponses, SyncDataSourceErrors, ThrowOnError>({
    responseValidator: async (data) => await zSyncDataSourceResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data-sources/{collection_uuid}/sync',
    ...options
});

/**
 * Add Website Url
 *
 * Add a website URL to a website-type data collection.
 *
 * The URL is added to the collection's config and immediately synced.
 */
export const addWebsiteUrl = <ThrowOnError extends boolean = false>(options: Options<AddWebsiteUrlData, ThrowOnError>): RequestResult<AddWebsiteUrlResponses, AddWebsiteUrlErrors, ThrowOnError> => (options.client ?? client).post<AddWebsiteUrlResponses, AddWebsiteUrlErrors, ThrowOnError>({
    responseValidator: async (data) => await zAddWebsiteUrlResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data-sources/{collection_uuid}/urls',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Export Capabilities
 *
 * Get available export formats and templates.
 *
 * Returns information about which formats are available (e.g., PDF
 * requires LibreOffice) and available styling templates.
 */
export const getExportCapabilities = <ThrowOnError extends boolean = false>(options?: Options<GetExportCapabilitiesData, ThrowOnError>): RequestResult<GetExportCapabilitiesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetExportCapabilitiesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zGetExportCapabilitiesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/export/capabilities',
    ...options
});

/**
 * List Extensions
 *
 * List all extensions (platform admin only).
 */
export const listExtensions = <ThrowOnError extends boolean = false>(options?: Options<ListExtensionsData, ThrowOnError>): RequestResult<ListExtensionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListExtensionsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zListExtensionsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/extensions',
    ...options
});

/**
 * Get Extension
 *
 * Get full extension detail (platform admin only).
 */
export const getExtension = <ThrowOnError extends boolean = false>(options: Options<GetExtensionData, ThrowOnError>): RequestResult<GetExtensionResponses, GetExtensionErrors, ThrowOnError> => (options.client ?? client).get<GetExtensionResponses, GetExtensionErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetExtensionResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/extensions/{ext_uuid}',
    ...options
});

/**
 * Update Extension
 *
 * Update extension settings (platform admin only).
 *
 * System extensions only allow display_order and config changes.
 */
export const updateExtension = <ThrowOnError extends boolean = false>(options: Options<UpdateExtensionData, ThrowOnError>): RequestResult<UpdateExtensionResponses, UpdateExtensionErrors, ThrowOnError> => (options.client ?? client).put<UpdateExtensionResponses, UpdateExtensionErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateExtensionResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/extensions/{ext_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Credential
 *
 * Set or update a credential value (platform admin only).
 *
 * The value is encrypted before storage using Fernet (AES-128-CBC + HMAC-SHA256).
 */
export const updateCredential = <ThrowOnError extends boolean = false>(options: Options<UpdateCredentialData, ThrowOnError>): RequestResult<UpdateCredentialResponses, UpdateCredentialErrors, ThrowOnError> => (options.client ?? client).put<UpdateCredentialResponses, UpdateCredentialErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateCredentialResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/extensions/{ext_uuid}/credentials',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clear Credential
 *
 * Clear (remove) the stored value for a credential (platform admin only).
 *
 * The credential row remains (so it still shows as a required key) but
 * its encrypted_value is set to NULL, marking it as "not configured".
 */
export const clearCredential = <ThrowOnError extends boolean = false>(options: Options<ClearCredentialData, ThrowOnError>): RequestResult<ClearCredentialResponses, ClearCredentialErrors, ThrowOnError> => (options.client ?? client).delete<ClearCredentialResponses, ClearCredentialErrors, ThrowOnError>({
    responseValidator: async (data) => await zClearCredentialResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/extensions/{ext_uuid}/credentials/{credential_key}',
    ...options
});

/**
 * Update Team Access
 *
 * Set team access for an extension (platform admin only).
 *
 * Replaces the entire access list. An empty list makes the extension global.
 */
export const updateTeamAccess = <ThrowOnError extends boolean = false>(options: Options<UpdateTeamAccessData, ThrowOnError>): RequestResult<UpdateTeamAccessResponses, UpdateTeamAccessErrors, ThrowOnError> => (options.client ?? client).put<UpdateTeamAccessResponses, UpdateTeamAccessErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateTeamAccessResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/extensions/{ext_uuid}/team-access',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Toggle Extension
 *
 * Enable or disable an extension (platform admin only).
 */
export const toggleExtension = <ThrowOnError extends boolean = false>(options: Options<ToggleExtensionData, ThrowOnError>): RequestResult<ToggleExtensionResponses, ToggleExtensionErrors, ThrowOnError> => (options.client ?? client).patch<ToggleExtensionResponses, ToggleExtensionErrors, ThrowOnError>({
    responseValidator: async (data) => await zToggleExtensionResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/extensions/{ext_uuid}/toggle',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List All Feedback
 *
 * List all feedback (admin only).
 */
export const listAllFeedback = <ThrowOnError extends boolean = false>(options?: Options<ListAllFeedbackData, ThrowOnError>): RequestResult<ListAllFeedbackResponses, ListAllFeedbackErrors, ThrowOnError> => (options?.client ?? client).get<ListAllFeedbackResponses, ListAllFeedbackErrors, ThrowOnError>({
    responseValidator: async (data) => await zListAllFeedbackResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/feedback',
    ...options
});

/**
 * Submit Feedback
 *
 * Submit a bug report or feature request, optionally with screenshots.
 */
export const submitFeedback = <ThrowOnError extends boolean = false>(options: Options<SubmitFeedbackData, ThrowOnError>): RequestResult<SubmitFeedbackResponses, SubmitFeedbackErrors, ThrowOnError> => (options.client ?? client).post<SubmitFeedbackResponses, SubmitFeedbackErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zSubmitFeedbackResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/feedback',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get Feedback
 *
 * Get one feedback item (admin only).
 */
export const getFeedback = <ThrowOnError extends boolean = false>(options: Options<GetFeedbackData, ThrowOnError>): RequestResult<GetFeedbackResponses, GetFeedbackErrors, ThrowOnError> => (options.client ?? client).get<GetFeedbackResponses, GetFeedbackErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetFeedbackResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/feedback/{feedback_uuid}',
    ...options
});

/**
 * Update Feedback Status
 *
 * Update the status of a feedback item (admin only).
 */
export const updateFeedbackStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateFeedbackStatusData, ThrowOnError>): RequestResult<UpdateFeedbackStatusResponses, UpdateFeedbackStatusErrors, ThrowOnError> => (options.client ?? client).patch<UpdateFeedbackStatusResponses, UpdateFeedbackStatusErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateFeedbackStatusResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/feedback/{feedback_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Screenshot
 *
 * Stream a feedback screenshot's bytes directly.
 *
 * Works for both local and Azure Blob storage — no SAS URL or
 * file:// path is exposed to the client.
 */
export const downloadScreenshot = <ThrowOnError extends boolean = false>(options: Options<DownloadScreenshotData, ThrowOnError>): RequestResult<DownloadScreenshotResponses, DownloadScreenshotErrors, ThrowOnError> => (options.client ?? client).get<DownloadScreenshotResponses, DownloadScreenshotErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/feedback/{feedback_uuid}/screenshots/{blob_name}',
    ...options
});

/**
 * List Flows
 *
 * List workflows the user holds a grant on (directly or through a team).
 */
export const listFlows = <ThrowOnError extends boolean = false>(options?: Options<ListFlowsData, ThrowOnError>): RequestResult<ListFlowsResponses, ListFlowsErrors, ThrowOnError> => (options?.client ?? client).get<ListFlowsResponses, ListFlowsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListFlowsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/flows',
    ...options
});

/**
 * Create Flow
 *
 * Create a new agent flow.
 */
export const createFlow = <ThrowOnError extends boolean = false>(options: Options<CreateFlowData, ThrowOnError>): RequestResult<CreateFlowResponses, CreateFlowErrors, ThrowOnError> => (options.client ?? client).post<CreateFlowResponses, CreateFlowErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateFlowResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/flows',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Flow
 *
 * Delete a flow (soft delete, admin only).
 */
export const deleteFlow = <ThrowOnError extends boolean = false>(options: Options<DeleteFlowData, ThrowOnError>): RequestResult<DeleteFlowResponses, DeleteFlowErrors, ThrowOnError> => (options.client ?? client).delete<DeleteFlowResponses, DeleteFlowErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteFlowResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/flows/{flow_uuid}',
    ...options
});

/**
 * Get Flow
 *
 * Get flow details (viewer+).
 */
export const getFlow = <ThrowOnError extends boolean = false>(options: Options<GetFlowData, ThrowOnError>): RequestResult<GetFlowResponses, GetFlowErrors, ThrowOnError> => (options.client ?? client).get<GetFlowResponses, GetFlowErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetFlowResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/flows/{flow_uuid}',
    ...options
});

/**
 * Update Flow
 *
 * Update a flow (editor+).
 */
export const updateFlow = <ThrowOnError extends boolean = false>(options: Options<UpdateFlowData, ThrowOnError>): RequestResult<UpdateFlowResponses, UpdateFlowErrors, ThrowOnError> => (options.client ?? client).put<UpdateFlowResponses, UpdateFlowErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateFlowResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/flows/{flow_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Flow Authorization
 *
 * Report the current user's background-access authorization for this flow.
 *
 * The ``scheduled_flows`` delegated token is user-scoped (one per user), so the
 * reported ``status`` reflects the user's overall scheduled-flow authorization.
 * ``has_scheduled_trigger`` indicates whether this flow has a schedule that
 * would actually use it. Detection is intentionally NOT based on which tools
 * the flow uses: agentless steps (a plain prompt) can call delegated tools at
 * runtime, so any scheduled flow may need this authorization.
 */
export const getFlowAuthorization = <ThrowOnError extends boolean = false>(options: Options<GetFlowAuthorizationData, ThrowOnError>): RequestResult<GetFlowAuthorizationResponses, GetFlowAuthorizationErrors, ThrowOnError> => (options.client ?? client).get<GetFlowAuthorizationResponses, GetFlowAuthorizationErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetFlowAuthorizationResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/flows/{flow_uuid}/authorization',
    ...options
});

/**
 * Authorize Flow
 *
 * Explicitly (re-)authorize background delegated access for scheduled flows.
 *
 * Captures the caller's live delegated token for the ``scheduled_flows``
 * purpose so background scheduled runs can act on their behalf (SharePoint,
 * Teams, Outlook, etc.). This is the user-initiated equivalent of the SharePoint
 * "Automated sync" authorize action.
 */
export const authorizeFlow = <ThrowOnError extends boolean = false>(options: Options<AuthorizeFlowData, ThrowOnError>): RequestResult<AuthorizeFlowResponses, AuthorizeFlowErrors, ThrowOnError> => (options.client ?? client).post<AuthorizeFlowResponses, AuthorizeFlowErrors, ThrowOnError>({
    responseValidator: async (data) => await zAuthorizeFlowResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/flows/{flow_uuid}/authorization',
    ...options
});

/**
 * Get Flow Members
 *
 * List who has access to a workflow (viewer+).
 */
export const getFlowMembers = <ThrowOnError extends boolean = false>(options: Options<GetFlowMembersData, ThrowOnError>): RequestResult<GetFlowMembersResponses, GetFlowMembersErrors, ThrowOnError> => (options.client ?? client).get<GetFlowMembersResponses, GetFlowMembersErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetFlowMembersResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/flows/{flow_uuid}/members',
    ...options
});

/**
 * Add Flow Team Member
 *
 * Grant a team a role on a workflow (admin only).
 */
export const addFlowTeamMember = <ThrowOnError extends boolean = false>(options: Options<AddFlowTeamMemberData, ThrowOnError>): RequestResult<AddFlowTeamMemberResponses, AddFlowTeamMemberErrors, ThrowOnError> => (options.client ?? client).post<AddFlowTeamMemberResponses, AddFlowTeamMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zAddFlowTeamMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/flows/{flow_uuid}/members/teams',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Flow Team Member
 *
 * Remove a team member (admin only; never the last admin).
 */
export const removeFlowTeamMember = <ThrowOnError extends boolean = false>(options: Options<RemoveFlowTeamMemberData, ThrowOnError>): RequestResult<RemoveFlowTeamMemberResponses, RemoveFlowTeamMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveFlowTeamMemberResponses, RemoveFlowTeamMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zRemoveFlowTeamMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/flows/{flow_uuid}/members/teams/{team_uuid}',
    ...options
});

/**
 * Update Flow Team Member
 *
 * Change a team member's role (admin only).
 */
export const updateFlowTeamMember = <ThrowOnError extends boolean = false>(options: Options<UpdateFlowTeamMemberData, ThrowOnError>): RequestResult<UpdateFlowTeamMemberResponses, UpdateFlowTeamMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateFlowTeamMemberResponses, UpdateFlowTeamMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateFlowTeamMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/flows/{flow_uuid}/members/teams/{team_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add Flow User Member
 *
 * Grant a user a role on a workflow (admin only).
 */
export const addFlowUserMember = <ThrowOnError extends boolean = false>(options: Options<AddFlowUserMemberData, ThrowOnError>): RequestResult<AddFlowUserMemberResponses, AddFlowUserMemberErrors, ThrowOnError> => (options.client ?? client).post<AddFlowUserMemberResponses, AddFlowUserMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zAddFlowUserMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/flows/{flow_uuid}/members/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Flow User Member
 *
 * Remove a user member (admin only; never the last admin).
 */
export const removeFlowUserMember = <ThrowOnError extends boolean = false>(options: Options<RemoveFlowUserMemberData, ThrowOnError>): RequestResult<RemoveFlowUserMemberResponses, RemoveFlowUserMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveFlowUserMemberResponses, RemoveFlowUserMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zRemoveFlowUserMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/flows/{flow_uuid}/members/users/{user_uuid}',
    ...options
});

/**
 * Update Flow User Member
 *
 * Change a user member's role (admin only).
 */
export const updateFlowUserMember = <ThrowOnError extends boolean = false>(options: Options<UpdateFlowUserMemberData, ThrowOnError>): RequestResult<UpdateFlowUserMemberResponses, UpdateFlowUserMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateFlowUserMemberResponses, UpdateFlowUserMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateFlowUserMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/flows/{flow_uuid}/members/users/{user_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Flow Runs
 *
 * List runs for a flow.
 */
export const listFlowRuns = <ThrowOnError extends boolean = false>(options: Options<ListFlowRunsData, ThrowOnError>): RequestResult<ListFlowRunsResponses, ListFlowRunsErrors, ThrowOnError> => (options.client ?? client).get<ListFlowRunsResponses, ListFlowRunsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListFlowRunsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/flows/{flow_uuid}/runs',
    ...options
});

/**
 * Stream Flow Run
 *
 * Start a flow run as a background operation and return the operation ID.
 *
 * Uses ``get_streaming_auth`` (lightweight auth) instead of
 * ``get_current_user`` / ``get_db`` so that **no request-scoped DB
 * session is held**.  All DB work is done via short-lived sessions from
 * ``async_session_maker``.
 *
 * The caller's live bearer token (``auth.access_token``) is threaded into
 * the flow context so delegated Microsoft Graph tools (SharePoint, Teams,
 * Outlook) can perform their OBO exchange during a manual run — mirroring
 * how chat/Task Mode pass the token. Without it, Graph tools would fail
 * mid-run with a spurious "needs permission" error even though the user is
 * fully consented.
 *
 * Returns a JSON response with ``operation_id`` which the client uses to
 * subscribe to events via ``GET /api/v1/operations/{op_id}/stream``.
 */
export const streamFlowRun = <ThrowOnError extends boolean = false>(options: Options<StreamFlowRunData, ThrowOnError>): RequestResult<StreamFlowRunResponses, StreamFlowRunErrors, ThrowOnError> => (options.client ?? client).post<StreamFlowRunResponses, StreamFlowRunErrors, ThrowOnError>({
    responseValidator: async (data) => await zStreamFlowRunResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/flows/{flow_uuid}/runs/stream',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Flow Run
 *
 * Get a specific flow run.
 */
export const getFlowRun = <ThrowOnError extends boolean = false>(options: Options<GetFlowRunData, ThrowOnError>): RequestResult<GetFlowRunResponses, GetFlowRunErrors, ThrowOnError> => (options.client ?? client).get<GetFlowRunResponses, GetFlowRunErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetFlowRunResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/flows/{flow_uuid}/runs/{run_uuid}',
    ...options
});

/**
 * Cancel Flow Run
 *
 * Cancel a running or paused flow run.
 */
export const cancelFlowRun = <ThrowOnError extends boolean = false>(options: Options<CancelFlowRunData, ThrowOnError>): RequestResult<CancelFlowRunResponses, CancelFlowRunErrors, ThrowOnError> => (options.client ?? client).post<CancelFlowRunResponses, CancelFlowRunErrors, ThrowOnError>({
    responseValidator: async (data) => await zCancelFlowRunResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/flows/{flow_uuid}/runs/{run_uuid}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resume Flow Run
 *
 * Resume a paused flow run.
 *
 * Used when a flow step has requires_review=True and is waiting for human approval.
 *
 * For approval: validates, prepares the resume (marks paused step completed,
 * sets run to RUNNING), fires off remaining step execution as a background
 * task, and returns immediately with the current run state.  The client
 * should poll ``GET /flows/{uuid}/runs/{runId}`` for progress.
 *
 * For rejection: cancels the run synchronously and returns the final state.
 */
export const resumeFlowRun = <ThrowOnError extends boolean = false>(options: Options<ResumeFlowRunData, ThrowOnError>): RequestResult<ResumeFlowRunResponses, ResumeFlowRunErrors, ThrowOnError> => (options.client ?? client).post<ResumeFlowRunResponses, ResumeFlowRunErrors, ThrowOnError>({
    responseValidator: async (data) => await zResumeFlowRunResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/flows/{flow_uuid}/runs/{run_uuid}/resume',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Flow Triggers
 *
 * List all triggers for a flow.
 */
export const listFlowTriggers = <ThrowOnError extends boolean = false>(options: Options<ListFlowTriggersData, ThrowOnError>): RequestResult<ListFlowTriggersResponses, ListFlowTriggersErrors, ThrowOnError> => (options.client ?? client).get<ListFlowTriggersResponses, ListFlowTriggersErrors, ThrowOnError>({
    responseValidator: async (data) => await zListFlowTriggersResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/flows/{flow_uuid}/triggers',
    ...options
});

/**
 * Create Flow Trigger
 *
 * Create a new trigger for a flow.
 */
export const createFlowTrigger = <ThrowOnError extends boolean = false>(options: Options<CreateFlowTriggerData, ThrowOnError>): RequestResult<CreateFlowTriggerResponses, CreateFlowTriggerErrors, ThrowOnError> => (options.client ?? client).post<CreateFlowTriggerResponses, CreateFlowTriggerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/flows/{flow_uuid}/triggers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Flow Trigger
 *
 * Delete a flow trigger.
 */
export const deleteFlowTrigger = <ThrowOnError extends boolean = false>(options: Options<DeleteFlowTriggerData, ThrowOnError>): RequestResult<DeleteFlowTriggerResponses, DeleteFlowTriggerErrors, ThrowOnError> => (options.client ?? client).delete<DeleteFlowTriggerResponses, DeleteFlowTriggerErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteFlowTriggerResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/flows/{flow_uuid}/triggers/{trigger_uuid}',
    ...options
});

/**
 * Update Flow Trigger
 *
 * Update a flow trigger (e.g. its schedule).
 */
export const updateFlowTrigger = <ThrowOnError extends boolean = false>(options: Options<UpdateFlowTriggerData, ThrowOnError>): RequestResult<UpdateFlowTriggerResponses, UpdateFlowTriggerErrors, ThrowOnError> => (options.client ?? client).put<UpdateFlowTriggerResponses, UpdateFlowTriggerErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateFlowTriggerResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/flows/{flow_uuid}/triggers/{trigger_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Flow Files
 *
 * Upload files for use in a flow run.
 *
 * Validates MIME types and sizes, uploads to Azure Blob Storage under
 * ``flow-attachments/{flow_uuid}/``, and returns blob paths that can be
 * passed in ``FlowRunCreate.file_blob_paths``.
 */
export const uploadFlowFiles = <ThrowOnError extends boolean = false>(options: Options<UploadFlowFilesData, ThrowOnError>): RequestResult<UploadFlowFilesResponses, UploadFlowFilesErrors, ThrowOnError> => (options.client ?? client).post<UploadFlowFilesResponses, UploadFlowFilesErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zUploadFlowFilesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/flows/{flow_uuid}/upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Download Document
 *
 * Download a Google Drive document and extract its text content.
 *
 * For Google Workspace files (Docs, Sheets, Slides), exports to a
 * portable format first.  For presentations, converts slides to images.
 */
export const googleDriveDownloadDocument = <ThrowOnError extends boolean = false>(options: Options<GoogleDriveDownloadDocumentData, ThrowOnError>): RequestResult<GoogleDriveDownloadDocumentResponses, GoogleDriveDownloadDocumentErrors, ThrowOnError> => (options.client ?? client).post<GoogleDriveDownloadDocumentResponses, GoogleDriveDownloadDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zGoogleDriveDownloadDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/google-drive/download/{file_id}',
    ...options
});

/**
 * List Files
 *
 * List files and folders within a folder (defaults to My Drive root).
 */
export const listFiles = <ThrowOnError extends boolean = false>(options?: Options<ListFilesData, ThrowOnError>): RequestResult<ListFilesResponses, ListFilesErrors, ThrowOnError> => (options?.client ?? client).get<ListFilesResponses, ListFilesErrors, ThrowOnError>({
    responseValidator: async (data) => await zListFilesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/google-drive/files',
    ...options
});

/**
 * Search Files
 *
 * Search for files in the user's Google Drive.
 */
export const searchFiles = <ThrowOnError extends boolean = false>(options: Options<SearchFilesData, ThrowOnError>): RequestResult<SearchFilesResponses, SearchFilesErrors, ThrowOnError> => (options.client ?? client).get<SearchFilesResponses, SearchFilesErrors, ThrowOnError>({
    responseValidator: async (data) => await zSearchFilesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/google-drive/search',
    ...options
});

/**
 * List My Jobs
 *
 * List the signed-in user's recent harness jobs (most recent first).
 */
export const listMyJobs = <ThrowOnError extends boolean = false>(options?: Options<ListMyJobsData, ThrowOnError>): RequestResult<ListMyJobsResponses, ListMyJobsErrors, ThrowOnError> => (options?.client ?? client).get<ListMyJobsResponses, ListMyJobsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListMyJobsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/harness/jobs',
    ...options
});

/**
 * List Workers
 *
 * List the signed-in user's harness workers with derived presence.
 */
export const listWorkers = <ThrowOnError extends boolean = false>(options?: Options<ListWorkersData, ThrowOnError>): RequestResult<ListWorkersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListWorkersResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zListWorkersResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/harness/workers',
    ...options
});

/**
 * List Available
 *
 * Enabled per-user-credential extensions the user can access + status.
 */
export const listAvailable = <ThrowOnError extends boolean = false>(options?: Options<ListAvailableData, ThrowOnError>): RequestResult<ListAvailableResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListAvailableResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zListAvailableResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/available',
    ...options
});

/**
 * List Extension Consent
 *
 * Integration extensions the user can access, with their read/write consent (MHS-588).
 */
export const listExtensionConsent = <ThrowOnError extends boolean = false>(options?: Options<ListExtensionConsentData, ThrowOnError>): RequestResult<ListExtensionConsentResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListExtensionConsentResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zListExtensionConsentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/extensions',
    ...options
});

/**
 * Clear Extension Preference
 *
 * Drop the user's choice so the extension's default applies again. Repeating it is harmless.
 */
export const clearExtensionPreference = <ThrowOnError extends boolean = false>(options: Options<ClearExtensionPreferenceData, ThrowOnError>): RequestResult<ClearExtensionPreferenceResponses, ClearExtensionPreferenceErrors, ThrowOnError> => (options.client ?? client).delete<ClearExtensionPreferenceResponses, ClearExtensionPreferenceErrors, ThrowOnError>({
    responseValidator: async (data) => await zClearExtensionPreferenceResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/extensions/{slug}/preference',
    ...options
});

/**
 * Set Extension Preference
 *
 * Save the user's read or write choice for an extension. Repeating it is harmless.
 */
export const setExtensionPreference = <ThrowOnError extends boolean = false>(options: Options<SetExtensionPreferenceData, ThrowOnError>): RequestResult<SetExtensionPreferenceResponses, SetExtensionPreferenceErrors, ThrowOnError> => (options.client ?? client).put<SetExtensionPreferenceResponses, SetExtensionPreferenceErrors, ThrowOnError>({
    responseValidator: async (data) => await zSetExtensionPreferenceResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/extensions/{slug}/preference',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Authorize
 *
 * Begin the OAuth connect flow for an extension.
 */
export const authorize = <ThrowOnError extends boolean = false>(options: Options<AuthorizeData, ThrowOnError>): RequestResult<AuthorizeResponses, AuthorizeErrors, ThrowOnError> => (options.client ?? client).get<AuthorizeResponses, AuthorizeErrors, ThrowOnError>({
    responseValidator: async (data) => await zAuthorizeResponse2.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/{slug}/authorize',
    ...options
});

/**
 * Disconnect
 *
 * Revoke (best-effort) and delete the user's credential for an extension.
 */
export const disconnect = <ThrowOnError extends boolean = false>(options: Options<DisconnectData, ThrowOnError>): RequestResult<DisconnectResponses, DisconnectErrors, ThrowOnError> => (options.client ?? client).delete<DisconnectResponses, DisconnectErrors, ThrowOnError>({
    responseValidator: async (data) => await zDisconnectResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/{slug}/connection',
    ...options
});

/**
 * List Imports
 *
 * Your recent imports (newest first), optionally for one space.
 */
export const listImports = <ThrowOnError extends boolean = false>(options?: Options<ListImportsData, ThrowOnError>): RequestResult<ListImportsResponses, ListImportsErrors, ThrowOnError> => (options?.client ?? client).get<ListImportsResponses, ListImportsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListImportsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/kg/imports',
    ...options
});

/**
 * Delete Import
 *
 * Cancel a running import, or delete a finished one with its pending proposals (accepted facts stay).
 */
export const deleteImport = <ThrowOnError extends boolean = false>(options: Options<DeleteImportData, ThrowOnError>): RequestResult<DeleteImportResponses, DeleteImportErrors, ThrowOnError> => (options.client ?? client).delete<DeleteImportResponses, DeleteImportErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteImportResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/kg/imports/{import_uuid}',
    ...options
});

/**
 * Get Import
 *
 * One of your imports: status and progress (poll while it runs).
 */
export const getImport = <ThrowOnError extends boolean = false>(options: Options<GetImportData, ThrowOnError>): RequestResult<GetImportResponses, GetImportErrors, ThrowOnError> => (options.client ?? client).get<GetImportResponses, GetImportErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetImportResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/kg/imports/{import_uuid}',
    ...options
});

/**
 * Accept All
 *
 * Accept up to 500 of an import's pending facts as proposed, into a space you can edit.
 *
 * No other names are written (confirm those per fact). Facts that can't be written stay pending (``skipped``).
 * 409 ``KG_IMPORT_RUNNING`` while it's still extracting; 403 ``WIKI_PUBLISH_FORBIDDEN`` for ``org`` pages
 * without admin on the space.
 */
export const acceptAll = <ThrowOnError extends boolean = false>(options: Options<AcceptAllData, ThrowOnError>): RequestResult<AcceptAllResponses, AcceptAllErrors, ThrowOnError> => (options.client ?? client).post<AcceptAllResponses, AcceptAllErrors, ThrowOnError>({
    responseValidator: async (data) => await zAcceptAllResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/kg/imports/{import_uuid}/accept-all',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Dismiss All
 *
 * Dismiss all of an import's pending facts (they won't be proposed to you again).
 */
export const dismissAll = <ThrowOnError extends boolean = false>(options: Options<DismissAllData, ThrowOnError>): RequestResult<DismissAllResponses, DismissAllErrors, ThrowOnError> => (options.client ?? client).post<DismissAllResponses, DismissAllErrors, ThrowOnError>({
    responseValidator: async (data) => await zDismissAllResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/kg/imports/{import_uuid}/dismiss-all',
    ...options
});

/**
 * List Inbox
 *
 * Your pending proposals, most confident first.
 */
export const listInbox = <ThrowOnError extends boolean = false>(options?: Options<ListInboxData, ThrowOnError>): RequestResult<ListInboxResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListInboxResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zListInboxResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/kg/inbox',
    ...options
});

/**
 * Accept Proposal
 *
 * Accept a proposal (optionally corrected): write it into a wiki you can edit.
 *
 * Creates pages for things that don't have one in that space yet (private by
 * default) and adds the fact to the subject's page under ``## Relationships``.
 * 404 ``KG_PROPOSAL_NOT_FOUND``, 409 ``KG_PROPOSAL_NOT_PENDING``, 400
 * ``KG_PROPOSAL_INVALID``, 409 ``WIKI_CONFLICT`` (a page changed meanwhile:
 * retry), 403/404 if the target space isn't editable.
 */
export const acceptProposal = <ThrowOnError extends boolean = false>(options: Options<AcceptProposalData, ThrowOnError>): RequestResult<AcceptProposalResponses, AcceptProposalErrors, ThrowOnError> => (options.client ?? client).post<AcceptProposalResponses, AcceptProposalErrors, ThrowOnError>({
    responseValidator: async (data) => await zAcceptProposalResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/kg/inbox/{proposal_uuid}/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reject Proposal
 *
 * Reject a proposal; the same fact won't be proposed to you again.
 */
export const rejectProposal = <ThrowOnError extends boolean = false>(options: Options<RejectProposalData, ThrowOnError>): RequestResult<RejectProposalResponses, RejectProposalErrors, ThrowOnError> => (options.client ?? client).post<RejectProposalResponses, RejectProposalErrors, ThrowOnError>({
    responseValidator: async (data) => await zRejectProposalResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/kg/inbox/{proposal_uuid}/reject',
    ...options
});

/**
 * List Duplicates
 *
 * Pages in this space that look like the same thing (editor+), strongest first.
 */
export const listDuplicates = <ThrowOnError extends boolean = false>(options: Options<ListDuplicatesData, ThrowOnError>): RequestResult<ListDuplicatesResponses, ListDuplicatesErrors, ThrowOnError> => (options.client ?? client).get<ListDuplicatesResponses, ListDuplicatesErrors, ThrowOnError>({
    responseValidator: async (data) => await zListDuplicatesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/kg/spaces/{space_uuid}/duplicates',
    ...options
});

/**
 * Dismiss Duplicate
 *
 * "Not the same thing": don't suggest merging these two again (editor+).
 */
export const dismissDuplicate = <ThrowOnError extends boolean = false>(options: Options<DismissDuplicateData, ThrowOnError>): RequestResult<DismissDuplicateResponses, DismissDuplicateErrors, ThrowOnError> => (options.client ?? client).post<DismissDuplicateResponses, DismissDuplicateErrors, ThrowOnError>({
    responseValidator: async (data) => await zDismissDuplicateResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/kg/spaces/{space_uuid}/duplicates/dismiss',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Import
 *
 * Import pasted text, or a file already in the space's knowledge base (editor+ on the space).
 *
 * Send exactly one of ``text`` and ``spaceFileUuid``. 400 ``KG_IMPORT_INVALID`` / ``KG_IMPORT_UNSUPPORTED``,
 * 404 if the space file isn't in this space, 429 ``KG_IMPORT_BUSY``.
 */
export const createImport = <ThrowOnError extends boolean = false>(options: Options<CreateImportData, ThrowOnError>): RequestResult<CreateImportResponses, CreateImportErrors, ThrowOnError> => (options.client ?? client).post<CreateImportResponses, CreateImportErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateImportResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/kg/spaces/{space_uuid}/imports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Import
 *
 * Import an uploaded document into your inbox as proposed facts (editor+ on the space).
 *
 * The file isn't kept. 400 ``KG_IMPORT_UNSUPPORTED``, 413 ``KG_IMPORT_TOO_LARGE``, 429 ``KG_IMPORT_BUSY``.
 */
export const uploadImport = <ThrowOnError extends boolean = false>(options: Options<UploadImportData, ThrowOnError>): RequestResult<UploadImportResponses, UploadImportErrors, ThrowOnError> => (options.client ?? client).post<UploadImportResponses, UploadImportErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zUploadImportResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/kg/spaces/{space_uuid}/imports/upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * List Merges
 *
 * Recent merges in this space, newest first (editor+): the audit trail, with undo.
 */
export const listMerges = <ThrowOnError extends boolean = false>(options: Options<ListMergesData, ThrowOnError>): RequestResult<ListMergesResponses, ListMergesErrors, ThrowOnError> => (options.client ?? client).get<ListMergesResponses, ListMergesErrors, ThrowOnError>({
    responseValidator: async (data) => await zListMergesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/kg/spaces/{space_uuid}/merges',
    ...options
});

/**
 * Merge Pages
 *
 * Merge ``removePath`` into ``keepPath`` (editor+). 409 ``KG_MERGE_CONFLICT`` if either changed
 * since the preview. Undo with ``POST .../merges/{uuid}/undo``.
 */
export const mergePages = <ThrowOnError extends boolean = false>(options: Options<MergePagesData, ThrowOnError>): RequestResult<MergePagesResponses, MergePagesErrors, ThrowOnError> => (options.client ?? client).post<MergePagesResponses, MergePagesErrors, ThrowOnError>({
    responseValidator: async (data) => await zMergePagesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/kg/spaces/{space_uuid}/merges',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview Merge
 *
 * What merging ``removePath`` into ``keepPath`` would do (editor+). Changes nothing.
 */
export const previewMerge = <ThrowOnError extends boolean = false>(options: Options<PreviewMergeData, ThrowOnError>): RequestResult<PreviewMergeResponses, PreviewMergeErrors, ThrowOnError> => (options.client ?? client).post<PreviewMergeResponses, PreviewMergeErrors, ThrowOnError>({
    responseValidator: async (data) => await zPreviewMergeResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/kg/spaces/{space_uuid}/merges/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Undo Merge
 *
 * Restore every page a merge changed (editor+). 409 ``KG_MERGE_CONFLICT`` if any changed since.
 */
export const undoMerge = <ThrowOnError extends boolean = false>(options: Options<UndoMergeData, ThrowOnError>): RequestResult<UndoMergeResponses, UndoMergeErrors, ThrowOnError> => (options.client ?? client).post<UndoMergeResponses, UndoMergeErrors, ThrowOnError>({
    responseValidator: async (data) => await zUndoMergeResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/kg/spaces/{space_uuid}/merges/{merge_uuid}/undo',
    ...options
});

/**
 * List Wiki Files
 *
 * Wiki files in the space that the caller may read.
 *
 * Members see what their role allows; anyone else sees only the space's ``org`` pages,
 * and a space with none looks the same to them as one that doesn't exist (404).
 */
export const listWikiFiles = <ThrowOnError extends boolean = false>(options: Options<ListWikiFilesData, ThrowOnError>): RequestResult<ListWikiFilesResponses, ListWikiFilesErrors, ThrowOnError> => (options.client ?? client).get<ListWikiFilesResponses, ListWikiFilesErrors, ThrowOnError>({
    responseValidator: async (data) => await zListWikiFilesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/kg/spaces/{space_uuid}/wiki',
    ...options
});

/**
 * Delete Wiki File
 *
 * Delete a wiki file (its history is kept), then reindex (editor+).
 */
export const deleteWikiFile = <ThrowOnError extends boolean = false>(options: Options<DeleteWikiFileData, ThrowOnError>): RequestResult<DeleteWikiFileResponses, DeleteWikiFileErrors, ThrowOnError> => (options.client ?? client).delete<DeleteWikiFileResponses, DeleteWikiFileErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteWikiFileResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/kg/spaces/{space_uuid}/wiki/file',
    ...options
});

/**
 * Get Wiki File
 *
 * One wiki file: markdown, indexed node, diagnostics, links and backlinks (viewer+).
 */
export const getWikiFile = <ThrowOnError extends boolean = false>(options: Options<GetWikiFileData, ThrowOnError>): RequestResult<GetWikiFileResponses, GetWikiFileErrors, ThrowOnError> => (options.client ?? client).get<GetWikiFileResponses, GetWikiFileErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetWikiFileResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/kg/spaces/{space_uuid}/wiki/file',
    ...options
});

/**
 * Save Wiki File
 *
 * Create (``baseRevision`` null) or update a wiki file, then reindex (editor+).
 *
 * 409 ``WIKI_CONFLICT`` if the file changed since ``baseRevision``. The page's
 * embedding (for the broker) is refreshed after the response.
 */
export const saveWikiFile = <ThrowOnError extends boolean = false>(options: Options<SaveWikiFileData, ThrowOnError>): RequestResult<SaveWikiFileResponses, SaveWikiFileErrors, ThrowOnError> => (options.client ?? client).put<SaveWikiFileResponses, SaveWikiFileErrors, ThrowOnError>({
    responseValidator: async (data) => await zSaveWikiFileResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/kg/spaces/{space_uuid}/wiki/file',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Micro Apps
 *
 * List micro apps the caller can access.
 */
export const listMicroApps = <ThrowOnError extends boolean = false>(options?: Options<ListMicroAppsData, ThrowOnError>): RequestResult<ListMicroAppsResponses, ListMicroAppsErrors, ThrowOnError> => (options?.client ?? client).get<ListMicroAppsResponses, ListMicroAppsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListMicroAppsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/micro-apps',
    ...options
});

/**
 * Get Attachment Bindings
 *
 * Read an attachment's data bindings (grouped per source) for the publish dialog.
 *
 * Lets the author see each data source and choose its mode before publishing.
 */
export const getAttachmentBindings = <ThrowOnError extends boolean = false>(options: Options<GetAttachmentBindingsData, ThrowOnError>): RequestResult<GetAttachmentBindingsResponses, GetAttachmentBindingsErrors, ThrowOnError> => (options.client ?? client).get<GetAttachmentBindingsResponses, GetAttachmentBindingsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetAttachmentBindingsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/micro-apps/attachments/{attachment_uuid}/bindings',
    ...options
});

/**
 * Publish Micro App
 *
 * Publish a generated HTML attachment as a first-class micro app.
 */
export const publishMicroApp = <ThrowOnError extends boolean = false>(options: Options<PublishMicroAppData, ThrowOnError>): RequestResult<PublishMicroAppResponses, PublishMicroAppErrors, ThrowOnError> => (options.client ?? client).post<PublishMicroAppResponses, PublishMicroAppErrors, ThrowOnError>({
    responseValidator: async (data) => await zPublishMicroAppResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/micro-apps/publish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Micro App
 *
 * Soft-delete a micro app (admin only).
 */
export const deleteMicroApp = <ThrowOnError extends boolean = false>(options: Options<DeleteMicroAppData, ThrowOnError>): RequestResult<DeleteMicroAppResponses, DeleteMicroAppErrors, ThrowOnError> => (options.client ?? client).delete<DeleteMicroAppResponses, DeleteMicroAppErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteMicroAppResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/micro-apps/{app_uuid}',
    ...options
});

/**
 * Get Micro App
 *
 * Get a single micro app's metadata.
 */
export const getMicroApp = <ThrowOnError extends boolean = false>(options: Options<GetMicroAppData, ThrowOnError>): RequestResult<GetMicroAppResponses, GetMicroAppErrors, ThrowOnError> => (options.client ?? client).get<GetMicroAppResponses, GetMicroAppErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetMicroAppResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/micro-apps/{app_uuid}',
    ...options
});

/**
 * Update Micro App
 *
 * Update a micro app's metadata (editor+ only).
 */
export const updateMicroApp = <ThrowOnError extends boolean = false>(options: Options<UpdateMicroAppData, ThrowOnError>): RequestResult<UpdateMicroAppResponses, UpdateMicroAppErrors, ThrowOnError> => (options.client ?? client).put<UpdateMicroAppResponses, UpdateMicroAppErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateMicroAppResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/micro-apps/{app_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Micro App Content
 *
 * Return the rendered micro app content (HTML) for the viewer.
 *
 * Uses ETag revalidation (``no-cache`` + ``ETag``) rather than a blind TTL so
 * that a re-published/edited dashboard is picked up immediately: the browser
 * revalidates on every load and gets a cheap ``304`` when unchanged or fresh
 * ``200`` when the content (blob) has changed.
 */
export const getMicroAppContent = <ThrowOnError extends boolean = false>(options: Options<GetMicroAppContentData, ThrowOnError>): RequestResult<GetMicroAppContentResponses, GetMicroAppContentErrors, ThrowOnError> => (options.client ?? client).get<GetMicroAppContentResponses, GetMicroAppContentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/micro-apps/{app_uuid}/content',
    ...options
});

/**
 * Get Micro App Info
 *
 * Return the end-user Info/About panel: identity + authorship + provenance.
 *
 * Composes the app's narrative (``about``) and factual, auto-derived data
 * provenance (sources, refresh cadence, last refresh). Lightweight auth; the
 * same view gate as opening the app.
 */
export const getMicroAppInfo = <ThrowOnError extends boolean = false>(options: Options<GetMicroAppInfoData, ThrowOnError>): RequestResult<GetMicroAppInfoResponses, GetMicroAppInfoErrors, ThrowOnError> => (options.client ?? client).get<GetMicroAppInfoResponses, GetMicroAppInfoErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetMicroAppInfoResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/micro-apps/{app_uuid}/info',
    ...options
});

/**
 * Get Micro App Members
 *
 * List a micro app's members (viewer+).
 */
export const getMicroAppMembers = <ThrowOnError extends boolean = false>(options: Options<GetMicroAppMembersData, ThrowOnError>): RequestResult<GetMicroAppMembersResponses, GetMicroAppMembersErrors, ThrowOnError> => (options.client ?? client).get<GetMicroAppMembersResponses, GetMicroAppMembersErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetMicroAppMembersResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/micro-apps/{app_uuid}/members',
    ...options
});

/**
 * Add Micro App Team Member
 *
 * Grant a team a role on a micro app (admin only).
 */
export const addMicroAppTeamMember = <ThrowOnError extends boolean = false>(options: Options<AddMicroAppTeamMemberData, ThrowOnError>): RequestResult<AddMicroAppTeamMemberResponses, AddMicroAppTeamMemberErrors, ThrowOnError> => (options.client ?? client).post<AddMicroAppTeamMemberResponses, AddMicroAppTeamMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zAddMicroAppTeamMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/micro-apps/{app_uuid}/members/teams',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Micro App Team Member
 *
 * Remove a team member (admin only).
 */
export const removeMicroAppTeamMember = <ThrowOnError extends boolean = false>(options: Options<RemoveMicroAppTeamMemberData, ThrowOnError>): RequestResult<RemoveMicroAppTeamMemberResponses, RemoveMicroAppTeamMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveMicroAppTeamMemberResponses, RemoveMicroAppTeamMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zRemoveMicroAppTeamMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/micro-apps/{app_uuid}/members/teams/{team_uuid}',
    ...options
});

/**
 * Update Micro App Team Member
 *
 * Change a team member's role (admin only).
 */
export const updateMicroAppTeamMember = <ThrowOnError extends boolean = false>(options: Options<UpdateMicroAppTeamMemberData, ThrowOnError>): RequestResult<UpdateMicroAppTeamMemberResponses, UpdateMicroAppTeamMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateMicroAppTeamMemberResponses, UpdateMicroAppTeamMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateMicroAppTeamMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/micro-apps/{app_uuid}/members/teams/{team_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add Micro App User Member
 *
 * Grant a user a role on a micro app (admin only).
 */
export const addMicroAppUserMember = <ThrowOnError extends boolean = false>(options: Options<AddMicroAppUserMemberData, ThrowOnError>): RequestResult<AddMicroAppUserMemberResponses, AddMicroAppUserMemberErrors, ThrowOnError> => (options.client ?? client).post<AddMicroAppUserMemberResponses, AddMicroAppUserMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zAddMicroAppUserMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/micro-apps/{app_uuid}/members/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Micro App User Member
 *
 * Remove a user member (admin only).
 */
export const removeMicroAppUserMember = <ThrowOnError extends boolean = false>(options: Options<RemoveMicroAppUserMemberData, ThrowOnError>): RequestResult<RemoveMicroAppUserMemberResponses, RemoveMicroAppUserMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveMicroAppUserMemberResponses, RemoveMicroAppUserMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zRemoveMicroAppUserMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/micro-apps/{app_uuid}/members/users/{user_uuid}',
    ...options
});

/**
 * Update Micro App User Member
 *
 * Change a user member's role (admin only).
 */
export const updateMicroAppUserMember = <ThrowOnError extends boolean = false>(options: Options<UpdateMicroAppUserMemberData, ThrowOnError>): RequestResult<UpdateMicroAppUserMemberResponses, UpdateMicroAppUserMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateMicroAppUserMemberResponses, UpdateMicroAppUserMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateMicroAppUserMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/micro-apps/{app_uuid}/members/users/{user_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Republish Micro App
 *
 * Replace a micro app's content from a newly generated attachment (editor+ only).
 *
 * Copies the new HTML blob, re-extracts and reconciles the live-data bindings,
 * and preserves the existing author-delegated authorization when the data owner
 * is unchanged. Lets an owner iterate on a dashboard in chat and push the new
 * version to the already-published app instead of forking a new one.
 */
export const republishMicroApp = <ThrowOnError extends boolean = false>(options: Options<RepublishMicroAppData, ThrowOnError>): RequestResult<RepublishMicroAppResponses, RepublishMicroAppErrors, ThrowOnError> => (options.client ?? client).post<RepublishMicroAppResponses, RepublishMicroAppErrors, ThrowOnError>({
    responseValidator: async (data) => await zRepublishMicroAppResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/micro-apps/{app_uuid}/republish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Models
 *
 * List available AI models.
 *
 * By default shows enabled models plus deprecated ones (so agent owners can be
 * warned). Admins can see disabled models.
 */
export const modelsListModels = <ThrowOnError extends boolean = false>(options?: Options<ModelsListModelsData, ThrowOnError>): RequestResult<ModelsListModelsResponses, ModelsListModelsErrors, ThrowOnError> => (options?.client ?? client).get<ModelsListModelsResponses, ModelsListModelsErrors, ThrowOnError>({
    responseValidator: async (data) => await zModelsListModelsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/models',
    ...options
});

/**
 * List User Facing Tier Defaults
 *
 * List user-facing model tier defaults (Default Fast, Default Thorough, etc.).
 *
 * These appear in model dropdowns as virtual model options that automatically
 * resolve to the admin-configured model deployment.
 */
export const listUserFacingTierDefaults = <ThrowOnError extends boolean = false>(options?: Options<ListUserFacingTierDefaultsData, ThrowOnError>): RequestResult<ListUserFacingTierDefaultsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListUserFacingTierDefaultsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zListUserFacingTierDefaultsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/models/tier-defaults/user-facing',
    ...options
});

/**
 * List Notifications
 *
 * List notifications for the authenticated user.
 */
export const listNotifications = <ThrowOnError extends boolean = false>(options?: Options<ListNotificationsData, ThrowOnError>): RequestResult<ListNotificationsResponses, ListNotificationsErrors, ThrowOnError> => (options?.client ?? client).get<ListNotificationsResponses, ListNotificationsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListNotificationsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/notifications',
    ...options
});

/**
 * Mark All Read
 *
 * Mark all unread notifications as read.
 */
export const markAllRead = <ThrowOnError extends boolean = false>(options?: Options<MarkAllReadData, ThrowOnError>): RequestResult<MarkAllReadResponses, unknown, ThrowOnError> => (options?.client ?? client).post<MarkAllReadResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zMarkAllReadResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/notifications/mark-all-read',
    ...options
});

/**
 * Get Preferences
 *
 * Get notification preferences for all event types.
 */
export const getPreferences = <ThrowOnError extends boolean = false>(options?: Options<GetPreferencesData, ThrowOnError>): RequestResult<GetPreferencesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPreferencesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zGetPreferencesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/notifications/preferences',
    ...options
});

/**
 * Update Preferences
 *
 * Update notification preferences (bulk upsert).
 */
export const updatePreferences = <ThrowOnError extends boolean = false>(options: Options<UpdatePreferencesData, ThrowOnError>): RequestResult<UpdatePreferencesResponses, UpdatePreferencesErrors, ThrowOnError> => (options.client ?? client).put<UpdatePreferencesResponses, UpdatePreferencesErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdatePreferencesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/notifications/preferences',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Unread Count
 *
 * Get the number of unread notifications.
 */
export const getUnreadCount = <ThrowOnError extends boolean = false>(options?: Options<GetUnreadCountData, ThrowOnError>): RequestResult<GetUnreadCountResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetUnreadCountResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zGetUnreadCountResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/notifications/unread-count',
    ...options
});

/**
 * Mark Notification Read
 *
 * Mark a single notification as read.
 */
export const markNotificationRead = <ThrowOnError extends boolean = false>(options: Options<MarkNotificationReadData, ThrowOnError>): RequestResult<MarkNotificationReadResponses, MarkNotificationReadErrors, ThrowOnError> => (options.client ?? client).patch<MarkNotificationReadResponses, MarkNotificationReadErrors, ThrowOnError>({
    responseValidator: async (data) => await zMarkNotificationReadResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/notifications/{notification_uuid}/read',
    ...options
});

/**
 * List Active Operations
 *
 * List all active operations for the current user.
 *
 * Used by the old frontend's ``OperationContext`` on mount, and by web/ to reattach a running reply after a
 * reload (MHS-793). Stale operations are failed lazily here (15 minutes without a sign of life), and listed this
 * once more with status ``failed``, so a reply whose worker died shows as failed instead of vanishing.
 */
export const listActiveOperations = <ThrowOnError extends boolean = false>(options?: Options<ListActiveOperationsData, ThrowOnError>): RequestResult<ListActiveOperationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListActiveOperationsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zListActiveOperationsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/operations/active',
    ...options
});

/**
 * Cancel Operation
 *
 * Ask a running operation to stop (cooperative, idempotent).
 *
 * The runner stops at its next check (within about a second), then finishes
 * with the normal ``operation_completed`` event carrying ``cancelled: true``.
 * Closing a stream alone only unsubscribes; this actually stops the work.
 */
export const cancelOperation = <ThrowOnError extends boolean = false>(options: Options<CancelOperationData, ThrowOnError>): RequestResult<CancelOperationResponses, CancelOperationErrors, ThrowOnError> => (options.client ?? client).post<CancelOperationResponses, CancelOperationErrors, ThrowOnError>({
    responseValidator: async (data) => await zCancelOperationResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/operations/{op_id}/cancel',
    ...options
});

/**
 * Download Document
 *
 * Download a SharePoint document and extract its text content.
 *
 * Resolves the URL, downloads the file bytes, and extracts readable text.
 * For presentations (.pptx/.ppt), converts slides to images instead.
 * Supports PDF, PowerPoint (.pptx), Word (.docx), plain text, CSV, JSON,
 * and Markdown files.
 */
export const sharepointDownloadDocument = <ThrowOnError extends boolean = false>(options: Options<SharepointDownloadDocumentData, ThrowOnError>): RequestResult<SharepointDownloadDocumentResponses, SharepointDownloadDocumentErrors, ThrowOnError> => (options.client ?? client).post<SharepointDownloadDocumentResponses, SharepointDownloadDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zSharepointDownloadDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/sharepoint/download',
    ...options
});

/**
 * List Drive Items
 *
 * List files and folders within a drive or a specific folder.
 *
 * Either provide ``folder_id`` to browse by ID, ``path`` to browse by
 * path, or omit both to list the drive root.
 */
export const listDriveItems = <ThrowOnError extends boolean = false>(options: Options<ListDriveItemsData, ThrowOnError>): RequestResult<ListDriveItemsResponses, ListDriveItemsErrors, ThrowOnError> => (options.client ?? client).get<ListDriveItemsResponses, ListDriveItemsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListDriveItemsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/sharepoint/drives/{drive_id}/items',
    ...options
});

/**
 * Count Folder Items
 *
 * Count files inside a SharePoint folder.
 *
 * Returns the number of *supported* files (those with indexable
 * extensions) and the total number of files.  When ``recursive=true``,
 * includes files in all sub-folders.  The total count is capped at
 * 1000 — if exceeded, ``truncated`` is ``true``.
 */
export const sharepointCountFolderItems = <ThrowOnError extends boolean = false>(options: Options<SharepointCountFolderItemsData, ThrowOnError>): RequestResult<SharepointCountFolderItemsResponses, SharepointCountFolderItemsErrors, ThrowOnError> => (options.client ?? client).get<SharepointCountFolderItemsResponses, SharepointCountFolderItemsErrors, ThrowOnError>({
    responseValidator: async (data) => await zSharepointCountFolderItemsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/sharepoint/drives/{drive_id}/items/{item_id}/count',
    ...options
});

/**
 * Search Drive Items
 *
 * Search for files within a specific document library.
 */
export const searchDriveItems = <ThrowOnError extends boolean = false>(options: Options<SearchDriveItemsData, ThrowOnError>): RequestResult<SearchDriveItemsResponses, SearchDriveItemsErrors, ThrowOnError> => (options.client ?? client).get<SearchDriveItemsResponses, SearchDriveItemsErrors, ThrowOnError>({
    responseValidator: async (data) => await zSearchDriveItemsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/sharepoint/drives/{drive_id}/search',
    ...options
});

/**
 * Get My Onedrive
 *
 * Get the current user's personal OneDrive (as a drive).
 *
 * Returned in the same shape as a SharePoint document library so the
 * frontend can reuse the existing drive/item browsing flow. The returned
 * ``id`` is the OneDrive drive ID; feed it to the existing
 * ``/drives/{drive_id}/items`` endpoints to browse.
 */
export const getMyOnedrive = <ThrowOnError extends boolean = false>(options?: Options<GetMyOnedriveData, ThrowOnError>): RequestResult<GetMyOnedriveResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetMyOnedriveResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zGetMyOnedriveResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/sharepoint/onedrive/drive',
    ...options
});

/**
 * Resolve Sharepoint Url
 *
 * Resolve a SharePoint/OneDrive URL to a file item.
 *
 * Supports various URL formats including sharing links and direct file paths.
 */
export const resolveSharepointUrl = <ThrowOnError extends boolean = false>(options: Options<ResolveSharepointUrlData, ThrowOnError>): RequestResult<ResolveSharepointUrlResponses, ResolveSharepointUrlErrors, ThrowOnError> => (options.client ?? client).get<ResolveSharepointUrlResponses, ResolveSharepointUrlErrors, ThrowOnError>({
    responseValidator: async (data) => await zResolveSharepointUrlResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/sharepoint/resolve',
    ...options
});

/**
 * Search Sites
 *
 * Search for SharePoint sites the current user has access to.
 */
export const searchSites = <ThrowOnError extends boolean = false>(options?: Options<SearchSitesData, ThrowOnError>): RequestResult<SearchSitesResponses, SearchSitesErrors, ThrowOnError> => (options?.client ?? client).get<SearchSitesResponses, SearchSitesErrors, ThrowOnError>({
    responseValidator: async (data) => await zSearchSitesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/sharepoint/sites',
    ...options
});

/**
 * List Site Drives
 *
 * List document libraries (drives) within a SharePoint site.
 */
export const listSiteDrives = <ThrowOnError extends boolean = false>(options: Options<ListSiteDrivesData, ThrowOnError>): RequestResult<ListSiteDrivesResponses, ListSiteDrivesErrors, ThrowOnError> => (options.client ?? client).get<ListSiteDrivesResponses, ListSiteDrivesErrors, ThrowOnError>({
    responseValidator: async (data) => await zListSiteDrivesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/sharepoint/sites/{site_id}/drives',
    ...options
});

/**
 * List Skills
 *
 * List skills accessible to the user.
 *
 * Returns platform-managed (system/extension) skills plus skills the user
 * holds a grant on (directly or via a team). Platform admins see all skills.
 */
export const listSkills = <ThrowOnError extends boolean = false>(options?: Options<ListSkillsData, ThrowOnError>): RequestResult<ListSkillsResponses, ListSkillsErrors, ThrowOnError> => (options?.client ?? client).get<ListSkillsResponses, ListSkillsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListSkillsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/skills',
    ...options
});

/**
 * Create Skill
 *
 * Create a new skill. The creator becomes its admin.
 */
export const createSkill = <ThrowOnError extends boolean = false>(options: Options<CreateSkillData, ThrowOnError>): RequestResult<CreateSkillResponses, CreateSkillErrors, ThrowOnError> => (options.client ?? client).post<CreateSkillResponses, CreateSkillErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateSkillResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/skills',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Skill Categories
 *
 * List all unique skill categories.
 */
export const listSkillCategories = <ThrowOnError extends boolean = false>(options?: Options<ListSkillCategoriesData, ThrowOnError>): RequestResult<ListSkillCategoriesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListSkillCategoriesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zListSkillCategoriesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/skills/categories',
    ...options
});

/**
 * Import Skills
 *
 * Import selected skills/agents from an uploaded Agent-Skills bundle (MHS-359).
 *
 * The zip may contain a single ``SKILL.md`` bundle at the root or several
 * bundles nested one level down. Imported skills are created **private** to the
 * uploading user; ``required_tools`` are resolved by name and any not present
 * in this install are reported back (not fatal). When ``selection`` is
 * provided, only the listed skills/agents are created (with optional agent
 * renames); otherwise everything found is imported.
 */
export const importSkills = <ThrowOnError extends boolean = false>(options: Options<ImportSkillsData, ThrowOnError>): RequestResult<ImportSkillsResponses, ImportSkillsErrors, ThrowOnError> => (options.client ?? client).post<ImportSkillsResponses, ImportSkillsErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zImportSkillsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/skills/import',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Analyze Import
 *
 * Analyze an uploaded bundle and report what *would* be imported — no writes.
 *
 * Returns the detected skills and agents (with tool matches/gaps and whether a
 * skill name is already taken) so the UI can let the user uncheck items and
 * rename agents before approving (MHS-359).
 */
export const analyzeImport = <ThrowOnError extends boolean = false>(options: Options<AnalyzeImportData, ThrowOnError>): RequestResult<AnalyzeImportResponses, AnalyzeImportErrors, ThrowOnError> => (options.client ?? client).post<AnalyzeImportResponses, AnalyzeImportErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zAnalyzeImportResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/skills/import/analyze',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete Skill
 *
 * Soft delete a skill.
 *
 * Requires admin. System skills cannot be deleted; extension skills only by
 * platform admins.
 */
export const deleteSkill = <ThrowOnError extends boolean = false>(options: Options<DeleteSkillData, ThrowOnError>): RequestResult<DeleteSkillResponses, DeleteSkillErrors, ThrowOnError> => (options.client ?? client).delete<DeleteSkillResponses, DeleteSkillErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteSkillResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/skills/{skill_uuid}',
    ...options
});

/**
 * Get Skill
 *
 * Get a skill by UUID.
 */
export const getSkill = <ThrowOnError extends boolean = false>(options: Options<GetSkillData, ThrowOnError>): RequestResult<GetSkillResponses, GetSkillErrors, ThrowOnError> => (options.client ?? client).get<GetSkillResponses, GetSkillErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetSkillResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/skills/{skill_uuid}',
    ...options
});

/**
 * Update Skill
 *
 * Update a skill.
 *
 * Requires editor. System skills cannot be modified; extension skills only
 * by platform admins.
 */
export const updateSkill = <ThrowOnError extends boolean = false>(options: Options<UpdateSkillData, ThrowOnError>): RequestResult<UpdateSkillResponses, UpdateSkillErrors, ThrowOnError> => (options.client ?? client).put<UpdateSkillResponses, UpdateSkillErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateSkillResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/skills/{skill_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Skill Delete Impact
 *
 * What deleting this skill would affect: imported sibling agents + how many
 * agents it's attached to (MHS-359).
 */
export const skillDeleteImpact = <ThrowOnError extends boolean = false>(options: Options<SkillDeleteImpactData, ThrowOnError>): RequestResult<SkillDeleteImpactResponses, SkillDeleteImpactErrors, ThrowOnError> => (options.client ?? client).get<SkillDeleteImpactResponses, SkillDeleteImpactErrors, ThrowOnError>({
    responseValidator: async (data) => await zSkillDeleteImpactResponse2.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/skills/{skill_uuid}/delete-impact',
    ...options
});

/**
 * Get Skill Members
 *
 * List who has access to a skill (viewer+).
 */
export const getSkillMembers = <ThrowOnError extends boolean = false>(options: Options<GetSkillMembersData, ThrowOnError>): RequestResult<GetSkillMembersResponses, GetSkillMembersErrors, ThrowOnError> => (options.client ?? client).get<GetSkillMembersResponses, GetSkillMembersErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetSkillMembersResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/skills/{skill_uuid}/members',
    ...options
});

/**
 * Add Skill Team Member
 *
 * Grant a team a role on a skill (admin only).
 */
export const addSkillTeamMember = <ThrowOnError extends boolean = false>(options: Options<AddSkillTeamMemberData, ThrowOnError>): RequestResult<AddSkillTeamMemberResponses, AddSkillTeamMemberErrors, ThrowOnError> => (options.client ?? client).post<AddSkillTeamMemberResponses, AddSkillTeamMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zAddSkillTeamMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/skills/{skill_uuid}/members/teams',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Skill Team Member
 *
 * Remove a team member (admin only; never the last admin).
 */
export const removeSkillTeamMember = <ThrowOnError extends boolean = false>(options: Options<RemoveSkillTeamMemberData, ThrowOnError>): RequestResult<RemoveSkillTeamMemberResponses, RemoveSkillTeamMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveSkillTeamMemberResponses, RemoveSkillTeamMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zRemoveSkillTeamMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/skills/{skill_uuid}/members/teams/{team_uuid}',
    ...options
});

/**
 * Update Skill Team Member
 *
 * Change a team member's role (admin only).
 */
export const updateSkillTeamMember = <ThrowOnError extends boolean = false>(options: Options<UpdateSkillTeamMemberData, ThrowOnError>): RequestResult<UpdateSkillTeamMemberResponses, UpdateSkillTeamMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateSkillTeamMemberResponses, UpdateSkillTeamMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateSkillTeamMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/skills/{skill_uuid}/members/teams/{team_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add Skill User Member
 *
 * Grant a user a role on a skill (admin only).
 */
export const addSkillUserMember = <ThrowOnError extends boolean = false>(options: Options<AddSkillUserMemberData, ThrowOnError>): RequestResult<AddSkillUserMemberResponses, AddSkillUserMemberErrors, ThrowOnError> => (options.client ?? client).post<AddSkillUserMemberResponses, AddSkillUserMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zAddSkillUserMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/skills/{skill_uuid}/members/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Skill User Member
 *
 * Remove a user member (admin only; never the last admin).
 */
export const removeSkillUserMember = <ThrowOnError extends boolean = false>(options: Options<RemoveSkillUserMemberData, ThrowOnError>): RequestResult<RemoveSkillUserMemberResponses, RemoveSkillUserMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveSkillUserMemberResponses, RemoveSkillUserMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zRemoveSkillUserMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/skills/{skill_uuid}/members/users/{user_uuid}',
    ...options
});

/**
 * Update Skill User Member
 *
 * Change a user member's role (admin only).
 */
export const updateSkillUserMember = <ThrowOnError extends boolean = false>(options: Options<UpdateSkillUserMemberData, ThrowOnError>): RequestResult<UpdateSkillUserMemberResponses, UpdateSkillUserMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateSkillUserMemberResponses, UpdateSkillUserMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateSkillUserMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/skills/{skill_uuid}/members/users/{user_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Spaces
 *
 * List spaces the caller can access (active by default; archived on request).
 */
export const listSpaces = <ThrowOnError extends boolean = false>(options?: Options<ListSpacesData, ThrowOnError>): RequestResult<ListSpacesResponses, ListSpacesErrors, ThrowOnError> => (options?.client ?? client).get<ListSpacesResponses, ListSpacesErrors, ThrowOnError>({
    responseValidator: async (data) => await zListSpacesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces',
    ...options
});

/**
 * Create Space
 *
 * Create a space. The creator becomes an admin member.
 */
export const createSpace = <ThrowOnError extends boolean = false>(options: Options<CreateSpaceData, ThrowOnError>): RequestResult<CreateSpaceResponses, CreateSpaceErrors, ThrowOnError> => (options.client ?? client).post<CreateSpaceResponses, CreateSpaceErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateSpaceResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Recent Activities
 *
 * Newest activity across every space the caller can view (Home and Spaces feeds).
 */
export const listRecentActivities = <ThrowOnError extends boolean = false>(options?: Options<ListRecentActivitiesData, ThrowOnError>): RequestResult<ListRecentActivitiesResponses, ListRecentActivitiesErrors, ThrowOnError> => (options?.client ?? client).get<ListRecentActivitiesResponses, ListRecentActivitiesErrors, ThrowOnError>({
    responseValidator: async (data) => await zListRecentActivitiesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/activities',
    ...options
});

/**
 * Get Personal Space
 *
 * Get-or-create the caller's personal space ("My Private Space").
 */
export const getPersonalSpace = <ThrowOnError extends boolean = false>(options?: Options<GetPersonalSpaceData, ThrowOnError>): RequestResult<GetPersonalSpaceResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPersonalSpaceResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zGetPersonalSpaceResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/personal',
    ...options
});

/**
 * List Pins
 *
 * List the caller's pinned spaces (sidebar order).
 */
export const listPins = <ThrowOnError extends boolean = false>(options?: Options<ListPinsData, ThrowOnError>): RequestResult<ListPinsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListPinsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zListPinsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/pins',
    ...options
});

/**
 * Add Pin
 *
 * Pin a space into the caller's sidebar. Requires view access to the space.
 */
export const addPin = <ThrowOnError extends boolean = false>(options: Options<AddPinData, ThrowOnError>): RequestResult<AddPinResponses, AddPinErrors, ThrowOnError> => (options.client ?? client).post<AddPinResponses, AddPinErrors, ThrowOnError>({
    responseValidator: async (data) => await zAddPinResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/pins',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reorder Pins
 *
 * Reorder the caller's pinned spaces.
 */
export const reorderPins = <ThrowOnError extends boolean = false>(options: Options<ReorderPinsData, ThrowOnError>): RequestResult<ReorderPinsResponses, ReorderPinsErrors, ThrowOnError> => (options.client ?? client).post<ReorderPinsResponses, ReorderPinsErrors, ThrowOnError>({
    responseValidator: async (data) => await zReorderPinsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/pins/reorder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Pin
 *
 * Unpin a space from the caller's sidebar.
 */
export const removePin = <ThrowOnError extends boolean = false>(options: Options<RemovePinData, ThrowOnError>): RequestResult<RemovePinResponses, RemovePinErrors, ThrowOnError> => (options.client ?? client).delete<RemovePinResponses, RemovePinErrors, ThrowOnError>({
    responseValidator: async (data) => await zRemovePinResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/pins/{space_uuid}',
    ...options
});

/**
 * Get Space Sidebar
 *
 * The caller's sidebar: General, then their sections, each with its spaces in display order.
 */
export const getSpaceSidebar = <ThrowOnError extends boolean = false>(options?: Options<GetSpaceSidebarData, ThrowOnError>): RequestResult<GetSpaceSidebarResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSpaceSidebarResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zGetSpaceSidebarResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/sidebar',
    ...options
});

/**
 * Create Sidebar Section
 *
 * Add a section at the end. Returns the whole sidebar.
 */
export const createSidebarSection = <ThrowOnError extends boolean = false>(options: Options<CreateSidebarSectionData, ThrowOnError>): RequestResult<CreateSidebarSectionResponses, CreateSidebarSectionErrors, ThrowOnError> => (options.client ?? client).post<CreateSidebarSectionResponses, CreateSidebarSectionErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateSidebarSectionResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/sidebar/sections',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reorder Sidebar Sections
 *
 * Put the caller's sections in this order (General stays first).
 */
export const reorderSidebarSections = <ThrowOnError extends boolean = false>(options: Options<ReorderSidebarSectionsData, ThrowOnError>): RequestResult<ReorderSidebarSectionsResponses, ReorderSidebarSectionsErrors, ThrowOnError> => (options.client ?? client).post<ReorderSidebarSectionsResponses, ReorderSidebarSectionsErrors, ThrowOnError>({
    responseValidator: async (data) => await zReorderSidebarSectionsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/sidebar/sections/reorder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Sidebar Section
 *
 * Delete a section (not General); its spaces move to General.
 */
export const deleteSidebarSection = <ThrowOnError extends boolean = false>(options: Options<DeleteSidebarSectionData, ThrowOnError>): RequestResult<DeleteSidebarSectionResponses, DeleteSidebarSectionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteSidebarSectionResponses, DeleteSidebarSectionErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteSidebarSectionResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/sidebar/sections/{section_uuid}',
    ...options
});

/**
 * Update Sidebar Section
 *
 * Rename (not General), change how it's sorted, or collapse/expand it.
 */
export const updateSidebarSection = <ThrowOnError extends boolean = false>(options: Options<UpdateSidebarSectionData, ThrowOnError>): RequestResult<UpdateSidebarSectionResponses, UpdateSidebarSectionErrors, ThrowOnError> => (options.client ?? client).patch<UpdateSidebarSectionResponses, UpdateSidebarSectionErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateSidebarSectionResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/sidebar/sections/{section_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Move Sidebar Space
 *
 * Move a space to a section (or General), optionally at a position in its custom order.
 */
export const moveSidebarSpace = <ThrowOnError extends boolean = false>(options: Options<MoveSidebarSpaceData, ThrowOnError>): RequestResult<MoveSidebarSpaceResponses, MoveSidebarSpaceErrors, ThrowOnError> => (options.client ?? client).put<MoveSidebarSpaceResponses, MoveSidebarSpaceErrors, ThrowOnError>({
    responseValidator: async (data) => await zMoveSidebarSpaceResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/sidebar/spaces/{space_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Space
 *
 * Soft-delete a space (admin). Personal spaces cannot be deleted.
 */
export const deleteSpace = <ThrowOnError extends boolean = false>(options: Options<DeleteSpaceData, ThrowOnError>): RequestResult<DeleteSpaceResponses, DeleteSpaceErrors, ThrowOnError> => (options.client ?? client).delete<DeleteSpaceResponses, DeleteSpaceErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteSpaceResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}',
    ...options
});

/**
 * Get Space
 *
 * Get a space (viewer+).
 */
export const getSpace = <ThrowOnError extends boolean = false>(options: Options<GetSpaceData, ThrowOnError>): RequestResult<GetSpaceResponses, GetSpaceErrors, ThrowOnError> => (options.client ?? client).get<GetSpaceResponses, GetSpaceErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetSpaceResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}',
    ...options
});

/**
 * Update Space
 *
 * Update space config (editor+).
 */
export const updateSpace = <ThrowOnError extends boolean = false>(options: Options<UpdateSpaceData, ThrowOnError>): RequestResult<UpdateSpaceResponses, UpdateSpaceErrors, ThrowOnError> => (options.client ?? client).put<UpdateSpaceResponses, UpdateSpaceErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateSpaceResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Space Activities
 *
 * List a space's activity feed (viewer+).
 */
export const listSpaceActivities = <ThrowOnError extends boolean = false>(options: Options<ListSpaceActivitiesData, ThrowOnError>): RequestResult<ListSpaceActivitiesResponses, ListSpaceActivitiesErrors, ThrowOnError> => (options.client ?? client).get<ListSpaceActivitiesResponses, ListSpaceActivitiesErrors, ThrowOnError>({
    responseValidator: async (data) => await zListSpaceActivitiesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/activities',
    ...options
});

/**
 * List Space Connectors
 *
 * The connectors in a space (viewer+). Members can use them while chatting in it.
 */
export const listSpaceConnectors = <ThrowOnError extends boolean = false>(options: Options<ListSpaceConnectorsData, ThrowOnError>): RequestResult<ListSpaceConnectorsResponses, ListSpaceConnectorsErrors, ThrowOnError> => (options.client ?? client).get<ListSpaceConnectorsResponses, ListSpaceConnectorsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListSpaceConnectorsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/connectors',
    ...options
});

/**
 * Add Space Connector
 *
 * Add a connector I can use to a space I edit.
 */
export const addSpaceConnector = <ThrowOnError extends boolean = false>(options: Options<AddSpaceConnectorData, ThrowOnError>): RequestResult<AddSpaceConnectorResponses, AddSpaceConnectorErrors, ThrowOnError> => (options.client ?? client).post<AddSpaceConnectorResponses, AddSpaceConnectorErrors, ThrowOnError>({
    responseValidator: async (data) => await zAddSpaceConnectorResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/connectors',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Space Connector
 *
 * Take a connector out of the space (editor+).
 */
export const removeSpaceConnector = <ThrowOnError extends boolean = false>(options: Options<RemoveSpaceConnectorData, ThrowOnError>): RequestResult<RemoveSpaceConnectorResponses, RemoveSpaceConnectorErrors, ThrowOnError> => (options.client ?? client).delete<RemoveSpaceConnectorResponses, RemoveSpaceConnectorErrors, ThrowOnError>({
    responseValidator: async (data) => await zRemoveSpaceConnectorResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/connectors/{binding_uuid}',
    ...options
});

/**
 * Update Space Connector
 *
 * Set this space's values for the connector's settings (editor+).
 */
export const updateSpaceConnector = <ThrowOnError extends boolean = false>(options: Options<UpdateSpaceConnectorData, ThrowOnError>): RequestResult<UpdateSpaceConnectorResponses, UpdateSpaceConnectorErrors, ThrowOnError> => (options.client ?? client).patch<UpdateSpaceConnectorResponses, UpdateSpaceConnectorErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateSpaceConnectorResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/connectors/{binding_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Space Connector Skills
 *
 * Replace the flavor skills (editor+, and I must be able to share each skill I attach).
 */
export const setSpaceConnectorSkills = <ThrowOnError extends boolean = false>(options: Options<SetSpaceConnectorSkillsData, ThrowOnError>): RequestResult<SetSpaceConnectorSkillsResponses, SetSpaceConnectorSkillsErrors, ThrowOnError> => (options.client ?? client).put<SetSpaceConnectorSkillsResponses, SetSpaceConnectorSkillsErrors, ThrowOnError>({
    responseValidator: async (data) => await zSetSpaceConnectorSkillsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/connectors/{binding_uuid}/skills',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Space Documents
 *
 * Documents shared with the space, newest first (viewer+).
 */
export const listSpaceDocuments = <ThrowOnError extends boolean = false>(options: Options<ListSpaceDocumentsData, ThrowOnError>): RequestResult<ListSpaceDocumentsResponses, ListSpaceDocumentsErrors, ThrowOnError> => (options.client ?? client).get<ListSpaceDocumentsResponses, ListSpaceDocumentsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListSpaceDocumentsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/documents',
    ...options
});

/**
 * Share Space Document
 *
 * Share one version of a document from my chat with the space, as a snapshot (editor+).
 */
export const shareSpaceDocument = <ThrowOnError extends boolean = false>(options: Options<ShareSpaceDocumentData, ThrowOnError>): RequestResult<ShareSpaceDocumentResponses, ShareSpaceDocumentErrors, ThrowOnError> => (options.client ?? client).post<ShareSpaceDocumentResponses, ShareSpaceDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zShareSpaceDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Space Document
 *
 * Unshare a document (the sharer or a space admin).
 */
export const removeSpaceDocument = <ThrowOnError extends boolean = false>(options: Options<RemoveSpaceDocumentData, ThrowOnError>): RequestResult<RemoveSpaceDocumentResponses, RemoveSpaceDocumentErrors, ThrowOnError> => (options.client ?? client).delete<RemoveSpaceDocumentResponses, RemoveSpaceDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zRemoveSpaceDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/documents/{document_uuid}',
    ...options
});

/**
 * Upload Space Files
 *
 * Upload files to the space's default knowledge base (editor+).
 *
 * Session-per-phase: validate with the request session, upload to blob with no
 * DB held, then persist records in a fresh short-lived session.
 */
export const uploadSpaceFiles = <ThrowOnError extends boolean = false>(options: Options<UploadSpaceFilesData, ThrowOnError>): RequestResult<UploadSpaceFilesResponses, UploadSpaceFilesErrors, ThrowOnError> => (options.client ?? client).post<UploadSpaceFilesResponses, UploadSpaceFilesErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zUploadSpaceFilesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/files',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete Space File
 *
 * Delete a file from the space's default knowledge base (editor+).
 */
export const deleteSpaceFile = <ThrowOnError extends boolean = false>(options: Options<DeleteSpaceFileData, ThrowOnError>): RequestResult<DeleteSpaceFileResponses, DeleteSpaceFileErrors, ThrowOnError> => (options.client ?? client).delete<DeleteSpaceFileResponses, DeleteSpaceFileErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteSpaceFileResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/files/{file_uuid}',
    ...options
});

/**
 * Get Space Hub
 *
 * Aggregated hub payload for the space's main page (viewer+).
 */
export const getSpaceHub = <ThrowOnError extends boolean = false>(options: Options<GetSpaceHubData, ThrowOnError>): RequestResult<GetSpaceHubResponses, GetSpaceHubErrors, ThrowOnError> => (options.client ?? client).get<GetSpaceHubResponses, GetSpaceHubErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetSpaceHubResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/hub',
    ...options
});

/**
 * List Space Knowledge
 *
 * List files in the space's default knowledge base (viewer+).
 */
export const listSpaceKnowledge = <ThrowOnError extends boolean = false>(options: Options<ListSpaceKnowledgeData, ThrowOnError>): RequestResult<ListSpaceKnowledgeResponses, ListSpaceKnowledgeErrors, ThrowOnError> => (options.client ?? client).get<ListSpaceKnowledgeResponses, ListSpaceKnowledgeErrors, ThrowOnError>({
    responseValidator: async (data) => await zListSpaceKnowledgeResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/knowledge',
    ...options
});

/**
 * Get Space Members
 *
 * List a space's user + team members and the caller's effective role.
 */
export const getSpaceMembers = <ThrowOnError extends boolean = false>(options: Options<GetSpaceMembersData, ThrowOnError>): RequestResult<GetSpaceMembersResponses, GetSpaceMembersErrors, ThrowOnError> => (options.client ?? client).get<GetSpaceMembersResponses, GetSpaceMembersErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetSpaceMembersResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/members',
    ...options
});

/**
 * Add Space Team Member
 *
 * Add (or update) a team's role on a space. Requires space admin.
 *
 * Granting a role to the special "Everyone" team makes the space available
 * org-wide at that role. Not allowed on personal spaces.
 */
export const addSpaceTeamMember = <ThrowOnError extends boolean = false>(options: Options<AddSpaceTeamMemberData, ThrowOnError>): RequestResult<AddSpaceTeamMemberResponses, AddSpaceTeamMemberErrors, ThrowOnError> => (options.client ?? client).post<AddSpaceTeamMemberResponses, AddSpaceTeamMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zAddSpaceTeamMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/members/teams',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Space Team Member
 *
 * Remove a team member. Requires space admin (cannot remove the last admin).
 */
export const removeSpaceTeamMember = <ThrowOnError extends boolean = false>(options: Options<RemoveSpaceTeamMemberData, ThrowOnError>): RequestResult<RemoveSpaceTeamMemberResponses, RemoveSpaceTeamMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveSpaceTeamMemberResponses, RemoveSpaceTeamMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zRemoveSpaceTeamMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/members/teams/{team_uuid}',
    ...options
});

/**
 * Update Space Team Member
 *
 * Change a team member's role. Requires space admin. 404 if not a member.
 */
export const updateSpaceTeamMember = <ThrowOnError extends boolean = false>(options: Options<UpdateSpaceTeamMemberData, ThrowOnError>): RequestResult<UpdateSpaceTeamMemberResponses, UpdateSpaceTeamMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateSpaceTeamMemberResponses, UpdateSpaceTeamMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateSpaceTeamMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/members/teams/{team_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add Space User Member
 *
 * Add (or update) a user's role on a space. Requires space admin.
 */
export const addSpaceUserMember = <ThrowOnError extends boolean = false>(options: Options<AddSpaceUserMemberData, ThrowOnError>): RequestResult<AddSpaceUserMemberResponses, AddSpaceUserMemberErrors, ThrowOnError> => (options.client ?? client).post<AddSpaceUserMemberResponses, AddSpaceUserMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zAddSpaceUserMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/members/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Space User Member
 *
 * Remove a user member. Requires space admin (cannot remove the last admin).
 */
export const removeSpaceUserMember = <ThrowOnError extends boolean = false>(options: Options<RemoveSpaceUserMemberData, ThrowOnError>): RequestResult<RemoveSpaceUserMemberResponses, RemoveSpaceUserMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveSpaceUserMemberResponses, RemoveSpaceUserMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zRemoveSpaceUserMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/members/users/{user_uuid}',
    ...options
});

/**
 * Update Space User Member
 *
 * Change a user member's role. Requires space admin.
 */
export const updateSpaceUserMember = <ThrowOnError extends boolean = false>(options: Options<UpdateSpaceUserMemberData, ThrowOnError>): RequestResult<UpdateSpaceUserMemberResponses, UpdateSpaceUserMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateSpaceUserMemberResponses, UpdateSpaceUserMemberErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateSpaceUserMemberResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/members/users/{user_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Quick Actions
 *
 * List a space's quick actions (viewer+).
 */
export const listQuickActions = <ThrowOnError extends boolean = false>(options: Options<ListQuickActionsData, ThrowOnError>): RequestResult<ListQuickActionsResponses, ListQuickActionsErrors, ThrowOnError> => (options.client ?? client).get<ListQuickActionsResponses, ListQuickActionsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListQuickActionsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/quick-actions',
    ...options
});

/**
 * Create Quick Action
 *
 * Create a quick action on a space (editor+).
 */
export const spacesCreateQuickAction = <ThrowOnError extends boolean = false>(options: Options<SpacesCreateQuickActionData, ThrowOnError>): RequestResult<SpacesCreateQuickActionResponses, SpacesCreateQuickActionErrors, ThrowOnError> => (options.client ?? client).post<SpacesCreateQuickActionResponses, SpacesCreateQuickActionErrors, ThrowOnError>({
    responseValidator: async (data) => await zSpacesCreateQuickActionResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/quick-actions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Quick Action
 *
 * Delete a quick action (editor+).
 */
export const spacesDeleteQuickAction = <ThrowOnError extends boolean = false>(options: Options<SpacesDeleteQuickActionData, ThrowOnError>): RequestResult<SpacesDeleteQuickActionResponses, SpacesDeleteQuickActionErrors, ThrowOnError> => (options.client ?? client).delete<SpacesDeleteQuickActionResponses, SpacesDeleteQuickActionErrors, ThrowOnError>({
    responseValidator: async (data) => await zSpacesDeleteQuickActionResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/quick-actions/{action_uuid}',
    ...options
});

/**
 * Update Quick Action
 *
 * Update a quick action (editor+).
 */
export const spacesUpdateQuickAction = <ThrowOnError extends boolean = false>(options: Options<SpacesUpdateQuickActionData, ThrowOnError>): RequestResult<SpacesUpdateQuickActionResponses, SpacesUpdateQuickActionErrors, ThrowOnError> => (options.client ?? client).put<SpacesUpdateQuickActionResponses, SpacesUpdateQuickActionErrors, ThrowOnError>({
    responseValidator: async (data) => await zSpacesUpdateQuickActionResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/quick-actions/{action_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Space Resources
 *
 * List a space's resources (optionally filtered to pinned / by type).
 */
export const listSpaceResources = <ThrowOnError extends boolean = false>(options: Options<ListSpaceResourcesData, ThrowOnError>): RequestResult<ListSpaceResourcesResponses, ListSpaceResourcesErrors, ThrowOnError> => (options.client ?? client).get<ListSpaceResourcesResponses, ListSpaceResourcesErrors, ThrowOnError>({
    responseValidator: async (data) => await zListSpaceResourcesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/resources',
    ...options
});

/**
 * Add Space Resource
 *
 * Attach a resource to a space (editor+).
 */
export const addSpaceResource = <ThrowOnError extends boolean = false>(options: Options<AddSpaceResourceData, ThrowOnError>): RequestResult<AddSpaceResourceResponses, AddSpaceResourceErrors, ThrowOnError> => (options.client ?? client).post<AddSpaceResourceResponses, AddSpaceResourceErrors, ThrowOnError>({
    responseValidator: async (data) => await zAddSpaceResourceResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/resources',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reorder Space Resources
 *
 * Bulk-reorder a space's resources (editor+).
 */
export const reorderSpaceResources = <ThrowOnError extends boolean = false>(options: Options<ReorderSpaceResourcesData, ThrowOnError>): RequestResult<ReorderSpaceResourcesResponses, ReorderSpaceResourcesErrors, ThrowOnError> => (options.client ?? client).post<ReorderSpaceResourcesResponses, ReorderSpaceResourcesErrors, ThrowOnError>({
    responseValidator: async (data) => await zReorderSpaceResourcesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/resources/reorder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Space Resource
 *
 * Remove a resource from a space (editor+).
 */
export const removeSpaceResource = <ThrowOnError extends boolean = false>(options: Options<RemoveSpaceResourceData, ThrowOnError>): RequestResult<RemoveSpaceResourceResponses, RemoveSpaceResourceErrors, ThrowOnError> => (options.client ?? client).delete<RemoveSpaceResourceResponses, RemoveSpaceResourceErrors, ThrowOnError>({
    responseValidator: async (data) => await zRemoveSpaceResourceResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/resources/{resource_uuid}',
    ...options
});

/**
 * Update Space Resource
 *
 * Update a resource's pin state / order (editor+).
 */
export const updateSpaceResource = <ThrowOnError extends boolean = false>(options: Options<UpdateSpaceResourceData, ThrowOnError>): RequestResult<UpdateSpaceResourceResponses, UpdateSpaceResourceErrors, ThrowOnError> => (options.client ?? client).patch<UpdateSpaceResourceResponses, UpdateSpaceResourceErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateSpaceResourceResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/resources/{resource_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Space Access
 *
 * Take the space's access away (target admins or a space admin). The item stays shared.
 */
export const removeSpaceAccess = <ThrowOnError extends boolean = false>(options: Options<RemoveSpaceAccessData, ThrowOnError>): RequestResult<RemoveSpaceAccessResponses, RemoveSpaceAccessErrors, ThrowOnError> => (options.client ?? client).delete<RemoveSpaceAccessResponses, RemoveSpaceAccessErrors, ThrowOnError>({
    responseValidator: async (data) => await zRemoveSpaceAccessResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/resources/{resource_uuid}/access',
    ...options
});

/**
 * Give Space Access
 *
 * Give every space member access to the item's agent, data source or app.
 *
 * Needs admin on the target and editor on the space. Shares the item too.
 */
export const giveSpaceAccess = <ThrowOnError extends boolean = false>(options: Options<GiveSpaceAccessData, ThrowOnError>): RequestResult<GiveSpaceAccessResponses, GiveSpaceAccessErrors, ThrowOnError> => (options.client ?? client).put<GiveSpaceAccessResponses, GiveSpaceAccessErrors, ThrowOnError>({
    responseValidator: async (data) => await zGiveSpaceAccessResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/resources/{resource_uuid}/access',
    ...options
});

/**
 * Space Access Impact
 *
 * Which members can't use the item's target without the space's access, and why (advisory, editor+).
 */
export const spaceAccessImpact = <ThrowOnError extends boolean = false>(options: Options<SpaceAccessImpactData, ThrowOnError>): RequestResult<SpaceAccessImpactResponses, SpaceAccessImpactErrors, ThrowOnError> => (options.client ?? client).get<SpaceAccessImpactResponses, SpaceAccessImpactErrors, ThrowOnError>({
    responseValidator: async (data) => await zSpaceAccessImpactResponse2.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/resources/{resource_uuid}/access-impact',
    ...options
});

/**
 * List Space Shared Chats
 *
 * Chats their owners shared with everyone in the space, newest first (viewer+).
 */
export const listSpaceSharedChats = <ThrowOnError extends boolean = false>(options: Options<ListSpaceSharedChatsData, ThrowOnError>): RequestResult<ListSpaceSharedChatsResponses, ListSpaceSharedChatsErrors, ThrowOnError> => (options.client ?? client).get<ListSpaceSharedChatsResponses, ListSpaceSharedChatsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListSpaceSharedChatsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_uuid}/shared-chats',
    ...options
});

/**
 * List Teams
 *
 * List teams the user belongs to.
 *
 * Platform admins see all teams.
 */
export const listTeams = <ThrowOnError extends boolean = false>(options?: Options<ListTeamsData, ThrowOnError>): RequestResult<ListTeamsResponses, ListTeamsErrors, ThrowOnError> => (options?.client ?? client).get<ListTeamsResponses, ListTeamsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListTeamsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/teams',
    ...options
});

/**
 * List Tools
 *
 * List tools accessible to the user.
 *
 * Returns platform-wide tools and tools from user's teams.
 */
export const listTools = <ThrowOnError extends boolean = false>(options?: Options<ListToolsData, ThrowOnError>): RequestResult<ListToolsResponses, ListToolsErrors, ThrowOnError> => (options?.client ?? client).get<ListToolsResponses, ListToolsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListToolsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tools',
    ...options
});

/**
 * Get Usage By User
 *
 * Get per-user spend breakdown (admin only).
 */
export const getUsageByUser = <ThrowOnError extends boolean = false>(options?: Options<GetUsageByUserData, ThrowOnError>): RequestResult<GetUsageByUserResponses, GetUsageByUserErrors, ThrowOnError> => (options?.client ?? client).get<GetUsageByUserResponses, GetUsageByUserErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetUsageByUserResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/usage/by-user',
    ...options
});

/**
 * Get My Spend
 *
 * Get the current user's AI spend for the current month and trend.
 */
export const getMySpend = <ThrowOnError extends boolean = false>(options?: Options<GetMySpendData, ThrowOnError>): RequestResult<GetMySpendResponses, GetMySpendErrors, ThrowOnError> => (options?.client ?? client).get<GetMySpendResponses, GetMySpendErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetMySpendResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/usage/my-spend',
    ...options
});

/**
 * Regenerate Webhook Secret
 *
 * Regenerate the HMAC secret for a webhook.  Returns the new secret (shown once).
 */
export const regenerateWebhookSecret = <ThrowOnError extends boolean = false>(options: Options<RegenerateWebhookSecretData, ThrowOnError>): RequestResult<RegenerateWebhookSecretResponses, RegenerateWebhookSecretErrors, ThrowOnError> => (options.client ?? client).post<RegenerateWebhookSecretResponses, RegenerateWebhookSecretErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegenerateWebhookSecretResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/webhooks/{webhook_uuid}/regenerate-secret',
    ...options
});
